<template>
  <div class="ProductDescription" v-html="description"></div>
</template>

<script>
export default {
  name: 'ProductDescription',
  props: ['description']
}
</script>

<style scoped lang="scss">
.ProductDescription {
  background: #fff;
  border-radius: 7px;
  padding: 2rem;
}






/** TOOLKIT.CSS **/
/**
 * @define Alert
 */

::v-deep .Alert {
  border: 1px solid #d73043;
  color: #d73043;
  padding: 0.694em;
}

/**
 * @define Button
 */

/**
 * Default Button styles
 *
 * 1. We set border even if it's transparent to avoid alignment issues when
 *    buttons are next to bordered elements (like inputs) or other buttons with
 *    visible outlines.
 * 2. Inherit base font styles from ancestor to overcome inconsistencies across
 *    various platforms.
 * 3. Certain input elements require this value, so we use the same here to
 *    promote alignment.
 * 4. Prevent button text from being selectable.
 */

::v-deep .Button {
  background: #2c2a29;
  border: 1px solid transparent;

  /* 1 */
  border-radius: 0.125em;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font: inherit;

  /* 2 */
  font-weight: 700;
  letter-spacing: 0.0625em;
  line-height: normal;

  /* 3 */
  margin: 0;
  padding: 0.579em 0.833em;
  text-align: center;
  text-transform: uppercase;
  -webkit-transition-duration: 0.2s;
  transition-duration: 0.2s;
  -webkit-transition-property: background-color, border-color, box-shadow, color, opacity, -webkit-filter;
  transition-property: background-color, border-color, box-shadow, color, opacity, -webkit-filter;
  transition-property: background-color, border-color, box-shadow, color, filter, opacity;
  transition-property: background-color, border-color, box-shadow, color, filter, opacity, -webkit-filter;
  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* 4 */

  outline: 0;

  /* 1 */
  text-decoration: none;

  /* 2 */

  &:hover, &:focus, &:active {
    outline: 0;

    /* 1 */
    text-decoration: none;

    /* 2 */
  }

  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  &:hover:not(:disabled):not(.is-disabled) {
    background-color: rgb(72, 68, 66);
  }

  &:focus:not(:active):not(:disabled):not(.is-disabled) {
    border-color: #2c2a29;
    box-shadow: inset 0 0 0 1px #fff;
  }

  &:active:not(:disabled):not(.is-disabled) {
    color: #ffffff;
    color: rgba(255, 255, 255, 0.6);
  }

  &:disabled, &.is-disabled {
    cursor: not-allowed;
    filter: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg"><filter id="filter"><feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0" /></filter></svg>#filter');
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    opacity: 0.6;
  }
}

/**
 * Some overrides need to be applied to both the base class and states because
 * specificity is a tricky thing.
 *
 * 1. Override default focus styles because we'll be adding our own.
 * 2. Override link defaults.
 */

/**
 * Remove excess padding and border in Firefox 4+
 */

/**
 * States
 *
 * We negate disabled selectors so effects won't be visible when a button isn't
 * actionable.
 */

/**
 * Modifiers
 */

/**
 * On dark backgrounds
 *
 * Inverts focus effect of typical Button so it will show up better on dark
 * backgrounds.
 */

::v-deep .Button--onDark:focus:not(:active):not(:disabled):not(.is-disabled) {
  border-color: #fff;
  box-shadow: inset 0 0 0 1px #2c2a29;
}

/**
 * Mixins to make color modifiers easier to make. Nesting syntax violates
 * guidelines, hence the temporary disable.
 */

/* stylelint-disable plugin/selector-bem-pattern */

/* stylelint-enable */

/**
 * Modifier: Success
 *
 * 1. Slightly increase lightness of green for contrast as background color.
 * 2. Use darker text color for contrast.
 */

::v-deep .Button--success {
  background-color: rgb(153, 204, 92);

  &:hover:not(:disabled):not(.is-disabled) {
    background-color: rgb(166, 210, 112);
  }

  &:active:not(:disabled):not(.is-disabled) {
    background-color: rgb(129, 186, 59);
    color: #2c2a29;
    color: rgba(44, 42, 41, 0.8);
  }

                 /*1
*/
  color: #2c2a29;

                /*2
*/
}

/**
 * Mimic typical color transition on press-down state, but inverted given
 * that this is a dark color instead of white
 */

/**
 * Modifier: Passion
 */

::v-deep .Button--passion {
  background-color: #d73043;

  &:hover:not(:disabled):not(.is-disabled) {
    background-color: rgb(220, 71, 88);
  }

  &:active:not(:disabled):not(.is-disabled) {
    background-color: rgb(180, 34, 51);
  }
}

/**
 * Modifier: Loyalty
 */

::v-deep .Button--loyalty {
  background-color: #6f6da8;

  &:hover:not(:disabled):not(.is-disabled) {
    background-color: rgb(126, 124, 177);
  }

  &:active:not(:disabled):not(.is-disabled) {
    background-color: rgb(86, 84, 140);
  }
}

/**
 * Modifier: Inverted
 *
 * 1. Use current color and transparent background to blend into surroundings.
 * 2. Make border visible.
 */

::v-deep .Button--inverted {
  background-color: transparent;
  color: inherit;

  &:hover:not(:disabled):not(.is-disabled), &:focus:not(:active):not(:disabled):not(.is-disabled), &:active:not(:disabled):not(.is-disabled) {
    background-color: transparent;
    color: inherit;
  }

  &:hover:not(:disabled):not(.is-disabled) {
    opacity: 0.85;
  }

  &:active:not(:disabled):not(.is-disabled) {
    opacity: 0.6;
  }

                  /*1
*/
  border-color: currentColor;

                            /*2
*/

  &:focus:not(:active):not(:disabled):not(.is-disabled) {
    box-shadow: inset 0 0 0 1px currentColor;
  }
}

/**
 * Make focus state visible by using same color for inset border
 */

/**
 * Modifier: Transparent
 */

::v-deep .Button--transparent {
  background-color: transparent;
  color: inherit;

  &:hover:not(:disabled):not(.is-disabled), &:focus:not(:active):not(:disabled):not(.is-disabled), &:active:not(:disabled):not(.is-disabled) {
    background-color: transparent;
    color: inherit;
  }

  &:hover:not(:disabled):not(.is-disabled) {
    opacity: 0.85;
  }

  &:active:not(:disabled):not(.is-disabled) {
    opacity: 0.6;
  }
}

/**
 * Modifier: Modest
 *
 * In addition to typical transparent styles, reset some aspects of font styles
 * so it appears more like surrounding text
 */

::v-deep .Button--modest {
  background-color: transparent;
  color: inherit;

  &:hover:not(:disabled):not(.is-disabled), &:focus:not(:active):not(:disabled):not(.is-disabled), &:active:not(:disabled):not(.is-disabled) {
    background-color: transparent;
    color: inherit;
  }

  &:hover:not(:disabled):not(.is-disabled) {
    opacity: 0.85;
  }

  &:active:not(:disabled):not(.is-disabled) {
    opacity: 0.6;
  }

  font-family: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
}

/**
 * @define DividerText
 */

::v-deep .DividerText {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;

  &:before, &:after {
    background-color: #eee;
    content: "";
    display: block;
    -webkit-box-flex: 1;
    flex: 1 0 0%;
    height: 1px;
  }

  &:before {
    margin-right: 1em;
    margin-right: 2ch;
  }

  &:after {
    margin-left: 1em;
    margin-left: 2ch;
  }
}

/**
 * @define FlexEmbed
 */

/** @define FlexEmbed */

/**
 * Flexible media embeds
 *
 * For use with media embeds – such as videos, slideshows, or even images –
 * that need to retain a specific aspect ratio but adapt to the width of their
 * containing element.
 *
 * Based on: http://alistapart.com/article/creating-intrinsic-ratios-for-video
 */

::v-deep .FlexEmbed {
  display: block;
  overflow: hidden;
  position: relative;
}

/**
 * The aspect-ratio hack is applied to an empty element because it allows
 * the component to respect `max-height`. Default aspect ratio is 1:1.
 */

::v-deep .FlexEmbed-ratio {
  display: block;
  padding-bottom: 100%;
  width: 100%;
}

/**
 * Modifier: 3:1 aspect ratio
 */

::v-deep .FlexEmbed-ratio--3by1 {
  padding-bottom: 33.33333%;
}

/**
 * Modifier: 2:1 aspect ratio
 */

::v-deep .FlexEmbed-ratio--2by1 {
  padding-bottom: 50%;
}

/**
 * Modifier: 16:9 aspect ratio
 */

::v-deep .FlexEmbed-ratio--16by9 {
  padding-bottom: 56.25%;
}

/**
 * Modifier: 4:3 aspect ratio
 */

::v-deep .FlexEmbed-ratio--4by3 {
  padding-bottom: 75%;
}

/**
 * Fit the content to the aspect ratio
 */

::v-deep .FlexEmbed-content {
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

/**
 * Modifier: 4:5 aspect ratio
 *
 * Ideal for product imagery and thumbnails.
 */

::v-deep .FlexEmbed-ratio--4by5 {
  padding-bottom: 125%;
}

/**
 * @define Folio
 */

::v-deep .Folio {
  -webkit-column-gap: 1.728em;
  column-gap: 1.728em;
}

/* stylelint-disable plugin/selector-bem-pattern */

/**
 * Avoid breaking to a new column in the middle of a child element.
 *
 * 1. Technique for most browsers.
 * 2. Fallback technique for Firefox.
 */

::v-deep .Folio--avoidBreaks > * {
  -webkit-column-break-inside: avoid;
  break-inside: avoid;

  /* 1 */
  page-break-inside: avoid;

  /* 2 */
}

/* stylelint-enable */

/**
 * @define Grid
 */

/** @define Grid */

/**
 * Core grid component
 *
 * DO NOT apply dimension or offset utilities to the `Grid` element. All cell
 * widths and offsets should be applied to child grid cells.
 */

/* Grid container
   ========================================================================== */

/**
 * All content must be contained within child `Grid-cell` elements.
 *
 * 1. Account for browser defaults of elements that might be the root node of
 *    the component.
 */

::v-deep .Grid {
  box-sizing: border-box;
  display: -webkit-box;
  display: flex;

  /* 1 */
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-flow: row wrap;
  margin: 0;

  /* 1 */
  padding: 0;

  /* 1 */
}

/**
 * Modifier: center align all grid cells
 */

::v-deep .Grid--alignCenter {
  -webkit-box-pack: center;
  justify-content: center;
}

/**
 * Modifier: right align all grid cells
 */

::v-deep .Grid--alignRight {
  -webkit-box-pack: end;
  justify-content: flex-end;
}

/**
 * Modifier: middle-align grid cells
 */

::v-deep .Grid--alignMiddle {
  -webkit-box-align: center;
  align-items: center;
}

/**
 * Modifier: bottom-align grid cells
 */

::v-deep .Grid--alignBottom {
  -webkit-box-align: end;
  align-items: flex-end;
}

/**
 * Modifier: allow cells to equal distribute width
 *
 * 1. Provide all values to avoid IE10 bug with shorthand flex
 *    http://git.io/vllC7
 *
 *    Use `0%` to avoid bug in IE10/11 with unitless flex basis
 *    http://git.io/vllWx
 */

::v-deep .Grid--fit > .Grid-cell {
  -webkit-box-flex: 1;
  flex: 1 1 0%;

  /* 1 */
}

/**
 * Modifier: all cells match height of tallest cell in a row
 */

::v-deep .Grid--equalHeight > .Grid-cell {
  display: -webkit-box;
  display: flex;
}

/**
 * Modifier: gutters
 */

::v-deep .Grid--withGutter {
  margin: 0 -11.52px;
  margin: 0 -0.72rem;

  > .Grid-cell {
    padding: 0 11.52px;
    padding: 0 0.72rem;
  }
}

/* Grid cell
   ========================================================================== */

/**
 * No explicit width by default. Rely on combining `Grid-cell` with a dimension
 * utility or a component class that extends 'Grid'.
 *
 * 1. Set flex items to full width by default
 * 2. Fix issue where elements with overflow extend past the
 *    `Grid-cell` container - https://git.io/vw5oF
 */

::v-deep .Grid-cell {
  box-sizing: inherit;
  flex-basis: 100%;

  /* 1 */
  min-width: 0;

  /* 2 */
}

/**
 * Modifier: horizontally center one unit
 * Set a specific unit to be horizontally centered. Doesn't affect
 * any other units. Can still contain a child `Grid` object.
 */

::v-deep .Grid-cell--center {
  margin: 0 auto;
}

/**
 * Modifier: gaps
 *
 * Works like Grid--withGutter, but with gaps all the way around adjacent cells
 * (not just left and right).
 */

::v-deep .Grid--withGap {
  margin: -11.52px;
  margin: -0.72rem;

  > .Grid-cell {
    padding: 11.52px;
    padding: 0.72rem;
  }
}

/**
 * @define Icon
 */

/**
 * 1. Flow inline with text while retaining layout.
 * 2. Most SVG elements default to `fill="black"`. This is a friendlier
 *    default which inherits parent element text color.
 * 3. Size based on parent element font size.
 * 4. Treat icons more like text, don't constrain their width.
 * 5. Default to no stroke. When stroke-width is defined within an icon it
 *    will override this, and the currentColor definition (2) won't result in
 *    strokes being inadvertently visible.
 * 6. Prevent icons from unexpected 'warping' if within a flex container
 */

::v-deep .Icon {
  display: inline-block;

  /* 1 */
  fill: currentColor;

  /* 2 */
  -webkit-box-flex: 0;
  flex: 0 0 auto;

  /* 6 */
  height: 1em;

  /* 3 */
  max-width: none;

  /* 4 */
  position: relative;
  stroke: currentColor;

  /* 2 */
  stroke-width: 0;

  /* 5 */
  width: 1em;

  /* 3 */

  &:not(.Icon--block) {
    top: -2px;
    top: -0.125rem;
    vertical-align: middle;
  }
}

/**
 * Unfortunately there's no great vertical-align property for aligning with
 * the x-height of adjacent text. The issue becomes less prominent the larger
 * the text and/or icon, so this applies a small adjustment using the root
 * font-size (which won't scale with text).
 */

/**
 * Modifier: Block
 *
 * Most of this is handled on the core .Icon class via the :not() selector
 * above, but we might as well change the display type as well for convenience.
 */

::v-deep .Icon--block {
  display: block;
}

/**
 * @define Input
 */

/**
 * 1. Reset default element appearance. Useful for overriding some rather
 *    opinionated styles in mobile browsers (inner shadows, etc.)
 * 2. Use block display and occupy full width to encourage large, tappable
 *    elements and alignment in form using some sort of grid.
 * 3. Normalize `line-height`. For `input`, it can't be changed from `normal` in
 *    Firefox 4+.
 * 4. Disable default focus styles (we'll apply our own later).
 * 5. In case this is used on an unexpected element (for example, a `<button>`),
 *    set a default text alignment.
 * 6. Transition non-geometric properties for visual delight.
 */

::v-deep .Input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* 1 */
  background: #fff;
  border: 1px solid #2c2a29;
  border-radius: 0.125em;
  color: #2c2a29;
  display: block;

  /* 2 */
  font: inherit;
  line-height: normal;

  /* 3 */
  outline: 0;

  /* 4 */
  padding: 0.402em 0.579em;
  text-align: left;

  /* 5 */
  -webkit-transition-duration: 0.1s;
  transition-duration: 0.1s;

  /* 6 */
  -webkit-transition-property: background-color, border-color, box-shadow, color;
  transition-property: background-color, border-color, box-shadow, color;

  /* 6 */
  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);

  /* 6 */
  width: 100%;

  /* 2 */

  &:not(textarea) {
    min-height: 2.488em;
  }

  &[type="text"], &[type="search"], &[type="email"], &[type="url"] {
    padding-left: 0;
    padding-right: 0;
    text-indent: 0.579em;
  }
}

/**
 * For everything but textarea, set a minimum height. In some browsers, input
 * elements with certain types (such as "date") do not render at predictable
 * heights unless this is present.
 */

/**
 * For certain single-line, text-based input types without any additional
 * controls, use text indentation instead of padding so long values will carry
 * all the way to the nearest border.
 */

/**
 * The following element-specific tweaks violate our BEM guidelines, but I don't
 * believe they are any different on principle from the previous type-specific
 * adjustments.
 */

/* stylelint-disable plugin/selector-bem-pattern */

/**
 * Change cursor style when applied to elements that don't allow text input.
 */

select.Input:not(:disabled), button.Input:not(:disabled), a.Input:not(:disabled) {
  cursor: pointer;
}

/**
 * 1. Custom caret (dropdown) icon.
 * 2. Position icon (1).
 * 3. The icon's natural dimensions are in line with other compact icons,
 *    but a little big for a select input.
 */

select.Input:not(:disabled) {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26' stroke='%232c2a29'%3E %3Cpolyline points='2,8 13,18 24,8' fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='4'/%3E %3C/svg%3E");

  /* 1 */
  background-position: right 0.579em center;

  /* 2 */
  background-repeat: no-repeat;
  background-size: 0.833em;

  /* 3 */
  padding-right: 2.158em;
}

/**
 * Restrict resizing of textarea to the y-axis to prevent breaking of layout
 * containers for this element.
 */

::v-deep textarea.Input {
  resize: vertical;
}

/* stylelint-enable */

/**
 * States
 */

/**
 * 1. On focus, transition to a thicker border by changing the outline color.
 * 2. In some browsers, we need to repeat the outline override in this state
 *    in case the class is applied to a less common element (like a `<button>`).
 */

::v-deep .Input {
  &:focus {
    box-shadow: inset 0 0 0 1px #2c2a29;

    /* 1 */
    outline: 0;

    /* 2 */
  }

  &:disabled, &[readonly] {
    background-color: #eee;
  }

  &:disabled, &[readonly]:not(:hover):not(:focus) {
    border-color: #63666a;
    color: rgb(128, 130, 133);
  }

  &:disabled {
    cursor: not-allowed;
  }

  &::-webkit-input-placeholder, &:-ms-input-placeholder, &::-ms-input-placeholder, &::placeholder {
    color: rgb(128, 130, 133);
  }

  &::-ms-expand {
    display: none;
  }

  &[type="number"] {
    -moz-appearance: textfield;

    &::-webkit-inner-spin-button, &::-webkit-outer-spin-button {
      -webkit-appearance: none;
      appearance: none;
      margin: 0;
    }
  }
}

/**
 * Give non-editable inputs a more muted appearance.
 */

/**
 * Reinforce the disabled state with an appropriate cursor.
 */

/**
 * Make placeholder text more visually distinct from an editable text value.
 */

/**
 * Hide any expansion indicators in IE/Edge.
 */

/**
 * Hide spinner controls in numeric inputs
 *
 * Disabling stylelint because the use of a vendor prefix is necessary to
 * maintain desired appearance across browsers. Specifically, no spinners in
 * Firefox, and no inner shadows in iOS Safari.
 */

/* stylelint-disable property-no-vendor-prefix */

/* stylelint-enable */

/**
 * Modifier: Compact
 */

::v-deep .Input--compact {
  padding-bottom: 0.335em;
  padding-top: 0.335em;

  &:not(textarea) {
    min-height: 1.728em;
  }
}

/**
 * Modifier: Modest
 */

::v-deep .Input--modest:not(:focus):not(:disabled):not([readonly]) {
  border-color: #eee;
}

/**
 * Modifier: Credit Card
 */

/**
 * 1. Default icon.
 * 2. Because we need the card height to account for padding and we need to
 *    make sure the card width is consistent with the right padding of the
 *    input, we enforce the size and aspect ratio a bit more aggressively than
 *    we normally would.
 */

::v-deep .Input--creditCard {
  background-image: url("/cms/icons/c4/payment/generic.svg");

  /* 1 */
  background-position: right 0.579em center;
  background-repeat: no-repeat;
  background-size: 2.0748em 1.33em;

  /* 2 */

  padding-right: 3.2328em;

  &[type="text"], &[type="search"], &[type="email"], &[type="url"] {
    padding-right: 3.2328em;
  }

  &[data-credit-card-type="american-express"] {
    background-image: url("/cms/icons/c4/payment/amex.svg");
  }

  &[data-credit-card-type="discover"] {
    background-image: url("/cms/icons/c4/payment/discover.svg");
  }

  &[data-credit-card-type="master-card"] {
    background-image: url("/cms/icons/c4/payment/mastercard.svg");
  }

  &[data-credit-card-type="visa"] {
    background-image: url("/cms/icons/c4/payment/visa.svg");
  }
}

/**
 * Make sure there's enough padding for the image so the input value doesn't
 * overlap the card image. We do this in a separate selector to make sure we
 * override all right padding values (CSS specificity is a bear).
 */

/**
 * Supported credit card values
 *
 * Please match the format of possible `type` values of the `credit-card-type`
 * module when adding more. This will make the pattern easy to integrate with
 * client-side validation.
 *
 * @see https://github.com/braintree/credit-card-type#api
 */

/**
 * Modifier: Dark backgrounds
 *
 * Allows light input BG to show through, which makes it stand out better on
 * darker backgrounds.
 */

::v-deep .Input--onDark {
  border-color: transparent;

  &:disabled {
    border-color: transparent;
  }

  &[readonly] {
    border-color: transparent;

    &:not(:hover):not(:focus) {
      border-color: transparent;
    }
  }
}

/**
 * Validation states
 *
 * Only applying a style to the :invalid pseudoclass as all non-required inputs
 * qualify as :valid.
 *
 * We negate the `ng-pristine` class from some selectors to improve the initial
 * visual state in Angular applications.
 *
 * @see https://getbootstrap.com/docs/4.0/components/forms/#how-it-works
 */

::v-deep .Input {
  &:invalid:not(.ng-pristine), &.is-invalid {
    border-color: #d73043;
  }

  &:invalid:focus:not(.ng-pristine), &.is-invalid:focus {
    box-shadow: inset 0 0 0 1px #d73043;
  }

  &.is-valid {
    border-color: #8ec549;

    &:focus {
      box-shadow: inset 0 0 0 1px #8ec549;
    }
  }
}

/**
 * @define InputDecoration
 */

/**
 * Allow label and/or controls to position themselves relative to the containing
 * element, visually overlaying the input.
 */

::v-deep .InputDecoration {
  position: relative;
}

/**
 * The input should occupy the full element width so sizing is managed on the
 * container. This simplifies layout adjustments by focusing them on just the
 * parent.
 */

::v-deep .InputDecoration-input {
  display: block;
  width: 100%;
}

/**
 * When there is a left control present, add padding to avoid the text flowing
 * underneath and disable any conflicting text-indent.
 */

::v-deep .InputDecoration--withLeftControl .InputDecoration-input,
  ::v-deep .u .InputDecoration--withSideControls .InputDecoration-input {
  padding-left: 2.488em;
  text-indent: 0;
}

/**
 * For right-hand controls, only the padding adjustment is needed.
 */

::v-deep .InputDecoration--withRightControl .InputDecoration-input,
  ::v-deep .u .InputDecoration--withSideControls .InputDecoration-input {
  padding-right: 2.488em;
}

/**
 * When both controls are present, change the default text alignment of the
 * input to balance the value between both.
 */

::v-deep .InputDecoration--withLeftControl.InputDecoration--withRightControl .InputDecoration-input,
  ::v-deep .u .InputDecoration--withSideControls .InputDecoration-input {
  text-align: center;
}

/**
 * Labels mimic placeholder text in appearance. This is more accessible than
 * using a placeholder as a label.
 *
 * 1. Occupy full height and center visually.
 * 2. Apply an invisible border. This makes the layout of the label more
 *    consistent with the input element.
 * 3. We want this to behave similarly to placeholders. For some browsers, the
 *    best way to do this is to mimic the cursor style and count on accurate
 *    `for` attributes being set. For others, `pointer-events` disables the
 *    label acting as a mouse/touch target in and of itself.
 * 4. Push away from left to mimic input text-indent or padding.
 * 5. Same as Input.
 * 6. Prevent from exceeding the element width.
 */

::v-deep .InputDecoration-label {
  -webkit-box-align: center;
  align-items: center;

  /* 1 */
  border: 1px solid transparent;

  /* 2 */
  color: rgb(128, 130, 133);
  cursor: text;

  /* 3 */
  display: -webkit-box;
  display: flex;

  /* 1 */
  height: 100%;

  /* 1 */
  left: 0.579em;

  /* 4 */
  line-height: normal;

  /* 5 */
  max-width: 100%;

  /* 6 */
  overflow: hidden;

  /* 6 */
  pointer-events: none;

  /* 3 */
  position: absolute;
  top: 0;
}

/**
 * Unless we've used JavaScript to verify that the input is indeed empty, we
 * don't want to show the label. But we want to retain its availability to
 * assistive technology like screen readers, so we hide it using the same
 * method as the `u-hiddenVisually` utility class.
 *
 * @see https://github.com/suitcss/utils-display
 */

::v-deep .InputDecoration:not(.is-empty) .InputDecoration-label {
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  height: 1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
}

/**
 * Iconographic controls.
 *
 * 1. Center icon visually within the element.
 * 2. Reset some possible default element styles.
 * 3. Controls should have a more interactive pointer style.
 * 4. Don't allow text selection because it looks funky.
 */

::v-deep .InputDecoration-control {
  -webkit-box-align: center;
  align-items: center;

  /* 1 */
  background: transparent;

  /* 2 */
  border: 1px solid transparent;
  border-radius: 0.125em;
  color: #2c2a29;
  cursor: pointer;

  /* 3 */
  display: -webkit-box;
  display: flex;

  /* 1 */
  font: inherit;

  /* 2 */
  height: 100%;
  -webkit-box-pack: center;
  justify-content: center;

  /* 1 */
  line-height: normal;

  /* 2 */
  margin: 0;

  /* 2 */
  padding: 0;

  /* 2 */
  position: absolute;
  right: 0;
  top: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* 4 */
  width: 2.488em;

  &:focus {
    border-color: currentColor;
    box-shadow: inset 0 0 0 1px currentColor;
    outline: 0;
  }
}

/**
 * On focus, mimic the outline style of Input elements instead of default
 * button focus rings.
 */

/**
 * When dark BG modifier is applied, mimic the focus style of `Input--onDark`
 */

::v-deep .InputDecoration--onDark .InputDecoration-control:focus {
  border-color: transparent;
}

/**
 * When disabled, change the cursor style and mimic an `Input` element's
 * disabled text color.
 */

::v-deep .InputDecoration-control {
  &:disabled, &.is-disabled {
    color: rgb(128, 130, 133);
    cursor: not-allowed;
  }
}

/**
 * Modifier: Left-aligned control
 */

::v-deep .InputDecoration-control--left {
  left: 0;
  right: auto;
}

/**
 * @define InputGroup
 */

/**
 * Arrange all child elements into a single row. Also stretches those elements
 * vertically by default, which makes them look even more "joined."
 */

::v-deep .InputGroup {
  display: -webkit-box;
  display: flex;

  /* 1 */
}

/**
 * 1. Allows us to manage these elements' z-index later, which will be helpful
 *    for interaction states.
 * 2. Have everything start at its natural width. This establishes a common
 *    starting point, we'll ask certain elements to stretch later.
 */

::v-deep .InputGroup-input,
  ::v-deep .u .InputGroup-control {
  position: relative;
  width: auto;
}

/**
 * Some elements may have focus states, and because they overlap slightly they
 * may look strange unless we make sure the element with focus is on top of its
 * sibling elements.
 */

::v-deep .InputGroup-input:focus,
  ::v-deep .u .InputGroup-control:focus {
  z-index: 1;
}

/**
 * 1. If this item isn't the first, remove its left rounded corners (if any) to
 *    make it continue seamlessly into whatever element precedes it.
 * 2. Overlap this element as well so any vertical borders don't "double up" in
 *    a way that will draw the eye compared to the outer border.
 */

::v-deep .InputGroup-input:not(:first-child),
  ::v-deep .u .InputGroup-control:not(:first-child) {
  border-bottom-left-radius: 0;

  /* 1 */
  border-top-left-radius: 0;

  /* 1 */
  margin-left: -1px;

  /* 2 */
}

/**
 * Omit right rounded corners from all but the last element, again to avoid
 * unsightly double borders.
 */

::v-deep .InputGroup-input:not(:last-child),
  ::v-deep .u .InputGroup-control:not(:last-child) {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

/**
 * 1. Elements allowing text input should grow to fill empty space, giving the
 *    user as much room as possible to type.
 * 2. But because these are the "stretchiest" elements, we also need them to
 *    shrink. We can't do that unless there's no min-width, which some browsers
 *    set by default.
 */

::v-deep .InputGroup-input {
  -webkit-box-flex: 1;
  flex: 1 1 100%;

  /* 1 */
  min-width: 0;

  /* 2 */
}

/**
 * Controls do not stretch, but retain their natural size.
 */

::v-deep .InputGroup-control {
  -webkit-box-flex: 0;
  flex: 0 0 auto;
}

/**
 * @define Label
 */

/**
 * Label
 *
 * 1. Allows labels to exist inline with other content.
 */

::v-deep .Label {
  background-color: #d73043;
  border-radius: 0.1875em;
  color: #fff;
  display: inline-block;

  /* 1 */
  font-size: 0.694em;
  font-weight: 500;
  letter-spacing: 0.05556em;
  padding: 0.335em 0.694em;
}

/**
 * @define StarRating
 */

::v-deep .StarRating,
  ::v-deep .u .StarRating-fill {
  background-position: left;
  background-repeat: no-repeat;
  background-size: auto 100%;
}

::v-deep .StarRating {
  background-image: url("/cms/icons/c4/stars/stars.svg");
  display: inline-block;
  height: 1em;
  position: relative;
  width: 5em;
}

::v-deep .StarRating-fill {
  background-image: url("/cms/icons/c4/stars/stars-fill.svg");
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

/**
 * @define Swatch
 */

/**
 * 1. Flow inline with other content by default so this will behave predictably
 *    in new contexts.
 * 2. Prevent from overflowing container. This makes it a bit easier to use in
 *    flexible elements.
 * 3. Allow child elements to position themselves absolutely relative to this
 *    container.
 * 4. Align with other inline elements along the middle, which makes it more
 *    likely that any inset text will align well.
 * 5. Establish a default width, ideally in relative units (em) so its size can
 *    controlled via `font-size`.
 */

::v-deep .Swatch {
  display: inline-block;

  /* 1 */
  max-width: 100%;

  /* 2 */
  position: relative;

  /* 3 */
  vertical-align: middle;

  /* 4 */
  width: 2.986em;

  /* 5 */

  &:before {
    content: "";
    display: block;
    padding-bottom: 100%;
    width: 100%;
  }
}

/**
 * We style this pseudo element to maintain a square aspect ratio regardless of
 * size, similar to the technique used by the SUIT CSS `FlexEmbed` component.
 *
 * @see http://alistapart.com/article/creating-intrinsic-ratios-for-video
 * @see https://github.com/suitcss/components-flex-embed
 */

/**
 * The `<input>` element that controls the state of its neighbors. We hide this
 * in a way that doesn't disable keyboard focus.
 *
 * 1. Certain browsers will cause this to impact layout on state change unless
 *    we specify a absolute position _and_ set a vertical position (since the
 *    padding adjustment is vertical). We also set it on the opposite axis just
 *    to be safe.
 * 2. Make invisible.
 * 3. Don't overlap adjacent elements.
 */

::v-deep .Swatch-state {
  left: 0;

  /* 1 */
  opacity: 0;

  /* 2 */
  position: absolute;

  /* 1 */
  top: 0;

  /* 1 */
  z-index: -1;

  /* 3 */
}

/**
 * The actual visual indicator.
 *
 * 1. Center-align content therein on both axes.
 * 2. Fill the container.
 * 3. Prevent text from wrapping, which doesn't work well visually with the
 *    enforced square aspect ratio.
 */

::v-deep .Swatch-indicator {
  -webkit-box-align: center;
  align-items: center;

  /* 1 */
  background-color: #fff;
  border: 1px solid #bbb;
  border-radius: 0.1875em;
  color: #2c2a29;
  cursor: pointer;
  display: -webkit-box;
  display: flex;

  /* 1 */
  height: 100%;

  /* 2 */
  -webkit-box-pack: center;
  justify-content: center;

  /* 1 */
  left: 0;

  /* 2 */
  line-height: 1.2;
  overflow: hidden;
  position: absolute;

  /* 2 */
  top: 0;

  /* 2 */
  -webkit-transition-duration: 0.1s;
  transition-duration: 0.1s;
  -webkit-transition-property: background-color, border-color, box-shadow;
  transition-property: background-color, border-color, box-shadow;
  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  white-space: nowrap;

  /* 3 */
  width: 100%;

  /* 2 */
}

/**
 * State: Hover/Focus
 *
 * 1. We use `box-shadow` to visually enlarge the border so it won't impact
 *    layout and will also be easier to differentiate from "checked" state for
 *    keyboard users.
 */

::v-deep .Swatch {
  &:hover .Swatch-indicator, &:focus .Swatch-indicator {
    border-color: #2c2a29;
    box-shadow: 0 0 0 1px #2c2a29;

    /* 1 */
  }
}

::v-deep .Swatch-state:focus ~ .Swatch-indicator {
  border-color: #2c2a29;
  box-shadow: 0 0 0 1px #2c2a29;

  /* 1 */
}

/**
 * State: Checked
 */

::v-deep .Swatch.is-checked .Swatch-indicator,
  ::v-deep .u .Swatch-state:checked ~ .Swatch-indicator {
  background-color: #2c2a29;
  border-color: #2c2a29;
  color: #fff;
}

/**
 * When the swatch contains an object, make its container circular in shape...
 */

::v-deep .Swatch--withObject {
  .Swatch-indicator {
    border-radius: 50%;
  }

  &.is-checked .Swatch-indicator,
  ::v-deep .u .Swatch-state:checked ~ .Swatch-indicator {
    background-color: #fff;
  }

  &.is-checked .Swatch-indicator:before,
  ::v-deep .u .Swatch-state:checked ~ .Swatch-indicator:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26' stroke='%23fff'%3E %3Cpolyline points='2,13 9,20 24,5' stroke-width='4' fill='none'/%3E %3C/svg%3E"), -webkit-radial-gradient(rgba(44, 42, 41, 0.3), rgba(44, 42, 41, 0) 66.66667%);
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26' stroke='%23fff'%3E %3Cpolyline points='2,13 9,20 24,5' stroke-width='4' fill='none'/%3E %3C/svg%3E"), radial-gradient(rgba(44, 42, 41, 0.3), rgba(44, 42, 41, 0) 66.66667%);

    /* 1 */
    background-position: center;
    background-repeat: no-repeat;
    background-size: 1.44em, cover;

    /* 2 */
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}

/**
 * ...don't reset the background color when checked...
 */

/**
 * ...and display a check icon when checked. We do this via a pseudo element
 * so it will show on top of any visual object therein.
 *
 * 1. Show the checkmark icon with a shadow underneath to visually offset it
 *    from content below.
 * 2. Cap the size of the icon but allow the shadow to cover everything below.
 */

/**
 * State: Disabled
 */

::v-deep .Swatch.is-disabled .Swatch-indicator,
  ::v-deep .u .Swatch-state:disabled ~ .Swatch-indicator {
  border-color: #eee;
  box-shadow: none;
  color: #ccc;
  cursor: not-allowed;
}

/**
 * Show a diagonal slash (\) over content when disabled.
 *
 * 1. Longer than 100% because otherwise it won't reach opposite corners when
 *    rotated.
 */

::v-deep .Swatch.is-disabled .Swatch-indicator:after,
  ::v-deep .u .Swatch-state:disabled ~ .Swatch-indicator:after {
  background-color: #bbb;
  box-shadow: 0 0 1em rgba(44, 42, 41, 0.3);
  content: "";
  height: 2px;
  left: 50%;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(-50%, -50%) rotate(45deg);
  transform: translate(-50%, -50%) rotate(45deg);
  -webkit-transform-origin: center;
  transform-origin: center;
  width: 150%;

  /* 1 */
}

/**
 * Visual objects as content.
 *
 * 1. Stretch to fill container.
 * 2. Where supported, avoid distorting the image.
 */

::v-deep .Swatch-object {
  align-self: stretch;

  /* 1 */
  border: 2px solid transparent;
  border-radius: inherit;
  -o-object-fit: cover;
  object-fit: cover;

  /* 2 */
  width: 100%;

  /* 1 */
}

/**
 * @define SwatchList
 */

/**
 * Default behavior is a simple wrapping flex container.
 *
 * 1. Arrange items in a horizontal row.
 * 2. Allow items to wrap to new lines.
 * 3. Override default list appearance.
 * 4. Apply half of gap to allow elements to have even whitespace all the way
 *    around, with the inverse applied to the outside margin to promote
 *    alignment with the parent element.
 */

::v-deep .SwatchList {
  display: -webkit-box;
  display: flex;

  /* 1, 2 */
  flex-wrap: wrap;

  /* 2 */
  list-style: none;

  /* 3 */
  margin: -0.347em;

  /* 4 */
  padding: 0.347em;

  /* 4 */
  position: relative;

  /* 4 */
}

/**
 * When grid is displayed, we change our technique.
 *
 * 1. Apply the gap and override our previous complicated way of accomplishing
 *    this spacing.
 * 2. Allow items to extend from a minimum size to available space, breaking
 *    onto new lines only when necessary.
 */

@supports (display: grid) {
  .SwatchList {
    display: grid;
    grid-gap: 0.694em;

    /* 1 */
    grid-template-columns: repeat(auto-fill, minmax(2.986em, 1fr));

    /* 2 */
    margin: 0;

    /* 1 */
    padding: 0;

    /* 1 */
  }
}

/**
 * Apply half-gaps to child elements so they will have even spacing all the way
 * around.
 */

::v-deep .SwatchList-item {
  margin: 0.347em;
}

/**
 * Undo these half-gaps in supported browsers, as `grid-gap` takes care of this
 * for us. 🎉
 */

@supports (display: grid) {
  .SwatchList-item {
    margin: 0;
  }
}

/**
 * In supported browsers, allow swatches to occupy the full width of the
 * container since we are controlling its size from the containing element.
 */

@supports (display: grid) {
  .SwatchList-swatch {
    width: 100%;
  }
}

/**
 * @define Table
 */

/**
 * Note: This class disables our selector rules more often than most. This is
 * because tables are particularly markup-heavy, so for usability of this class
 * the intent is to simplify its application and encourage semantic markup.
 */

/**
 * Tables aren't very responsive, but this at least makes them fill their
 * container as consistently as they can.
 */

::v-deep .Table {
  max-width: 100%;
  width: 100%;

  th, td {
    padding: 0.347em 0.6em;

    /* 1 */
    vertical-align: top;
  }

  thead th {
    vertical-align: bottom;
  }

  &:not(.Table--striped) {
    th:first-child, td:first-child {
      padding-left: 0;
    }

    th:last-child, td:last-child {
      padding-right: 0;
    }
  }

  tr {
    &:first-child {
      th, td {
        padding-top: 0.694em;
      }
    }

    &:last-child {
      th, td {
        padding-bottom: 0.694em;
      }
    }
  }

  &:not(.Table--ruled):not(.Table--striped) > {
    thead:first-child > tr:first-child th, tbody:first-child > tr:first-child th, tfoot:first-child > tr:first-child th, thead:first-child > tr:first-child td, tbody:first-child > tr:first-child td, tfoot:first-child > tr:first-child td {
      padding-top: 0;
    }

    tr:first-child {
      th, td {
        padding-top: 0;
      }
    }

    thead:last-child > tr:last-child th, tbody:last-child > tr:last-child th, tfoot:last-child > tr:last-child th, thead:last-child > tr:last-child td, tbody:last-child > tr:last-child td, tfoot:last-child > tr:last-child td {
      padding-bottom: 0;
    }

    tr:last-child {
      th, td {
        padding-bottom: 0;
      }
    }
  }

  thead + thead, tbody + thead, tfoot + thead, thead + tbody, tbody + tbody, tfoot + tbody, thead + tfoot, tbody + tfoot, tfoot + tfoot {
    border-top: 1px solid #2c2a29;
  }
}

/**
 * Default cell styles
 *
 * 1. Our goal is for the cell contents to reach the edges of the table, so we
 *    apply half of the padding so it will add up to the intended number when
 *    the cells come together.
 */

/* stylelint-disable plugin/selector-bem-pattern */

/* stylelint-enable */

/**
 * First and last cells should have their far edge padding omitted so they touch
 * the container edges.
 *
 * If the table is striped so that row edges are more apparent, we do not make
 * this change.
 */

/**
 * The first and last rows should have extra padding so there's a visually even
 * amount of padding between sets of rows and row content.
 */

/* stylelint-disable plugin/selector-bem-pattern */

/* stylelint-enable */

/**
 * If a row is the first or last in the entire table, we omit its vertical
 * padding so its content reaches the edges of the table.
 */

/* stylelint-disable plugin/selector-bem-pattern */

/* stylelint-enable */

/**
 * Add dividers between adjacent sets
 */

/**
 * Style Modifiers
 */

/**
 * Ruled and striped tables both expose vertical edges of cells, so they must
 * have full vertical padding.
 */

::v-deep .Table--ruled {
  th, td {
    padding-bottom: 0.694em;
    padding-top: 0.694em;
  }
}

::v-deep .Table--striped {
  th, td {
    padding-bottom: 0.694em;
    padding-top: 0.694em;
  }
}

/**
 * Ruled cells in the table body should have dividing borders.
 *
 * We apply this to the top and bottom edges in case the table does not have
 * a head or foot.
 */

/* stylelint-disable plugin/selector-bem-pattern */

::v-deep .Table--ruled {
  > {
    tbody {
      th, td {
        border-bottom: 1px solid #2c2a29;
      }
    }

    tr {
      th, td {
        border-bottom: 1px solid #2c2a29;
      }
    }
  }

  thead + thead, tbody + thead, tfoot + thead, thead + tbody, tbody + tbody, tfoot + tbody, thead + tfoot, tbody + tfoot, tfoot + tfoot {
    border-top-width: 2px;
  }
}

/* stylelint-enable */

/**
 * To differentiate table sets from one another when rules are present, we
 * increase the size of the borders.
 */

/**
 * Striped cell backgrounds should alternate in color, but only in the body.
 */

/* stylelint-disable plugin/selector-bem-pattern */

::v-deep .Table--striped > {
  tbody tr:nth-child(even), tr:nth-child(even) {
    background: #eee;
  }
}

/* stylelint-enable */

/**
 * @define Theme
 */

/**
 * 1. Default styles reinforce document defaults.
 * 2. Allow child elements to position themselves relative to this container.
 */

::v-deep .Theme {
  background-color: #fff;

  /* 1 */
  color: #2c2a29;

  /* 1 */
  position: relative;

  /* 2 */

  :link:not([class]), :visited:not([class]) {
    color: #009ca6;
    text-decoration: none;
  }
}

/**
 * Only links without a `class` attribute should be styled. This minimizes
 * specificity conflicts with other classes.
 */

/**
 * Dark theme
 */

::v-deep .Theme--dark {
  background-color: #2c2a29;
  color: #fff;

  :link:not([class]), :visited:not([class]) {
    color: inherit;
    text-decoration: underline;
  }
}

/**
 * LEO theme
 */

::v-deep .Theme--leo {
  :link:not([class]), :visited:not([class]) {
    color: #2c2a29;
    text-decoration: underline;
  }

  :link:hover, :visited:hover {
    color: #009ca6;
  }
}

/**
 * Optional "beauty mark" to visually offset
 */

::v-deep .Theme--withBeautyMark:after {
  background: #d73043;
  content: "";
  height: 5.36px;
  height: 0.335rem;
  left: 50%;
  position: absolute;
  top: 0;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 23.04px;
  width: 1.44rem;
}

/**
 * @define Thumbnail
 */

/**
 * Thumbnail
 *
 * 1. Sets a styled border for all product thumbnails.
 * 2. Defines relative position which is required to allow labels to overlay
 *    thumbnail images.
 * 3. Transition the border color property if it changes, for example if a
 *    thumbnail enters or exits a current/selected state or the interactive
 *    modifier is applied.
 */

::v-deep .Thumbnail {
  border: 1px solid #eee;

  /* 1 */
  box-shadow: 0 1px 2px rgba(44, 42, 41, 0.06);

  /* 1 */
  position: relative;

  /* 2 */
  -webkit-transition-duration: 0.1s;
  transition-duration: 0.1s;

  /* 3 */
  -webkit-transition-property: border-color;
  transition-property: border-color;

  /* 3 */
  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);

  /* 3 */

  &.is-current, &[aria-expanded="true"] {
    border-color: #2c2a29;
  }

  &.is-current:after, &[aria-expanded="true"]:after {
    border: 2px solid #eee;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }

  &.is-loading:not(.is-zoomed):before {
    -webkit-animation: spin 0.6s linear infinite;
    animation: spin 0.6s linear infinite;

    /* 1 */
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26' stroke='%232c2a29'%3E %3Cpath d='M13,2A11,11,0,1,0,24,13' fill='none' stroke-width='3'/%3E %3C/svg%3E");

    /* 2 */
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    bottom: 0;

    /* 3 */
    content: "";

    /* 4 */
    height: 27.648px;
    height: 1.728rem;
    left: 0;

    /* 3 */
    margin: auto;

    /* 3 */
    position: absolute;

    /* 3 */
    right: 0;

    /* 3 */
    top: 0;

    /* 3 */
    -webkit-transform-origin: center;
    transform-origin: center;

    /* 1 */
    width: 27.648px;
    width: 1.728rem;
    z-index: 1;

    /* 5 */
  }
}

/**
 * State: Current/Selected/Expanded
 */

/**
 * For this state, we use a pseudo element to apply an inset border. This
 * technique insures that there will be no impact on the computed box of the
 * image (or a change to its aspect ratio), with no visible "shifts" in the
 * image relative to its container.
 */

/**
 * State: Loading
 *
 * Animates a "spinner" pseudo element. Not shown if also zooming.
 *
 * 1. Spin infinitely.
 * 2. Inject spinner into CSS so we don't introduce another asset load before
 *    communicating that assets are loading.
 * 3. Center within the thumbnail.
 * 4. Hack for forcing pseudo element visibility.
 * 5. Show on top of other elements within the parent.
 */

/**
 * Modifier: Interactive
 *
 * Adds interaction and selection states.
 */

::v-deep .Thumbnail--interactive {
  cursor: pointer;

  &:hover, &:focus {
    border-color: #2c2a29;
  }
}

/**
 * 1. Occupy all available space for thumbnail.
 * 2. Animate any opacity changes.
 */

::v-deep .Thumbnail-object {
  display: block;

  /* 1 */
  height: auto;

  /* 1 */
  -webkit-transition-duration: 0.1s;
  transition-duration: 0.1s;

  /* 2 */
  -webkit-transition-property: opacity;
  transition-property: opacity;

  /* 2 */
  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);

  /* 2 */
  width: 100%;

  /* 1 */
}

/**
 * When loading, lower the opacity of the current object. Only occurs when there
 * is no zoom.
 */

::v-deep .Thumbnail.is-loading:not(.is-zoomed) .Thumbnail-object {
  opacity: 0.2;
}

/**
 * Overlap bottom-left
 *
 * 1. Absolute positioning an element inside its container.
 * 2. Sets z-index to ensure label is above thumbnail image.
 */

::v-deep .Thumbnail-label {
  bottom: 1.2em;

  /* 1 */
  left: -0.579em;

  /* 1 */
  position: absolute;

  /* 1 */
  z-index: 1;

  /* 2 */
}

/**
 * @define Toggle
 */

/**
 * Containing element, typically a `<label>` to insure click and focus
 * interactions are maintained accurately.
 *
 * 1. Arrange child elements in a row but without occupying the full container
 *    width. This prevents accidental toggle clicks if the user clicks to the
 *    right of the label text.
 * 2. Allow elements within to position themselves absolutely. This makes the
 *    way we'll hide the actual `<input>` a bit less fragile.
 */

::v-deep .Toggle {
  display: -webkit-inline-box;
  display: inline-flex;

  /* 1 */
  position: relative;

  /* 2 */
}

/**
 * The `<input>` element that controls the state of its neighbors. We hide this
 * in a way that doesn't disable keyboard focus.
 *
 * 1. Make invisible.
 * 2. Don't change the layout of surrounding elements.
 * 3. Don't overlap adjacent elements.
 */

::v-deep .Toggle-state {
  opacity: 0;

  /* 1 */
  position: absolute;

  /* 2 */
  z-index: -1;

  /* 3 */
}

/**
 * The visible toggle element, what the user sees as the actual checkbox or
 * radio control.
 *
 * 1. Keep this element at its inherent size.
 * 2. We size this element based on its `font-size`, which allows the size to
 *    be easily customized using utilities later without having to override
 *    both width and height.
 * 3. We'll be using absolute positioning for the checked state, so this helps
 *    constrain that.
 */

::v-deep .Toggle-indicator {
  background-color: #fff;
  border: 1px solid #2c2a29;
  cursor: pointer;
  -webkit-box-flex: 0;
  flex: 0 0 auto;

  /* 1 */
  font-size: 1.2em;

  /* 2 */
  height: 1em;

  /* 2 */
  position: relative;

  /* 3 */
  -webkit-transition-duration: 0.1s;
  transition-duration: 0.1s;
  -webkit-transition-property: background-color, border-color, box-shadow;
  transition-property: background-color, border-color, box-shadow;
  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  width: 1em;

  /* 2 */
}

/**
 * States
 */

/**
 * Focus state
 *
 * Mimics an outline effect with box-shadow so `border-radius` is respected.
 * (Fun fact: This wouldn't be necessary if Mozilla's `outline-radius` were
 * adopted as a standard!)
 */

::v-deep .Toggle-state {
  &:focus ~ .Toggle-indicator {
    box-shadow: 0 0 0 1px #2c2a29;
    outline: 0;
  }

  &:disabled ~ .Toggle-indicator {
    background-color: #eee;
    border-color: #63666a;
    cursor: not-allowed;
  }
}

/**
 * Disabled state
 */

/**
 * Indicator "fills," for when checkboxes or radios are checked
 *
 * 1. Position background (if any) so that it is contained (not cropped),
 *    centered and not repeating on either axis.
 * 2. Position relative to indicator edges, with padding (if any).
 * 3. Animate in from these starting points.
 */

::v-deep .Toggle-indicator:before {
  background-position: center;

  /* 1 */
  background-repeat: no-repeat;

  /* 1 */
  background-size: contain;

  /* 1 */
  border-radius: inherit;
  bottom: 3px;

  /* 2 */
  content: "";
  left: 3px;

  /* 2 */
  opacity: 0;

  /* 3 */
  position: absolute;

  /* 2 */
  right: 3px;

  /* 2 */
  top: 3px;

  /* 2 */
  -webkit-transform: scale(0);
  transform: scale(0);

  /* 3 */
  -webkit-transform-origin: center;
  transform-origin: center;

  /* 3 */
  -webkit-transition-duration: 0.1s;
  transition-duration: 0.1s;
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: opacity, transform;
  transition-property: opacity, transform, -webkit-transform;
  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
}

/**
 * Visible and full size when checked
 */

::v-deep .Toggle-state {
  &:checked ~ .Toggle-indicator:before {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  &[type="checkbox"] {
    &:checked {
      ~ .Toggle-indicator {
        background-color: #2c2a29;
      }

      &:disabled ~ .Toggle-indicator {
        background-color: #63666a;
      }
    }

    ~ .Toggle-indicator:before {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26' stroke='%23fff'%3E %3Cpolyline points='2,13 9,20 24,5' stroke-width='4' fill='none'/%3E %3C/svg%3E");
    }
  }

  &[type="radio"] {
    ~ .Toggle-indicator {
      border-radius: 50%;

      &:before {
        background-color: #2c2a29;
      }
    }

    &:disabled ~ .Toggle-indicator:before {
      background-color: #63666a;
    }
  }
}

/**
 * Checkbox indicator
 */

/**
 * Radio indicator
 */

/**
 * Adjacent label text
 */

::v-deep .Toggle-text {
  cursor: pointer;
  -webkit-transition-duration: 0.1s;
  transition-duration: 0.1s;
  -webkit-transition-property: opacity;
  transition-property: opacity;
  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
}

::v-deep .Toggle-state {
  ~ .Toggle-text {
    margin-left: 0.402em;
  }

  &:disabled ~ .Toggle-text {
    cursor: not-allowed;
    opacity: 0.75;
  }

  &:invalid ~ .Toggle-indicator, &.is-invalid ~ .Toggle-indicator {
    border-color: #d73043;
  }

  &:focus:invalid ~ .Toggle-indicator, &.is-invalid:focus ~ .Toggle-indicator {
    box-shadow: 0 0 0 1px #d73043;
  }

  &[type="checkbox"] {
    &:checked:invalid ~ .Toggle-indicator, &.is-invalid:checked ~ .Toggle-indicator {
      background-color: #d73043;
    }
  }

  &[type="radio"] {
    &:invalid ~ .Toggle-indicator:before, &.is-invalid ~ .Toggle-indicator:before {
      background-color: #d73043;
    }
  }

  &.is-valid {
    ~ .Toggle-indicator {
      border-color: #8ec549;
    }

    &:focus ~ .Toggle-indicator {
      box-shadow: 0 0 0 1px #8ec549;
    }
  }

  &[type="checkbox"].is-valid:checked ~ .Toggle-indicator {
    background-color: #8ec549;
  }
}

/**
 * Validation states
 *
 * Only applying a style to the :invalid pseudoclass as all non-required inputs
 * qualify as :valid.
 *
 * @see: https://getbootstrap.com/docs/4.0/components/forms/#how-it-works
 */

/**
 * @define Badge
 */

/**
 * Ensure that the parent element will allow the count to be positioned without
 * affecting its layout.
 */

::v-deep .Badge {
  position: relative;
}

/**
 * The actual visible badge.
 *
 * 1. We clear any line-height, instead using vertical padding for vertical
 *    alignment. This technique is strange but was more consistent across
 *    different browsers for very small elements.
 * 2. We add a very small amount of padding in case the count exceeds the
 *    default width. This keeps the text from touching the edges.
 * 3. Position in the top right corner of the parent element.
 * 4. Finalize position with `transform`. We do this so that large counts will
 *    naturally compensate for their size rather than overlapping too much of
 *    the parent element content.
 * 5. Avoid unexpected text selection when count is within an interactive
 *    element, for example a button or link.
 */

::v-deep .Badge-count {
  background-color: #3cdbc0;
  border-radius: 0.83334em;
  color: #2c2a29;
  font-size: 0.694em;
  font-weight: 700;
  height: 1.66667em;
  letter-spacing: -0.0625em;
  line-height: 0;

  /* 1 */
  min-width: 1.66667em;
  padding-left: 0.3125em;

  /* 2 */
  padding-right: 0.3125em;

  /* 2 */
  padding-top: 0.83334em;

  /* 1 */
  position: absolute;

  /* 3 */
  right: 0;

  /* 3 */
  text-align: center;
  top: 0;

  /* 3 */
  -webkit-transform: translate(33.33333%, -25%);
  transform: translate(33.33333%, -25%);

  /* 4 */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* 5 */
}

/**
 * @define Carousel
 */

/**
 * Carousel Image Properties
 *
 * It is very important that these are kept in sync with the dimensions of
 * carousel images!
 *
 * 1. Default aspect ratio of carousel images (1:1)
 * 2. Aspect ratio starting at the "medium" breakpoint (2:1)
 * 3. Aspect ratio starting at the "large" breakpoint (2.4:1)
 * 4. Maximum displayed width of carousel images
 */

:root {
  /* 1 */

  /* 2 */

  /* 3 */

  /* 4 */
}

/**
 * Carousel Image Breakpoints
 *
 * These should match the `media` attribute used in "medium" and "large"
 * `<source>` elements in each slide!
 */

/**
 * Misc. Appearance Properties
 */

/**
 * The track is where the carousel will actually occur. We set the background
 * here so there won't be visible "seams" as slides transition.
 */

::v-deep .Carousel-track {
  background: #fff;
}

/**
 * We use relative positioning on individual slides so we can position a spinner
 * within each one. This prevents loading indicators from covering slides that
 * have already loaded.
 */

::v-deep .Carousel-slide {
  position: relative;
}

/**
 * If the Carousel JavaScript has not been initialized and the slide is not
 * the first, we should hide it so the user doesn't have to scroll past a stack
 * of slides.
 */

::v-deep .Carousel:not(.is-initialized) .Carousel-slide:not(:first-child) {
  display: none;
}

/**
 * Loading Spinner
 *
 * Shown when slide is in a loading state.
 *
 * 1. Spin infinitely.
 * 2. Inject spinner into CSS so we don't introduce another asset load before
 *    communicating that assets are loading.
 * 3. Center within the thumbnail.
 * 4. Hack for forcing pseudo element visibility.
 */

::v-deep .Carousel-slide.is-loading:before {
  -webkit-animation: spin 0.6s linear infinite;
  animation: spin 0.6s linear infinite;

  /* 1 */
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='26' height='26' viewBox='0 0 26 26' stroke='%232c2a29'%3E %3Cpath d='M13,2A11,11,0,1,0,24,13' fill='none' stroke-width='3'/%3E %3C/svg%3E");

  /* 2 */
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  bottom: 0;

  /* 3 */
  content: "";

  /* 4 */
  height: 27.648px;
  height: 1.728rem;
  left: 0;

  /* 3 */
  margin: auto;

  /* 3 */
  position: absolute;

  /* 3 */
  right: 0;

  /* 3 */
  top: 0;

  /* 3 */
  -webkit-transform-origin: center;
  transform-origin: center;

  /* 1 */
  width: 27.648px;
  width: 1.728rem;
}

/**
 * Banner
 *
 * This is the containing rectangle of a slide. Aspect ratio is maintained
 * from here. Frequently a link so that it can lead to a destination.
 *
 * 1. Fill available width up to max-width (3).
 * 2. Center horizontally.
 * 3. Limit the width based on available image sizes.
 * 4. Allow elements to position themselves absolutely relative to this. We'll
 *    use this later to enforce aspect ratio.
 * 5. We set up a transition on opacity so slides fade in when they finish
 *    loading.
 */

::v-deep .Carousel-banner {
  display: block;

  /* 1 */
  margin: 0 auto;

  /* 2 */
  max-width: 1920px;

  /* 3 */
  position: relative;

  /* 4 */
  -webkit-transition: opacity 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: opacity 0.2s cubic-bezier(0.77, 0, 0.175, 1);

  /* 5 */
  width: 100%;

  /* 1 */
}

/**
 * Disable pointer events to avoid conflicts between swipe and click.
 *
 * @see https://github.com/pawelgrzybek/siema/issues/71
 */

/* stylelint-disable plugin/selector-bem-pattern */

::v-deep .Carousel.is-initialized a.Carousel-banner > * {
  pointer-events: none;
}

/* stylelint-enable */

/**
 * Fade out slides that are loading
 */

::v-deep .Carousel-slide.is-loading .Carousel-banner {
  opacity: 0;
}

/**
 * Enforce aspect ratios using the padding hack. We do not use Keith J. Grant's
 * technique because we want to enforce or cut off imagery that exceeds this
 * ratio.
 *
 * @see https://keithjgrant.com/posts/2017/03/aspect-ratios/
 */

::v-deep .Carousel-banner:before {
  content: "";
  display: block;
  padding-bottom: 100%;
}

@media (min-width: 480px) {
  .Carousel-banner:before {
    padding-bottom: 50%;
  }
}

@media (min-width: 960px) {
  .Carousel-banner:before {
    padding-bottom: 41.66667%;
  }
}

/**
 * The element that fills the banner. Usually an image or a container.
 *
 * 1. Position to occupy all of containing element.
 * 2. If this is an image, fill available area rather than distorting.
 *
 * @see https://caniuse.com/#feat=object-fit
 */

::v-deep .Carousel-bannerContent {
  height: 100%;

  /* 1 */
  left: 0;

  /* 1 */
  -o-object-fit: cover;
  object-fit: cover;

  /* 2 */
  position: absolute;

  /* 1 */
  top: 0;

  /* 1 */
  width: 100%;

  /* 1 */
}

/**
 * Navigation
 *
 * A containing element to help manage display and position of an optional
 * carousel navigation element below the track.
 *
 * Hidden until JS functionality is initialized. We avoid `display: none` so
 * its appearance won't cause a shift in layout.
 */

::v-deep .Carousel:not(.is-initialized) .Carousel-nav {
  visibility: hidden;
}

/**
 * @define CarouselControl
 */

/**
 * 1. Display pages in a centered horizontal row.
 * 2. Allow pages to wrap.
 * 3. Override list default styles.
 * 4. Provide space around the pages so they won't run up against adjacent
 *    content. We use half the gap space so they'll have the same space around
 *    as they do in between.
 */

::v-deep .CarouselControl {
  display: -webkit-box;
  display: flex;

  /* 1 */
  flex-wrap: wrap;

  /* 2 */
  -webkit-box-pack: center;
  justify-content: center;

  /* 1 */
  list-style: none;

  /* 3 */
  padding: 4.632px;
  padding: 0.2895rem;

  /* 3, 4 */
}

/**
 * The actual interactive elements, typically buttons.
 *
 * 1. Override browser defaults.
 * 2. Set an interactive cursor style to communicate hover state clearly.
 * 3. Apply half gaps as padding so buttons will be equal distances apart.
 */

::v-deep .CarouselControl-action {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* 1 */
  background: transparent;

  /* 1 */
  border: 0;

  /* 1 */
  color: inherit;

  /* 1 */
  cursor: pointer;

  /* 2 */
  display: block;

  /* 1 */
  margin: 0;

  /* 1 */
  opacity: 0.25;
  padding: 4.632px;
  padding: 0.2895rem;

  /* 1, 3 */
  -webkit-transition: opacity 0.1s cubic-bezier(0.77, 0, 0.175, 1);
  transition: opacity 0.1s cubic-bezier(0.77, 0, 0.175, 1);

  &.is-current, &[aria-expanded="true"] {
    opacity: 0.75;
  }

  &:hover {
    opacity: 1;
  }

  &:focus {
    opacity: 1;
    outline: 0;
  }
}

/**
 * Adjust opacity depending on state
 */

/**
 * Remove browser default focus style, which we'll replace on the label element
 */

/**
 * Most of the appearance happens on the label. We do this so the buttons will
 * have a larger hit area.
 *
 * 1. Use parent text color as a fill, allowing easy customization.
 * 2. Force consistent layout and display.
 * 3. Hide inner text visually but not from assistive devices.
 */

::v-deep .CarouselControl-label {
  background-color: currentColor;

  /* 1 */
  display: block;

  /* 2 */
  height: 7.712px;
  height: 0.482rem;

  /* 2 */
  overflow: hidden;

  /* 3 */
  text-indent: -999em;

  /* 3 */
  width: 57.328px;
  width: 3.583rem;

  /* 2 */
}

/**
 * On focus, add a small outline around the label to make it appear slightly
 * larger than before.
 */

::v-deep .CarouselControl-action:focus .CarouselControl-label {
  outline: 1px solid currentColor;
}

/**
 * @define Collapsible
 */

::v-deep .Collapsible.is-collapsed {
  display: none;
}

/**
 * @define GarmentIllustration
 */

/**
 * 1. Override default link colors.
 */

::v-deep .GarmentIllustration {
  color: inherit;

  /* 1 */
  display: block;
  padding-bottom: 0.694em;
  padding-top: 0.694em;
  text-align: center;

  &:focus {
    outline: 0;

    /* 1 */
  }
}

/* Focus styles */

/**
 * 1. Removes default :focus style since we are transforming scale
 *    and color on :--enter.
 */

/**
 * 1. Centers origin for desired animation effect.
 * 2. Defines transform transition properties.
 */

::v-deep .GarmentIllustration-item {
  -webkit-transform-origin: center;
  transform-origin: center;

  /* 1 */
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;

  /* 2 */
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;

  /* 2 */
  -webkit-transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
  transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);

  /* 2 */
}

/* Hover Styles */

/**
 * 1. Increases scale of GarmentIllustration on :hover and :focus.
 */

::v-deep .GarmentIllustration {
  &:hover .GarmentIllustration-item, &:focus .GarmentIllustration-item {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);

    /* 1 */
  }
}

/**
 * 1. Sets our desired color for the item backdrop.
 * 2. Defines our desired opacity for the item backdrop.
 * 3. Centers origin for desired animation effect.
 * 4. Defines transform transition properties.
 */

::v-deep .GarmentIllustration-backdrop {
  fill: #b4b5df;

  /* 1 */
  opacity: 0.25;

  /* 2 */
  -webkit-transform-origin: center;
  transform-origin: center;

  /* 3 */
  -webkit-transition: opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.4s cubic-bezier(0.77, 0, 0.175, 1);
  transition: opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.4s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.4s cubic-bezier(0.77, 0, 0.175, 1), opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.4s cubic-bezier(0.77, 0, 0.175, 1), opacity 0.6s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.4s cubic-bezier(0.77, 0, 0.175, 1);

  /* 4 */
}

/**
 * 1. Lowers opacity of GarmentIllustration-backdrop on :hover and :focus
 * 2. Decreases scale of GarmentIllustration-backdrop on :hover and :focus.
 */

::v-deep .GarmentIllustration {
  &:hover .GarmentIllustration-backdrop, &:focus .GarmentIllustration-backdrop {
    opacity: 0.6;

    /* 1 */
    -webkit-transform: scale(0.9);
    transform: scale(0.9);

    /* 2 */
  }

  &:active .GarmentIllustration-backdrop {
    opacity: 0.8;

    /* 1 */
    -webkit-transform: scale(0.85);
    transform: scale(0.85);

    /* 2 */
  }
}

/* Active Style */

/**
 * 1. Lowers color alpha of GarmentIllustration-backdrop on :hover and :focus
 * 2. Decreases scale of GarmentIllustration-backdrop on :hover and :focus.
 */

/**
 * Optional label element (below illustration)
 *
 * 1. Shift downward slightly so it won't appear as if the illustration has too
 *    much bottom whitespace with the label present.
 */

::v-deep .GarmentIllustration-label {
  display: block;
  font-size: inherit;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: -0.694em;

  /* 1 */
  position: relative;

  /* 1 */
}

/**
 * @define Masthead
 */

/**
 * 1. Arrange children in a non-wrapping row.
 * 2. Cap the element height. This is important for maintaining alignment with
 *    adjacent elements, such as submenus and side menus.
 * 3. If there are multiple elements, add space in-between so they fill the
 *    entire bar.
 * 4. Also works as a lazy clearfix (just in case).
 * 5. Allow child elements to position themselves relative to this.
 */

::v-deep .Masthead {
  display: -webkit-box;
  display: flex;

  /* 1 */
  height: 57.328px;
  height: 3.583rem;

  /* 2 */
  -webkit-box-pack: justify;
  justify-content: space-between;

  /* 3 */
  overflow: hidden;

  /* 2, 4 */
  position: relative;

  /* 5 */
}

/**
 * Dark Masthead
 */

::v-deep .Masthead--dark {
  background-color: #2c2a29;
  color: #fff;
}

/**
 * Centered logo. Intended for use on a link.
 *
 * 1. Center child elements. Easier than having to adjust the display type of
 *    images or elements therein to avoid line-height bumps.
 * 2. Fill container height.
 * 3. Center horizontally.
 * 4. Establish a min and max for width so the logo can flex responsively.
 */

::v-deep .Masthead-logo {
  -webkit-box-align: center;
  align-items: center;

  /* 1 */
  display: -webkit-box;
  display: flex;

  /* 1 */
  height: 100%;

  /* 2 */
  -webkit-box-pack: center;
  justify-content: center;

  /* 1 */
  left: 0;

  /* 3 */
  margin: auto;

  /* 3 */
  max-width: 25%;

  /* 4 */
  position: absolute;

  /* 2, 3 */
  right: 0;

  /* 3 */
  top: 0;

  /* 2 */
  width: 132px;
  width: 8.25rem;

  /* 4 */
}

/**
 * Limit the logo object height. We handle this on the inner element so as not
 * to reduce the logo's click area, and also to work around some strangeness
 * when centering overflowing imagery in a flex container.
 */

::v-deep .Masthead-logoObject {
  max-height: 55%;
}

/**
 * Container for groups of elements, actions or other content.
 *
 * 1. Arrange this content in a vertically-centered row.
 * 2. Override any list styles if this is a list.
 */

::v-deep .Masthead-group {
  -webkit-box-align: center;
  align-items: center;

  /* 1 */
  display: -webkit-box;
  display: flex;

  /* 1 */
  list-style: none;

  /* 2 */
  padding-left: 0;

  /* 2 */
}

/**
 * If a logo is present, cap the width of any groups so they won't collide.
 */

::v-deep .Masthead-logo {
  ~ .Masthead-group {
    max-width: 37.5%;
  }

  + .Masthead-group {
    -webkit-box-ordinal-group: 0;
    order: -1;
  }
}

/**
 * The first group following a logo should have its order shifted earlier. This
 * fixes an IE11 bug where the first group did not align with flex-start.
 */

/**
 * Actions, typically buttons or links.
 *
 * 1. Mimic alignment of the component so far. The goal is for these to look
 *    like they're floating naturally in the bar, while extending their hit area
 *    to the element edges.
 * 2. Inherit and/or reset default styles to blend in more seamlessly.
 * 3. We set the height again on this element to encourage semantic markup,
 *    which may be too densely nested to consistently carry height through
 *    child elements via `align-items: stretch` or similar.
 * 4. Maintain horizontal hit areas and keep elements from running together.
 * 5. Prevent awkward text selection styles on click/tap.
 */

::v-deep .Masthead-action {
  -webkit-box-align: center;
  align-items: center;

  /* 1 */
  background: transparent;

  /* 2 */
  color: inherit;

  /* 2 */
  cursor: pointer;
  display: -webkit-box;
  display: flex;

  /* 1 */
  font: inherit;

  /* 2 */
  height: 57.328px;
  height: 3.583rem;

  /* 3 */
  line-height: normal;

  /* 2 */
  padding: 0 16px;
  padding: 0 1rem;

  /* 4 */
  -webkit-transition: color 0.1s cubic-bezier(0.77, 0, 0.175, 1);
  transition: color 0.1s cubic-bezier(0.77, 0, 0.175, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* 5 */

  &:hover:not(:active):not(:focus) {
    color: #009ca6;
  }
}

/**
 * Change color on hover. This change felt too dramatic to also apply on focus,
 * where it would hang around on touch platforms.
 *
 * @todo Explore custom focus styles (if desired).
 */

/**
 * Modifies :hover color value for dark mastheads
 */

::v-deep .Masthead--dark .Masthead-action:hover:not(:active):not(:focus) {
  color: #009ca6;
}

/**
 * @define MenuBar
 */

/**
 * Containing element.
 *
 * 1. Arrange items in a horizontal, non-wrapping row.
 * 2. Reset appearance if this is a list.
 * 3. Apply half-gap padding so actions will have equal gaps between, and the
 *    inverse amount of margin so element will meet the edges of its container,
 *    which simplifies layout.
 * 4. Respect negative margins.
 */

::v-deep .MenuBar {
  display: -webkit-box;
  display: flex;

  /* 1 */
  list-style: none;

  /* 2 */
  margin-left: -19.2px;
  margin-left: -1.2rem;

  /* 3 */
  margin-right: -19.2px;
  margin-right: -1.2rem;

  /* 3 */
  padding-left: 9.6px;
  padding-left: 0.6rem;

  /* 2, 3 */
  padding-right: 9.6px;
  padding-right: 0.6rem;

  /* 3 */
  position: relative;

  /* 4 */
}

::v-deep .MenuBar--dark {
  background-color: #2c2a29;
}

/**
 * Modifier: Spread elements to occupy all available width.
 */

::v-deep .MenuBar--spread {
  -webkit-box-pack: justify;
  justify-content: space-between;
}

/**
 * Modifier: Fill or Tabs
 *
 * Either of these modifiers cause the action contents to be farther apart,
 * which removes the need to apply gaps in the same way. We remove the half-gap
 * steps for these cases to make them easier to style as blocks.
 */

::v-deep .MenuBar--fill,
  ::v-deep .u .MenuBar--tabs {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
}

/**
 * In order to cause all elements to fill regardless of the bar structure, we
 * need to momentarily violate our selector guidelines.
 *
 * 1. Provide all Flex values to avoid shorthand-related bugs in IE, Safari.
 *    We specify 0% to avoid IE bug with unitless flex basis.
 */

/* stylelint-disable plugin/selector-bem-pattern */

::v-deep .MenuBar--fill > * {
  -webkit-box-flex: 1;
  flex: 1 1 0%;

  /* 1 */
}

::v-deep .MenuBar--tabs {
  background-color: #eee;
}

/* stylelint-enable */

/**
 * Action elements, typically links.
 *
 * 1. Center-align contents on both axes.
 * 2. Inherit color. This makes it easier to modify the default color without
 *    impacting color changes on interaction states.
 * 3. Set some sensible defaults in case this is a button or other less
 *    predictable element.
 * 4. Apply half-gap padding, which completes even gaps between adjacent
 *    siblings.
 * 5. This menu is not intended to wrap or exceed its set height, so we disable
 *    wrapping on its content as well.
 */

::v-deep .MenuBar-action {
  -webkit-box-align: center;
  align-items: center;

  /* 1 */
  color: inherit;

  /* 2 */
  cursor: pointer;

  /* 3 */
  display: -webkit-box;
  display: flex;

  /* 1 */
  font: inherit;
  font-weight: 500;
  height: 47.776px;
  height: 2.986rem;
  -webkit-box-pack: center;
  justify-content: center;

  /* 1 */
  line-height: 1.2;
  padding-left: 9.6px;
  padding-left: 0.6rem;

  /* 4 */
  padding-right: 9.6px;
  padding-right: 0.6rem;

  /* 4 */
  text-transform: uppercase;
  -webkit-transition: color 0.1s cubic-bezier(0.77, 0, 0.175, 1);
  transition: color 0.1s cubic-bezier(0.77, 0, 0.175, 1);
  white-space: nowrap;

  /* 5 */
  width: 100%;

  /* 3 */
}

::v-deep .MenuBar--dark .MenuBar-action {
  color: #fff;
}

/**
 * State: Hover/focus/current/expanded
 */

::v-deep .MenuBar-action {
  &:hover, &:focus, &.is-current, &[aria-expanded="true"] {
    color: #009ca6;
  }
}

::v-deep .MenuBar--leo .MenuBar-action {
  &:hover, &:focus, &.is-current, &[aria-expanded="true"] {
    color: #009ca6;
  }
}

/**
 * Modifier: Fill or Tabs
 *
 * In either case, the tabs are encased in fuller blocks and no longer need to
 * apply half-padding. To maintain a fair distance away from the container edge,
 * we apply the full gap to them.
 */

::v-deep .MenuBar--fill .MenuBar-action {
  padding-left: 19.2px;
  padding-left: 1.2rem;
  padding-right: 19.2px;
  padding-right: 1.2rem;
}

::v-deep .MenuBar--tabs .MenuBar-action {
  padding-left: 19.2px;
  padding-left: 1.2rem;
  padding-right: 19.2px;
  padding-right: 1.2rem;
  font-weight: 400;
  text-transform: inherit;

  &.is-current, &[aria-expanded="true"] {
    background-color: #fff;
    color: inherit;
  }
}

/**
 * Optional inner element. Uses extra node to apply some more complex alternate
 * styles.
 *
 * 1. Apply invisible borders by default to both ends. This maintains even
 *    vertical positioning and minimizes subtle shifts on state change.
 * 2. Force element to enforce padding.
 * 3. Apply the same border width as padding to avoid the text running directly
 *    into it.
 */

::v-deep .MenuBar-actionText {
  border-color: transparent;

  /* 1 */
  border-style: solid;

  /* 1 */
  border-width: 3px 0;

  /* 1 */
  display: block;

  /* 2 */
  font-weight: 400;
  padding: 3px 0;

  /* 3 */
}

/**
 * 1. Current action text should have visible underline.
 * 2. Current action text should retain default color, except on hover/focus.
 */

::v-deep .MenuBar-action {
  &.is-current .MenuBar-actionText, &[aria-expanded="true"] .MenuBar-actionText {
    border-bottom-color: #009ca6;

    /* 1 */
    color: #2c2a29;

    /* 2 */
  }
}

::v-deep .MenuBar--leo .MenuBar-action {
  &.is-current .MenuBar-actionText, &[aria-expanded="true"] .MenuBar-actionText {
    border-bottom-color: #bbb;
  }
}

::v-deep .MenuBar--dark .MenuBar-action {
  &.is-current .MenuBar-actionText, &[aria-expanded="true"] .MenuBar-actionText {
    color: #fff;
  }
}

/**
 * @define MenuGrid
 */

/**
 * 1. By default, arrange the items in a flexible row with wrapping.
 * 2. Override default list styles.
 * 3. Negate gutter gaps with inverse margins, which gives even space between
 *    all cells while lining up with parent element edges.
 */

::v-deep .MenuGrid {
  display: -webkit-box;
  display: flex;

  /* 1 */
  flex-wrap: wrap;

  /* 1 */
  list-style: none;

  /* 2 */
  margin: -5.552px;
  margin: -0.347rem;

  /* 3 */
  padding-left: 0;

  /* 2 */
  position: relative;

  /* 3 */
}

/**
 * When grid is supported, use that for layout instead. This allows cells to
 * fill space more efficiently.
 */

@supports (display: grid) {
  .MenuGrid {
    display: grid;
    grid-gap: 0.694rem;
    grid-template-columns: repeat(auto-fill, minmax(6.375em, 1fr));
    margin: 0;
  }
}

/**
 * 1. Cause child items to stretch. This makes sure actions will match each
 *    others' height.
 * 2. Apply the other half of the gap here, which allows even spacing between
 *    items.
 * 3. When grid is disabled, we use this default size. While it would be cleaner
 *    to set this as a flex-basis (so we wouldn't need to override it), IE11
 *    would not calculate the width correctly (failing to factor in padding).
 */

::v-deep .MenuGrid-item {
  display: -webkit-box;
  display: flex;

  /* 1 */
  padding: 5.552px;
  padding: 0.347rem;

  /* 2 */
  width: 33.33333%;

  /* 3 */
}

/**
 * 1. Remove gap when grid is supported, since in that case it will be defined
 *    on the containing element.
 * 2. Remove the fallback width (since grid will take care of this for us).
 */

@supports (display: grid) {
  .MenuGrid-item {
    padding: 0;

    /* 1 */
    width: auto;

    /* 2 */
  }
}

/**
 * Actions
 *
 * 1. Flex positioning is ineffectual in Firefox, but required to get the
 *    content to fill a button consistently in Chrome.
 * 2. Prevent awkward text selection on clumsy mouse actions.
 * 3. Without this, elements with small labels will not fill their item.
 * 4. Allow inner content to fill 100% of the elements height.
 */

::v-deep .MenuGrid-action {
  background: #fff;
  border: 1px solid #bbb;
  border-radius: 0.125em;
  color: #2c2a29;
  cursor: pointer;
  display: block;
  font: inherit;
  font-weight: 500;
  height: 100%;

  /* 4 */
  line-height: 1;
  padding: 0;
  -webkit-transition-duration: 0.1s;
  transition-duration: 0.1s;
  -webkit-transition-property: background-color, border-color, box-shadow, opacity;
  transition-property: background-color, border-color, box-shadow, opacity;
  -webkit-transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  transition-timing-function: cubic-bezier(0.77, 0, 0.175, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* 2 */
  width: 100%;

  /* 3 */

  &:focus {
    outline: 0;
  }

  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  &[aria-expanded="true"], &.is-current {
    background-color: #2c2a29;
    border-color: #2c2a29;
    color: #fff;
  }

  &:disabled, &.is-disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:not(.is-disabled):not(:disabled) {
    &:hover {
      opacity: 0.85;
      border-color: #2c2a29;
      box-shadow: 0 0 0 1px #2c2a29;
    }

    &:focus {
      border-color: #2c2a29;
      box-shadow: 0 0 0 1px #2c2a29;
    }

    &:active {
      opacity: 0.6;
    }
  }
}

/**
 * Disable default focus style (we'll apply our own later)
 */

/**
 * Remove excess padding and border in Firefox 4+
 */

/**
 * State: Current/Expanded
 */

/**
 * State: Disabled
 */

/**
 * State: Hover/Focus/Active
 */

/**
 * Content container
 *
 * This is required because of a Firefox bug involving flex columns on
 * `<button>` elements. Without this, long labels would disrupt the consistent
 * position of objects in the grid.
 *
 * 1. Arrange children in a vertical stack, centered on both axes.
 * 2. Fill containing element (Chrome, IE).
 * 3. Fill containing element (Firefox).
 *
 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1397768
 */

::v-deep .MenuGrid-content {
  -webkit-box-align: center;
  align-items: center;

  /* 1 */
  display: -webkit-box;
  display: flex;

  /* 1 */
  -webkit-box-flex: 1;
  flex: 1 0 auto;

  /* 2 */
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;

  /* 1 */
  height: 100%;

  /* 3 */
  padding: 0.694em 0.335em;
  width: 100%;

  /* 3 */
}

/**
 * The visual object, ideally an `<svg>` or `<img>` element.
 *
 * 1. Cap height.
 * 2. Limit width to that of the container.
 * 3. Uncap width to a point (2). This allows non-square icons or imagery to
 *    be used, which can be helpful for wider objects (such as payment logos).
 */

::v-deep .MenuGrid-object {
  height: 2.488em;

  /* 1 */
  max-width: 100%;

  /* 2 */
  width: auto;

  /* 3 */

  &:not(:last-child) {
    margin-bottom: 0.402em;
  }
}

/**
 * If the object is followed by a label, put some space between. We do this here
 * because we need `margin-top` on the label.
 */

/**
 * Expand margins of label to fill available space. This will cause every label
 * to be centered vertically with every other in a row.
 */

::v-deep .MenuGrid-label {
  margin: auto;
  text-align: center;
}

/**
 * @define MenuList
 */

/**
 * Containing element
 *
 * 1. Reset default list styles as needed.
 */

::v-deep .MenuList {
  background-color: #fff;
  color: #2c2a29;
  list-style: none;

  /* 1 */
  padding-left: 0;

  /* 1 */
}

/**
 * Containing element - loyalty background.
 */

::v-deep .MenuList--loyalty {
  background-color: #e9d7e8;
}

/**
 * Adjacent list items should be separated by a divider.
 */

::v-deep .MenuList-item + .MenuList-item {
  border-top: 1px solid #eee;
}

/**
 * Header elements used for semantic purposes should have their typographic
 * styles reset to avoid disrupting the consistent look and feel of each action.
 */

::v-deep .MenuList-header {
  font: inherit;
}

/**
 * Actions, typically links or buttons
 *
 * 1. Align content vertically within container.
 * 2. Reset appearance to match surroundings or override quirky browser defaults
 *    for buttons, inputs.
 * 3. Cause adjacent children to push each other apart, which is useful for
 *    adding right-aligned icons or other affordances more easily.
 * 4. Override default text alignment for multi-line buttons.
 */

::v-deep .MenuList-action {
  -webkit-box-align: center;
  align-items: center;

  /* 1 */
  color: inherit;

  /* 2 */
  cursor: pointer;

  /* 2 */
  display: -webkit-box;
  display: flex;

  /* 1, 3 */
  font: inherit;

  /* 2 */
  font-weight: 700;
  -webkit-box-pack: justify;
  justify-content: space-between;

  /* 3 */
  line-height: 1.2;
  min-height: 47.776px;
  min-height: 2.986rem;
  padding: 13.328px 19.2px;
  padding: 0.833rem 1.2rem;
  text-align: left;

  /* 4 */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* 2 */
  width: 100%;

  /* 2 */
}

/**
 * Content should align with actions but without top padding, since actions
 * will already contain some visual whitespace.
 */

::v-deep .MenuList-content {
  padding: 0 19.2px 19.2px;
  padding: 0 1.2rem 1.2rem;
}

/**
 * Content should align with actions and should have top padding, since the
 * background is different and will not have visual whitespace.
 */

::v-deep .MenuList--loyalty .MenuList-content {
  background-color: #fafafa;
  padding: 19.2px 19.2px;
  padding: 1.2rem 1.2rem;
}

/**
 * @define Modal
 */

/**
 * Modal container is fixed (does not scroll with content)
 */

::v-deep .Modal {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;

  &[aria-hidden="true"] {
    display: none;
  }
}

/**
 * At wider viewports, we make the topmost container the scrolling element.
 * Because there is now space around the modal, this makes it clear that there
 * is content to scroll when it overflows.
 *
 * 1. Allow child elements to space themselves more easily.
 * 2. Elastic scrolling in supported browsers.
 * 3. Auto-hiding scrollbar in supported browsers.
 * 4. Vertical overflow scrolling.
 * 5. Always keep space around the content (so it doesn't meet the edge).
 */

@media (min-width: 47em) {
  .Modal {
    display: -webkit-box;
    display: flex;

    /* 1 */
    -webkit-overflow-scrolling: touch;

    /* 2 */
    -ms-overflow-style: -ms-autohiding-scrollbar;

    /* 3 */
    overflow-y: auto;

    /* 4 */
    padding: 1.44rem;

    /* 5 */
  }
}

/**
 * Hide visually when hidden from screen readers
 */

/**
 * Overlay element covers content below and also serves as a convenient
 * close/hide trigger
 *
 * 1. Without this, the overlay will mysteriously scroll with overflowing
 *    content in IE and Edge
 */

::v-deep .Modal-overlay {
  background-color: #2c2a29;
  height: 100%;
  left: 0;
  opacity: 0.8;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: -1;

  /* 1 */
}

/**
 * Dialog container. Mostly exists for accessibility (`role="dialog"`).
 *
 * 1. Without this, the z-order of the modal compared to the overlay is
 *    unpredictable in some browsers.
 *
 * @see https://github.com/edenspiekermann/a11y-dialog#expected-dom-structure
 */

::v-deep .Modal-dialog {
  position: relative;

  /* 1 */
}

/**
 * At small viewports, we want this element to fill the available space so
 * everything is "full-screen"
 */

@media (max-width: 46.999em) {
  .Modal-dialog {
    height: 100%;
    width: 100%;
  }
}

/**
 * At wide viewports...
 *
 * 1. Center vertically and horizontally.
 * 2. Constrain maximum width.
 * 3. Add a bit more padding to the bottom. This is purely visual, to help the
 *    modal appear a bit more balanced within the viewport.
 * 4. Set a default width, typically a percentage.
 */

@media (min-width: 47em) {
  .Modal-dialog {
    margin: auto;

    /* 1 */
    max-width: 40em;

    /* 2 */
    padding-bottom: 1.44rem;

    /* 3 */
    width: 80%;

    /* 4 */
  }
}

/**
 * At wide viewports...
 * Wider container so the content will fit better in wider screens
 */

@media (min-width: 47em) {
  .Modal-dialog--wide {
    max-width: 54.4rem;
  }
}

/**
 * At small sizes, the document container should occupy the full parent height
 * and use flex positioning. This will allow the main element to expand to fill
 * the available space.
 */

@media (max-width: 46.999em) {
  .Modal-document {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    height: 100%;
  }
}

/**
 * Header (typically with title and close button)
 *
 * 1. Arrange child elements in a horizontal row.
 * 2. Do not occupy more height than the content would normally.
 */

::v-deep .Modal-header {
  background-color: #eee;
  display: -webkit-box;
  display: flex;

  /* 1 */
  -webkit-box-flex: 0;
  flex: 0 0 auto;

  /* 2 */
}

/**
 * Close button. Designed to contain an icon, though that isn't technically
 * a strict requirement (text might look funny)
 *
 * 1. Center-align content (iconography).
 * 2. Override default button appearance properties.
 * 3. Use more interactive cursor style.
 * 4. Do not grow or shrink (only take up as much room as needed).
 * 5. Position as far to the right as possible without requiring that the
 *    element is last in the DOM order.
 * 6. We set modal padding on child elements so the click area for this will
 *    be quite large.
 * 7. Set up focus animation.
 */

::v-deep .Modal-close {
  -webkit-box-align: center;
  align-items: center;

  /* 1 */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  /* 2 */
  background: transparent;

  /* 2 */
  border: 0;

  /* 2 */
  color: inherit;

  /* 2 */
  cursor: pointer;

  /* 3 */
  display: -webkit-box;
  display: flex;

  /* 1 */
  -webkit-box-flex: 0;
  flex: 0 0 auto;

  /* 4 */
  font: inherit;

  /* 2 */
  -webkit-box-pack: center;
  justify-content: center;

  /* 1 */
  margin-left: auto;

  /* 5 */
  opacity: 0.8;
  -webkit-box-ordinal-group: 2;
  order: 1;

  /* 5 */
  padding: 19.2px;
  padding: 1.2rem;

  /* 6 */
  -webkit-transform-origin: center;
  transform-origin: center;

  /* 7 */
  -webkit-transition: opacity 0.3s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1);
  transition: opacity 0.3s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), opacity 0.3s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), opacity 0.3s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1);

  /* 7 */

  &:focus {
    opacity: 1;

    /* 1 */
    outline: 0;

    /* 2 */
    -webkit-transform: scale(1.25);
    transform: scale(1.25);

    /* 3 */
  }
}

/**
 * 1. Adds subtle opacity shift on :focus
 * 2. Removes default outline on :focus
 * 3. Sets desired scale for item on :focus
 */

/**
 * Title element within header.
 *
 * 1. We set padding on child elements of the header so that an adjacent close
 *    button will easily meet its container's edge.
 * 2. This element appears to be part of the dialog "shell," so it feels a bit
 *    strange to have its text selectable.
 */

::v-deep .Modal-title {
  font-size: inherit;
  line-height: 1.2;
  padding: 19.2px;
  padding: 1.2rem;

  /* 1 */
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* 2 */
}

/**
 * If the title follows a close element, remove padding that would "double up"
 * against that button.
 */

::v-deep .Modal-close + .Modal-title {
  padding-right: 0;
}

/**
 * Wrapper for the primary dialog section. This element will be flexible, but
 * because overflow-scrolling requires an explicit height property, we will
 * only use it to position the content wrapper (`Modal-content`).
 *
 * 1. Expand to fill space (but not more than necessary).
 * 2. Allow child elements to position themselves absolutely within.
 */

::v-deep .Modal-main {
  background-color: #fff;
  -webkit-box-flex: 1;
  flex: 1 0 0%;

  /* 1 */
  position: relative;

  /* 2 */
}

/**
 * Content container with default padding
 */

::v-deep .Modal-content {
  padding: 19.2px;
  padding: 1.2rem;
}

/**
 * At small screens, the content container is scrollable
 *
 * 1. Occupy the entirety of the parent element.
 * 2. Elastic scrolling in supported browsers.
 * 3. Auto-hiding scrollbar in supported browsers.
 * 4. Vertical overflow scrolling.
 */

@media (max-width: 46.999em) {
  .Modal-content {
    height: 100%;

    /* 1 */
    left: 0;

    /* 1 */
    -webkit-overflow-scrolling: touch;

    /* 2 */
    -ms-overflow-style: -ms-autohiding-scrollbar;

    /* 3 */
    overflow-y: auto;

    /* 4 */
    position: absolute;

    /* 1 */
    top: 0;

    /* 1 */
    width: 100%;

    /* 1 */
  }
}

/**
 * Optional footer content. Will be "sticky" at small sizes, but will scroll
 * with the rest of the modal at larger ones.
 *
 * 1. Do not occupy more height than the content would normally.
 */

::v-deep .Modal-footer {
  background-color: #fff;
  border-top: 1px solid #eee;
  -webkit-box-flex: 0;
  flex: 0 0 auto;

  /* 1 */
  padding: 19.2px;
  padding: 1.2rem;
  position: relative;
}

/**
 * @define PageGirdle
 */

:root {
  /* keep PageGirdle-duration in sync with page-girdle.js */
}

/**
 * Provide top padding so that content never scrolls beneath sticky header.
 *
 * Note that this padding would not be necessary if all browsers supported
 * `position: sticky`.
 *
 * Also, if IE11 weren't supported we could do most transform animations on
 * this root element.
 */

::v-deep .PageGirdle {
  padding-top: 57.328px;
  padding-top: 3.583rem;

  &.is-showingLeft, &.is-showingRight, &.is-showingSub {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
  }
}

/**
 * Additional padding unless this is a simple PageGirdle with no horizontal
 * submenu at large sizes
 */

@media (min-width: 47em) {
  .PageGirdle:not(.PageGirdle--simple) {
    padding-top: 6.569rem;
  }
}

/**
 * Whenever `PageGirdle` has started showing a menu, disable the page's default
 * scroll behavior by making it full-size and fixed-position. This relies on
 * JavaScript to visually maintain the scroll position.
 */

/**
 * Sticky header
 *
 * 1. This element expects two rows of content, so we stack those in a column.
 *    We use flexbox for this just in case the child content is not sized
 *    appropriately... the flexibility will cause it to adjust a bit more
 *    gracefully than it might otherwise.
 */

::v-deep .PageGirdle-header {
  background: #fff;
  box-shadow: 0 0 0.162em rgba(44, 42, 41, 0.2);
  display: -webkit-box;
  display: flex;

  /* 1 */
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;

  /* 1 */
  height: 57.328px;
  height: 3.583rem;
  left: 0;
  position: fixed;
  top: 0;
  -webkit-transition: -webkit-transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: -webkit-transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.2s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  width: 100%;
  z-index: 101;
}

@media (min-width: 47em) {
  .PageGirdle:not(.PageGirdle--simple) .PageGirdle-header {
    height: 6.569rem;
  }
}

/**
 * Move the header when left or right menus are showing.
 */

::v-deep .PageGirdle {
  &.is-shownLeft .PageGirdle-header {
    -webkit-transform: translateX(86vw);
    transform: translateX(86vw);
  }

  &.is-shownRight .PageGirdle-header {
    -webkit-transform: translateX(-86vw);
    transform: translateX(-86vw);
  }
}

/**
 * The top row of header content should grow to fill the available space.
 */

::v-deep .PageGirdle-headerTop {
  -webkit-box-flex: 1;
  flex: 1 0 auto;
}

::v-deep .PageGirdle-headerTop--dark {
  background-color: #2c2a29;
}

/**
 * Bottom row of content
 *
 * 1. Visual separation from top row.
 * 2. Retain natural vertical size (don't grow or shrink).
 */

::v-deep .PageGirdle-headerBottom {
  border-top: 1px solid #eee;

  /* 1 */
  -webkit-box-flex: 0;
  flex: 0 0 auto;

  /* 2 */
}

/**
 * Because the bottom row is intended for a widescreen navigation element,
 * we hide it until the medium viewport. We can't control this via a utility
 * in markup because the height of the header must be known by other
 * sticky elements, for example submenus.
 */

@media (max-width: 46.999em) {
  .PageGirdle-headerBottom {
    display: none;
  }
}

::v-deep .PageGirdle-left,
  ::v-deep .u .PageGirdle-right {
  background: #eee;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  position: fixed;
  top: 0;
  -webkit-transition: -webkit-transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: -webkit-transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.2s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  width: 86vw;
  z-index: 101;
}

/**
 * Left off-canvas menu
 */

::v-deep .PageGirdle-left {
  left: 0;

  &:not(.is-current) {
    display: none;
  }
}

::v-deep .PageGirdle {
  &:not(.is-showingLeft) .PageGirdle-left {
    display: none;
  }

  &:not(.is-shownLeft) .PageGirdle-left {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
  }
}

/**
 * Right off-canvas menu
 */

::v-deep .PageGirdle-right {
  right: 0;

  &:not(.is-current) {
    display: none;
  }
}

::v-deep .PageGirdle {
  &:not(.is-showingRight) .PageGirdle-right {
    display: none;
  }

  &:not(.is-shownRight) .PageGirdle-right {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
  }
}

/**
 * Submenu, displaying below the header
 */

::v-deep .PageGirdle-sub {
  bottom: 0;
  left: 0;
  position: fixed;
  top: 57.328px;
  top: 3.583rem;
  -webkit-transition: opacity 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: opacity 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  width: 100%;
  z-index: 101;

  &:not(.is-current) {
    display: none;
  }
}

@media (min-width: 47em) {
  .PageGirdle:not(.PageGirdle--simple) .PageGirdle-sub {
    top: 6.569rem;
  }
}

::v-deep .PageGirdle {
  &:not(.is-showingSub) .PageGirdle-sub {
    display: none;
  }

  &:not(.is-shownSub) .PageGirdle-sub {
    opacity: 0;
  }
}

/**
 * Because submenus may be smaller than the full page height, we use an inner
 * element both visually and to control the scroll (so elastic scrolling won't
 * show the page below).
 */

::v-deep .PageGirdle-subInner {
  background: #eee;
  max-height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

/**
 * Overlay element
 */

::v-deep .PageGirdle-overlay {
  background-color: #2c2a29;
  height: 100%;
  left: 0;
  opacity: 0.8;
  position: fixed;
  top: 0;
  -webkit-transition: opacity 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: opacity 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  width: 100%;
  z-index: 100;
}

::v-deep .PageGirdle {
  &:not(.is-showingLeft):not(.is-showingRight):not(.is-showingSub) .PageGirdle-overlay {
    display: none;
  }

  &:not(.is-shownLeft):not(.is-shownRight):not(.is-shownSub) .PageGirdle-overlay {
    opacity: 0;
  }

  &.is-showingSub .PageGirdle-overlay {
    background-color: #fff;
  }
}

/**
 * Overlay color changes depending on what type of menu is shown. The submenu
 * style is the alternate because it is less likely to be triggered on small
 * screens. Mobile first!
 */

/**
 * Transition and disable events for page content to sync with the rest of the
 * animation.
 */

::v-deep .PageGirdle-content {
  -webkit-transition: -webkit-transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: -webkit-transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: transform 0.2s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.2s cubic-bezier(0.77, 0, 0.175, 1);
}

::v-deep .PageGirdle {
  &.is-showingLeft .PageGirdle-content, &.is-showingRight .PageGirdle-content, &.is-showingSub .PageGirdle-content {
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  &.is-shownLeft .PageGirdle-content {
    -webkit-transform: translateX(86vw);
    transform: translateX(86vw);
  }

  &.is-shownRight .PageGirdle-content {
    -webkit-transform: translateX(-86vw);
    transform: translateX(-86vw);
  }
}

/**
 * Hash Fix
 *
 * Helper class to add to content that is likely to be a hash navigation target
 * to make sure it won't end up scrolled beneath the header.
 *
 * @see https://css-tricks.com/hash-tag-links-padding/
 * @see http://nicolasgallagher.com/jump-links-and-viewport-positioning/
 */

::v-deep .PageGirdle-hashFix {
  background-clip: content-box;
  margin-top: -57.328px;
  margin-top: -3.583rem;
  padding-top: 57.328px;
  padding-top: 3.583rem;
}

@media (min-width: 47em) {
  .PageGirdle:not(.PageGirdle--simple) .PageGirdle-hashFix {
    margin-top: -6.569rem;
    padding-top: 6.569rem;
  }
}

/**
 * @display ProductDisplay
 */

/**
 * Apply half-inverse margins to the containing element so inner elements with
 * half-padding will have equal gaps on all edges while aligning with the
 * outermost container.
 *
 * @see http://alistapart.com/article/learning-from-lego-a-step-forward-in-modular-web-design
 */

::v-deep .ProductDisplay {
  margin: -9.6px;
  margin: -0.6rem;
  position: relative;

  &:before {
    content: " ";

    /* 1 */
    display: table;

    /* 1 */
  }

  &:after {
    content: " ";

    /* 1 */
    display: table;

    /* 1 */

    clear: both;
  }
}

/**
 * Classic clearfix. We would ususally use the much simpler `overflow: hidden`,
 * but in this case the contents may have visual effects (such as shadows) that
 * we don't want to clip.
 *
 * 1. The space content is one way to avoid an Opera bug when the
 *    `contenteditable` attribute is included anywhere else in the document.
 *    Otherwise it causes space to appear at the top and bottom of the
 *    element.
 * 2. The use of `table` rather than `block` is only necessary if using
 *    `:before` to contain the top-margins of child elements.
 */

/**
 * Content cells that contain the header, product details and gallery. These all
 * have half-gaps applied via padding so they line up evenly regardless of
 * position. We use padding because these will float (not flex) so they won't
 * shrink to accommodate margins evenly.
 */

::v-deep .ProductDisplay-cell {
  padding: 9.6px;
  padding: 0.6rem;
}

/**
 * At wider sizes, we shift to a two-column layout. By default, cells assume
 * they will be on the right (since only the gallery cell should be on the
 * left.)
 *
 * The reason we use floats here is because we want cells that were initially
 * above and below the gallery to shift up and to the right. We can't do that
 * with flexbox unless we give the containing element a fixed height. When IE11
 * compatibility is dropped, CSS Grid Layout would be an even better choice!
 */

@media (min-width: 47em) {
  .ProductDisplay-cell {
    float: right;
    width: 50%;
  }
}

/**
 * At wider viewports still, we want the gallery to take up even more space,
 * so we shrink the width of the default cells.
 */

@media (min-width: 64em) {
  .ProductDisplay-cell {
    width: 42.85714%;
  }
}

/**
 * Cells: With Gallery
 *
 * The cell that contains the gallery should occupy the opposite column at
 * wider viewport sizes.
 */

@media (min-width: 47em) {
  .ProductDisplay-cell--withGallery {
    float: left;
  }
}

/**
 * Starting here, the columns are no longer of even width. We subtract the
 * default cell width from 100% so the gallery will fill the remaining space.
 */

@media (min-width: 64em) {
  .ProductDisplay-cell--withGallery {
    width: 57.14286%;
  }
}

/**
 * Gallery
 *
 * 1. We use flexbox for this because the source order is simpler than the
 *    parent element, and it doesn't need any sort of clearfix. This will
 *    arrange the current figure and the thumbnail navigation in a horizontal
 *    row.
 * 2. Like the parent, we apply inverse half-gaps to allow even spacing between
 *    children while still aligning with the parent element's edges.
 */

::v-deep .ProductDisplay-gallery {
  display: -webkit-box;
  display: flex;

  /* 1 */
  margin: -4.632px;
  margin: -0.2895rem;

  /* 2 */
  position: relative;

  /* 2 */
}

/**
 * While the cells are evenly spaced, we arrange the gallery contents vertically
 * instead of horizontally.
 */

@media (min-width: 47.001em) and (max-width: 63.999em) {
  .ProductDisplay-gallery {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
  }
}

/**
 * At even larger sizes, we reverse the order of the gallery contents. This is
 * because the gallery will now be too far away from the right edge of the
 * screen to get much benefit from thumbnails being on the right, and the
 * composition looks nicer when the thumbnails aren't competing directly with
 * adjacent content.
 *
 * We could also accomplish this by applying `order: -1` to
 * `.ProductDisplay-galleryNav` at this breakpoint, but then the layout would
 * be defined across two different classes.
 */

@media (min-width: 64em) {
  .ProductDisplay-gallery {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
    flex-direction: row-reverse;
  }
}

/**
 * Gallery Figure (Current/Selected)
 *
 * 1. Allow this element to occupy all available space. We use `0%` to avoid
 *    an IE bug with unitless flex basis.
 * 2. Apply half-gap to this element so it will have consistent whitespace
 *    regardless of layout.
 *
 * @see https://github.com/philipwalton/flexbugs#4-flex-shorthand-declarations-with-unitless-flex-basis-values-are-ignored
 */

::v-deep .ProductDisplay-galleryFigure {
  -webkit-box-flex: 1;
  flex: 1 1 0%;

  /* 1 */
  margin: 4.632px;
  margin: 0.2895rem;

  /* 2 */
}

/**
 * While in stacked orientation, we make this element less flexible. This is
 * only needed because otherwise IE will collapse the element to `height: 0`.
 */

@media (min-width: 47.001em) and (max-width: 63.999em) {
  .ProductDisplay-galleryFigure {
    -webkit-box-flex: 0;
    flex: 0 0 auto;
  }
}

/**
 * Gallery Navigation (Column of Thumbnails)
 *
 * 1. Unlike the figure, this element should maintain a consistent, inflexible
 *    width.
 * 2. Apply the same half-gap to this element. In this case, use of `margin` is
 *    particularly important as it will simplify position of the scrollable
 *    track.
 */

::v-deep .ProductDisplay-galleryNav {
  -webkit-box-flex: 0;
  flex: 0 0 44px;
  flex: 0 0 2.75rem;

  /* 1 */
  margin: 4.632px;
  margin: 0.2895rem;

  /* 2 */
  position: relative;

  /* 2 */
}

/**
 * Increase the nav width as available space increases.
 */

@media (min-width: 30em) {
  .ProductDisplay-galleryNav {
    flex-basis: 3.3rem;
  }
}

/**
 * When the gallery is in a vertical (stacked) orientation, we reset the
 * flex basis so it won't have limited height.
 */

@media (min-width: 47em) {
  .ProductDisplay-galleryNav {
    flex-basis: auto;
  }
}

/**
 * At the widest sizes, the gallery is back in a horizontal orientation but
 * we want the thumbs to be larger still.
 */

@media (min-width: 64em) {
  .ProductDisplay-galleryNav {
    flex-basis: 4.752rem;
  }
}

/**
 * Gallery Nav Track
 *
 * This element makes the list of thumbnails scrollable. It is only applied
 * up to a specific breakpoint, at which point the design is more flexible in
 * terms of allowing extra thumbnails.
 *
 * 1. We occupy the full height of the container, setting `height` explicitly to
 *    gain scrolling behavior when the content exceeds that (3).
 * 2. We exceed the container width by the available gaps to make the scrollable
 *    container more touch-friendly. We apply this same overage as padding, so
 *    the contents of this element will respect the parent element's whitespace.
 * 3. Allow content to scroll when it exceeds the container.
 * 4. In Webkit-based browsers, allow "elastic" scrolling of contents.
 */

@media (max-width: 46.999em) {
  .ProductDisplay-galleryNavTrack {
    height: 100%;

    /* 1 */
    left: -0.579rem;

    /* 2 */
    overflow: auto;

    /* 3 */
    -webkit-overflow-scrolling: touch;

    /* 4 */
    padding-left: 0.579rem;

    /* 2 */
    padding-right: 1.2rem;

    /* 2 */
    position: absolute;

    /* 1, 2 */
    right: -1.2rem;

    /* 2 */
    top: 0;

    /* 1 */
  }
}

/**
 * Gallery Nav List
 *
 * This is the containing element for the nav items (typically thumbnails).
 *
 * 1. Arrange thumbnails in a vertical stack.
 * 2. Since this is typically a list, we reset some list defaults.
 * 3. Same inverse half-gap trick as other elements.
 */

::v-deep .ProductDisplay-galleryNavList {
  display: -webkit-box;
  display: flex;

  /* 1 */
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;

  /* 1 */
  list-style: none;

  /* 2 */
  margin: -4.632px;
  margin: -0.2895rem;

  /* 3 */
  padding-left: 0;

  /* 2 */
  position: relative;

  /* 3 */
}

/**
 * When the nav is below the figure, arrange children in a row instead.
 */

@media (min-width: 47.001em) and (max-width: 63.999em) {
  .ProductDisplay-galleryNavList {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
  }
}

/**
 * Apply half-gaps to nav items (similar to parent elements). In this case we
 * choose `padding` over `margin` because at some breakpoints we want whitespace
 * to factor into the percentage occupied.
 */

::v-deep .ProductDisplay-galleryNavItem {
  padding: 4.632px;
  padding: 0.2895rem;
}

/**
 * When items are arranged in a row, we want them to default to a width of 20%,
 * while shrinking to accommodate additional thumbnails when there are more than
 * five. This avoids the need for overflow scrolling (which feels awkward in the
 * multi-column layout) but also makes sure thumbnails don't get too large when
 * there are fewer than five.
 */

@media (min-width: 47.001em) and (max-width: 63.999em) {
  .ProductDisplay-galleryNavItem {
    -webkit-box-flex: 0;
    flex: 0 1 20%;
  }
}

/**
 * @define ScrollRow
 */

/**
 * 1. Arrange items in a horizontal row.
 * 2. Do not allow wrapping. This should be the default, but since it's critical
 *    we go ahead and specify it just in case.
 * 3. "Elastic" scrolling in iOS
 * 4. Scrollbars that don't overstay their welcome in IE/Edge
 * 5. Horizontal scrolling activated ↔
 * 6. We add vertical padding like normal, but we only add horizontal padding
 *    minus the padding present in items. This avoids the requirement for an
 *    inner element and allows the item width percentages to be accurate.
 * 7. Prevent Chrome issue where overflowing items impact page width (even if
 *    `width` or `max-width` is set! 😮)
 *
 * @see https://iamsteve.me/blog/entry/using-flexbox-for-horizontal-scrolling-navigation
 */

::v-deep .ScrollRow {
  display: -webkit-box;
  display: flex;

  /* 1 */
  flex-wrap: nowrap;

  /* 2 */
  -webkit-overflow-scrolling: touch;

  /* 3 */
  -ms-overflow-style: -ms-autohiding-scrollbar;

  /* 4 */
  overflow-x: auto;

  /* 5 */
  padding: 19.2px 7.68px;
  padding: 1.2rem 0.48rem;

  /* 6 */
  position: relative;

  /* 7 */
}

/**
 * 1. Items should size themselves naturally (not growing or shrinking).
 * 2. Apply half horizontal gutter so it will add up to the full gutter space
 *    as items line up.
 */

::v-deep .ScrollRow-item {
  -webkit-box-flex: 0;
  flex: 0 0 auto;

  /* 1 */
  padding: 0 11.52px;
  padding: 0 0.72rem;

  /* 2 */
}

/**
 * @define TweenToggle
 */

/**
 * Set consistent transition properties for child elements that will animate.
 */

::v-deep .TweenToggle-fadeIn,
  ::v-deep .u .TweenToggle-fadeOut,
  ::v-deep .u .TweenToggle-rotate1of8,
  ::v-deep .u .TweenToggle-rotateCounter1of8,
  ::v-deep .u .TweenToggle-rotateCounter1of2,
  ::v-deep .u .TweenToggle-scaleIn,
  ::v-deep .u .TweenToggle-scaleOut {
  -webkit-transition: 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  transition: 0.2s cubic-bezier(0.77, 0, 0.175, 1);
  -webkit-transition-property: opacity, -webkit-transform;
  transition-property: opacity, -webkit-transform;
  transition-property: transform, opacity;
  transition-property: transform, opacity, -webkit-transform;
}

/**
 * Set consistent transform origin for child elements that will animate their
 * position, scale or orientation.
 */

::v-deep .TweenToggle-rotate1of8,
  ::v-deep .u .TweenToggle-rotateCounter1of8,
  ::v-deep .u .TweenToggle-rotateCounter1of2,
  ::v-deep .u .TweenToggle-scaleIn,
  ::v-deep .u .TweenToggle-scaleOut {
  -webkit-transform-origin: center;
  transform-origin: center;
}

/**
 * Visibility changes
 *
 * We use opacity for both fade-in/fade-out animations and for visibility,
 * because some browsers are quirky when it comes to `visibility: hidden`.
 */

::v-deep .TweenToggle {
  &.is-on .TweenToggle-hide, &[aria-expanded="true"] .TweenToggle-hide, &:not(.is-on):not([aria-expanded="true"]) .TweenToggle-show, &.is-on .TweenToggle-fadeOut, &[aria-expanded="true"] .TweenToggle-fadeOut, &:not(.is-on):not([aria-expanded="true"]) .TweenToggle-fadeIn {
    opacity: 0;
  }

  &.is-on .TweenToggle-rotate1of8, &[aria-expanded="true"] .TweenToggle-rotate1of8 {
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  &.is-on .TweenToggle-rotateCounter1of8, &[aria-expanded="true"] .TweenToggle-rotateCounter1of8 {
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  &.is-on .TweenToggle-rotate1of2, &[aria-expanded="true"] .TweenToggle-rotate1of2 {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  &.is-on .TweenToggle-rotateCounter1of2, &[aria-expanded="true"] .TweenToggle-rotateCounter1of2 {
    -webkit-transform: rotate(-180deg);
    transform: rotate(-180deg);
  }

  &.is-on .TweenToggle-scaleOut, &[aria-expanded="true"] .TweenToggle-scaleOut, &:not(.is-on):not([aria-expanded="true"]) .TweenToggle-scaleIn {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
}

/**
 * Rotation
 */

/**
 * Scale
 */

/**
 * @define Zoomable
 */

/**
 * 1. Clip anything that exceeds the boundaries of this container.
 * 2. Force child element dimensions to base themselves on this container.
 */

::v-deep .Zoomable {
  display: block;
  overflow: hidden;

  /* 1 */
  position: relative;

  /* 2 */
}

/**
 * The actual image object.
 *
 * 1. Fill containing element while maintaining aspect ratio.
 * 2. Transform from the top left. This will make calculations in the JavaScript
 *    component much easier.
 */

::v-deep .Zoomable-object {
  display: block;

  /* 1 */
  height: auto;

  /* 1 */
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;

  /* 2 */
  width: 100%;

  /* 1 */
}

/**
 * @define utilities
 */

/**
 * Size
 */

/* stylelint-disable plugin/selector-bem-pattern */

/* stylelint-enable */

::v-deep .u-borderSm {
  border-style: solid;
  border-width: 1px;
}

::v-deep .u-borderEndsSm {
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-top-style: solid;
  border-top-width: 1px;
}

::v-deep .u-borderSidesSm {
  border-left-style: solid;
  border-left-width: 1px;
  border-right-style: solid;
  border-right-width: 1px;
}

::v-deep .u-borderTopSm {
  border-top-style: solid;
  border-top-width: 1px;
}

::v-deep .u-borderBottomSm {
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

::v-deep .u-borderLeftSm {
  border-left-style: solid;
  border-left-width: 1px;
}

::v-deep .u-borderRightSm {
  border-right-style: solid;
  border-right-width: 1px;
}

::v-deep .u-borderMd {
  border-style: solid;
  border-width: 2px;
}

::v-deep .u-borderEndsMd {
  border-bottom-style: solid;
  border-bottom-width: 2px;
  border-top-style: solid;
  border-top-width: 2px;
}

::v-deep .u-borderSidesMd {
  border-left-style: solid;
  border-left-width: 2px;
  border-right-style: solid;
  border-right-width: 2px;
}

::v-deep .u-borderTopMd {
  border-top-style: solid;
  border-top-width: 2px;
}

::v-deep .u-borderBottomMd {
  border-bottom-style: solid;
  border-bottom-width: 2px;
}

::v-deep .u-borderLeftMd {
  border-left-style: solid;
  border-left-width: 2px;
}

::v-deep .u-borderRightMd {
  border-right-style: solid;
  border-right-width: 2px;
}

::v-deep .u-borderNone {
  border-style: solid;
  border-width: 0;
}

::v-deep .u-borderEndsNone {
  border-bottom-style: solid;
  border-bottom-width: 0;
  border-top-style: solid;
  border-top-width: 0;
}

::v-deep .u-borderSidesNone {
  border-left-style: solid;
  border-left-width: 0;
  border-right-style: solid;
  border-right-width: 0;
}

::v-deep .u-borderTopNone {
  border-top-style: solid;
  border-top-width: 0;
}

::v-deep .u-borderBottomNone {
  border-bottom-style: solid;
  border-bottom-width: 0;
}

::v-deep .u-borderLeftNone {
  border-left-style: solid;
  border-left-width: 0;
}

::v-deep .u-borderRightNone {
  border-right-style: solid;
  border-right-width: 0;
}

@media (min-width: 30em) {
  ::v-deep .u-sm-borderSm {
    border-style: solid;
    border-width: 1px;
  }

  ::v-deep .u-sm-borderEndsSm {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-top-style: solid;
    border-top-width: 1px;
  }

  ::v-deep .u-sm-borderSidesSm {
    border-left-style: solid;
    border-left-width: 1px;
    border-right-style: solid;
    border-right-width: 1px;
  }

  ::v-deep .u-sm-borderTopSm {
    border-top-style: solid;
    border-top-width: 1px;
  }

  ::v-deep .u-sm-borderBottomSm {
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }

  ::v-deep .u-sm-borderLeftSm {
    border-left-style: solid;
    border-left-width: 1px;
  }

  ::v-deep .u-sm-borderRightSm {
    border-right-style: solid;
    border-right-width: 1px;
  }

  ::v-deep .u-sm-borderMd {
    border-style: solid;
    border-width: 2px;
  }

  ::v-deep .u-sm-borderEndsMd {
    border-bottom-style: solid;
    border-bottom-width: 2px;
    border-top-style: solid;
    border-top-width: 2px;
  }

  ::v-deep .u-sm-borderSidesMd {
    border-left-style: solid;
    border-left-width: 2px;
    border-right-style: solid;
    border-right-width: 2px;
  }

  ::v-deep .u-sm-borderTopMd {
    border-top-style: solid;
    border-top-width: 2px;
  }

  ::v-deep .u-sm-borderBottomMd {
    border-bottom-style: solid;
    border-bottom-width: 2px;
  }

  ::v-deep .u-sm-borderLeftMd {
    border-left-style: solid;
    border-left-width: 2px;
  }

  ::v-deep .u-sm-borderRightMd {
    border-right-style: solid;
    border-right-width: 2px;
  }

  ::v-deep .u-sm-borderNone {
    border-style: solid;
    border-width: 0;
  }

  ::v-deep .u-sm-borderEndsNone {
    border-bottom-style: solid;
    border-bottom-width: 0;
    border-top-style: solid;
    border-top-width: 0;
  }

  ::v-deep .u-sm-borderSidesNone {
    border-left-style: solid;
    border-left-width: 0;
    border-right-style: solid;
    border-right-width: 0;
  }

  ::v-deep .u-sm-borderTopNone {
    border-top-style: solid;
    border-top-width: 0;
  }

  ::v-deep .u-sm-borderBottomNone {
    border-bottom-style: solid;
    border-bottom-width: 0;
  }

  ::v-deep .u-sm-borderLeftNone {
    border-left-style: solid;
    border-left-width: 0;
  }

  ::v-deep .u-sm-borderRightNone {
    border-right-style: solid;
    border-right-width: 0;
  }
}

@media (min-width: 47em) {
  ::v-deep .u-md-borderSm {
    border-style: solid;
    border-width: 1px;
  }

  ::v-deep .u-md-borderEndsSm {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-top-style: solid;
    border-top-width: 1px;
  }

  ::v-deep .u-md-borderSidesSm {
    border-left-style: solid;
    border-left-width: 1px;
    border-right-style: solid;
    border-right-width: 1px;
  }

  ::v-deep .u-md-borderTopSm {
    border-top-style: solid;
    border-top-width: 1px;
  }

  ::v-deep .u-md-borderBottomSm {
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }

  ::v-deep .u-md-borderLeftSm {
    border-left-style: solid;
    border-left-width: 1px;
  }

  ::v-deep .u-md-borderRightSm {
    border-right-style: solid;
    border-right-width: 1px;
  }

  ::v-deep .u-md-borderMd {
    border-style: solid;
    border-width: 2px;
  }

  ::v-deep .u-md-borderEndsMd {
    border-bottom-style: solid;
    border-bottom-width: 2px;
    border-top-style: solid;
    border-top-width: 2px;
  }

  ::v-deep .u-md-borderSidesMd {
    border-left-style: solid;
    border-left-width: 2px;
    border-right-style: solid;
    border-right-width: 2px;
  }

  ::v-deep .u-md-borderTopMd {
    border-top-style: solid;
    border-top-width: 2px;
  }

  ::v-deep .u-md-borderBottomMd {
    border-bottom-style: solid;
    border-bottom-width: 2px;
  }

  ::v-deep .u-md-borderLeftMd {
    border-left-style: solid;
    border-left-width: 2px;
  }

  ::v-deep .u-md-borderRightMd {
    border-right-style: solid;
    border-right-width: 2px;
  }

  ::v-deep .u-md-borderNone {
    border-style: solid;
    border-width: 0;
  }

  ::v-deep .u-md-borderEndsNone {
    border-bottom-style: solid;
    border-bottom-width: 0;
    border-top-style: solid;
    border-top-width: 0;
  }

  ::v-deep .u-md-borderSidesNone {
    border-left-style: solid;
    border-left-width: 0;
    border-right-style: solid;
    border-right-width: 0;
  }

  ::v-deep .u-md-borderTopNone {
    border-top-style: solid;
    border-top-width: 0;
  }

  ::v-deep .u-md-borderBottomNone {
    border-bottom-style: solid;
    border-bottom-width: 0;
  }

  ::v-deep .u-md-borderLeftNone {
    border-left-style: solid;
    border-left-width: 0;
  }

  ::v-deep .u-md-borderRightNone {
    border-right-style: solid;
    border-right-width: 0;
  }
}

@media (min-width: 64em) {
  ::v-deep .u-lg-borderSm {
    border-style: solid;
    border-width: 1px;
  }

  ::v-deep .u-lg-borderEndsSm {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-top-style: solid;
    border-top-width: 1px;
  }

  ::v-deep .u-lg-borderSidesSm {
    border-left-style: solid;
    border-left-width: 1px;
    border-right-style: solid;
    border-right-width: 1px;
  }

  ::v-deep .u-lg-borderTopSm {
    border-top-style: solid;
    border-top-width: 1px;
  }

  ::v-deep .u-lg-borderBottomSm {
    border-bottom-style: solid;
    border-bottom-width: 1px;
  }

  ::v-deep .u-lg-borderLeftSm {
    border-left-style: solid;
    border-left-width: 1px;
  }

  ::v-deep .u-lg-borderRightSm {
    border-right-style: solid;
    border-right-width: 1px;
  }

  ::v-deep .u-lg-borderMd {
    border-style: solid;
    border-width: 2px;
  }

  ::v-deep .u-lg-borderEndsMd {
    border-bottom-style: solid;
    border-bottom-width: 2px;
    border-top-style: solid;
    border-top-width: 2px;
  }

  ::v-deep .u-lg-borderSidesMd {
    border-left-style: solid;
    border-left-width: 2px;
    border-right-style: solid;
    border-right-width: 2px;
  }

  ::v-deep .u-lg-borderTopMd {
    border-top-style: solid;
    border-top-width: 2px;
  }

  ::v-deep .u-lg-borderBottomMd {
    border-bottom-style: solid;
    border-bottom-width: 2px;
  }

  ::v-deep .u-lg-borderLeftMd {
    border-left-style: solid;
    border-left-width: 2px;
  }

  ::v-deep .u-lg-borderRightMd {
    border-right-style: solid;
    border-right-width: 2px;
  }

  ::v-deep .u-lg-borderNone {
    border-style: solid;
    border-width: 0;
  }

  ::v-deep .u-lg-borderEndsNone {
    border-bottom-style: solid;
    border-bottom-width: 0;
    border-top-style: solid;
    border-top-width: 0;
  }

  ::v-deep .u-lg-borderSidesNone {
    border-left-style: solid;
    border-left-width: 0;
    border-right-style: solid;
    border-right-width: 0;
  }

  ::v-deep .u-lg-borderTopNone {
    border-top-style: solid;
    border-top-width: 0;
  }

  ::v-deep .u-lg-borderBottomNone {
    border-bottom-style: solid;
    border-bottom-width: 0;
  }

  ::v-deep .u-lg-borderLeftNone {
    border-left-style: solid;
    border-left-width: 0;
  }

  ::v-deep .u-lg-borderRightNone {
    border-right-style: solid;
    border-right-width: 0;
  }
}

/**
 * Colors
 */

::v-deep .u-borderBlack {
  border-color: #2c2a29;
}

::v-deep .u-borderMercury {
  border-color: #bbb;
}

::v-deep .u-borderSilver {
  border-color: #eee;
}

/** @define utilities */

::v-deep .u-bgWhite {
  background-color: #fff !important;
}

::v-deep .u-bgBlack {
  background-color: #2c2a29 !important;
}

::v-deep .u-bgGray80 {
  background-color: #ccc !important;
}

::v-deep .u-bgSalmon {
  background-color: #db908c !important;
}

::v-deep .u-bgDarkPink {
  background-color: #af605b !important;
}

::v-deep .u-bgLeonisa {
  background-color: #003865 !important;
}

::v-deep .u-bgPurple {
  background-color: #b4b5df !important;
}

::v-deep .u-bgPeach {
  background-color: #fdd086 !important;
}

::v-deep .u-bgGray {
  background-color: #63666a !important;
}

::v-deep .u-bgOrange {
  background-color: #f48e28 !important;
}

::v-deep .u-bgMercury {
  background-color: #bbb !important;
}

::v-deep .u-bgSilver {
  background-color: #eee !important;
}

::v-deep .u-bgLightSilver {
  background-color: #fafafa !important;
}

::v-deep .u-bgDarkBlue {
  background-color: #2f4754 !important;
}

::v-deep .u-bgWine {
  background-color: #641e35 !important;
}

::v-deep .u-bgSand {
  background-color: #a99a6c !important;
}

::v-deep .u-bgRed {
  background-color: #d73043 !important;
}

::v-deep .u-bgGreen {
  background-color: #8ec549 !important;
}

::v-deep .u-bgCyan {
  background-color: #009fda !important;
}

::v-deep .u-bgYellow {
  background-color: #e8aa00 !important;
}

::v-deep .u-bgSeaGreen {
  background-color: #009ca6 !important;
}

::v-deep .u-bgMint {
  background-color: #3cdbc0 !important;
}

::v-deep .u-bgLoyaltyPeach {
  background-color: #fdf1e9 !important;
}

::v-deep .u-bgLoyaltyGreen {
  background-color: #cfe7e1 !important;
}

::v-deep .u-bgLoyaltyBlue {
  background-color: #d2ebf1 !important;
}

::v-deep .u-bgLoyaltyPink {
  background-color: #e9d7e8 !important;
}

::v-deep .u-bgLoyaltyPurple {
  background-color: #6f6da8 !important;
}

/**
 * @define utilities
 */

/* stylelint-disable plugin/selector-bem-pattern */

/* stylelint-enable */

::v-deep .u-columns1 {
  -webkit-columns: 1;
  columns: 1;
}

::v-deep .u-columns2 {
  -webkit-columns: 2;
  columns: 2;
}

::v-deep .u-columns3 {
  -webkit-columns: 3;
  columns: 3;
}

@media (min-width: 30em) {
  ::v-deep .u-sm-columns1 {
    -webkit-columns: 1;
    columns: 1;
  }

  ::v-deep .u-sm-columns2 {
    -webkit-columns: 2;
    columns: 2;
  }

  ::v-deep .u-sm-columns3 {
    -webkit-columns: 3;
    columns: 3;
  }
}

@media (min-width: 47em) {
  ::v-deep .u-md-columns1 {
    -webkit-columns: 1;
    columns: 1;
  }

  ::v-deep .u-md-columns2 {
    -webkit-columns: 2;
    columns: 2;
  }

  ::v-deep .u-md-columns3 {
    -webkit-columns: 3;
    columns: 3;
  }
}

@media (min-width: 64em) {
  ::v-deep .u-lg-columns1 {
    -webkit-columns: 1;
    columns: 1;
  }

  ::v-deep .u-lg-columns2 {
    -webkit-columns: 2;
    columns: 2;
  }

  ::v-deep .u-lg-columns3 {
    -webkit-columns: 3;
    columns: 3;
  }
}

/**
 * @define utilities
 */

/**
 * 1. Center element by default, but leave unimportant so it can be overridden
 *    easily by other utilities.
 */

::v-deep .u-contain {
  margin-left: auto;

  /* 1 */
  margin-right: auto;

  /* 1 */
  max-width: 1024px !important;
  max-width: 64rem !important;
}

/**
 * @define utilities
 */

/**
 * @define utilities
 * Display-type utilities
 */

::v-deep .u-block {
  display: block !important;
}

::v-deep .u-hidden {
  display: none !important;
}

/**
 * Completely remove from the flow but leave available to screen readers.
 */

::v-deep .u-hiddenVisually {
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  height: 1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
}

::v-deep .u-inline {
  display: inline !important;
}

/**
 * 1. Fix for Firefox bug: an image styled `max-width:100%` within an
 * inline-block will display at its default size, and not limit its width to
 * 100% of an ancestral container.
 */

::v-deep .u-inlineBlock {
  display: inline-block !important;
  max-width: 100%;

  /* 1 */
}

::v-deep .u-table {
  display: table !important;
}

::v-deep .u-tableCell {
  display: table-cell !important;
}

::v-deep .u-tableRow {
  display: table-row !important;
}

/**
 * Some display utilities are useful at specific breakpoints, so we recreate
 * a few as a mixin to keep things consistent and DRY between the various
 * media queries.
 */

/* stylelint-disable plugin/selector-bem-pattern */

/* stylelint-enable */

@media (min-width: 30em) {
  ::v-deep .u-sm-block {
    display: block !important;
  }

  ::v-deep .u-sm-hidden {
    display: none !important;
  }

  ::v-deep .u-sm-inline {
    display: inline !important;
  }

  /**
   * 1. Fix for Firefox bug: an image styled `max-width:100%` within an
   * inline-block will display at its default size, and not limit its width to
   * 100% of an ancestral container.
   */

  ::v-deep .u-sm-inlineBlock {
    display: inline-block !important;
    max-width: 100%;

    /* 1 */
  }
}

@media (min-width: 47em) {
  ::v-deep .u-md-block {
    display: block !important;
  }

  ::v-deep .u-md-hidden {
    display: none !important;
  }

  ::v-deep .u-md-inline {
    display: inline !important;
  }

  /**
   * 1. Fix for Firefox bug: an image styled `max-width:100%` within an
   * inline-block will display at its default size, and not limit its width to
   * 100% of an ancestral container.
   */

  ::v-deep .u-md-inlineBlock {
    display: inline-block !important;
    max-width: 100%;

    /* 1 */
  }
}

@media (min-width: 64em) {
  ::v-deep .u-lg-block {
    display: block !important;
  }

  ::v-deep .u-lg-hidden {
    display: none !important;
  }

  ::v-deep .u-lg-inline {
    display: inline !important;
  }

  /**
   * 1. Fix for Firefox bug: an image styled `max-width:100%` within an
   * inline-block will display at its default size, and not limit its width to
   * 100% of an ancestral container.
   */

  ::v-deep .u-lg-inlineBlock {
    display: inline-block !important;
    max-width: 100%;

    /* 1 */
  }
}

/**
 * @define utilities
 */

/** @define utilities */

/* Applies to flex container
   ========================================================================== */

/**
 * Container
 */

::v-deep .u-flex {
  display: -webkit-box !important;
  display: flex !important;
}

::v-deep .u-flexInline {
  display: -webkit-inline-box !important;
  display: inline-flex !important;
}

/**
 * Direction: row
 */

::v-deep .u-flexRow {
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: normal !important;
  flex-direction: row !important;
}

::v-deep .u-flexRowReverse {
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: reverse !important;
  flex-direction: row-reverse !important;
}

/**
 * Direction: column
 */

::v-deep .u-flexCol {
  -webkit-box-orient: vertical !important;
  -webkit-box-direction: normal !important;
  flex-direction: column !important;
}

::v-deep .u-flexColReverse {
  -webkit-box-orient: vertical !important;
  -webkit-box-direction: reverse !important;
  flex-direction: column-reverse !important;
}

/**
 * Wrap
 */

::v-deep .u-flexWrap {
  flex-wrap: wrap !important;
}

::v-deep .u-flexNoWrap {
  flex-wrap: nowrap !important;
}

::v-deep .u-flexWrapReverse {
  flex-wrap: wrap-reverse !important;
}

/**
 * Align items along the main axis of the current line of the flex container
 */

::v-deep .u-flexJustifyStart {
  -webkit-box-pack: start !important;
  justify-content: flex-start !important;
}

::v-deep .u-flexJustifyEnd {
  -webkit-box-pack: end !important;
  justify-content: flex-end !important;
}

::v-deep .u-flexJustifyCenter {
  -webkit-box-pack: center !important;
  justify-content: center !important;
}

::v-deep .u-flexJustifyBetween {
  -webkit-box-pack: justify !important;
  justify-content: space-between !important;
}

::v-deep .u-flexJustifyAround {
  justify-content: space-around !important;
}

/**
 * Align items in the cross axis of the current line of the flex container
 * Similar to `justify-content` but in the perpendicular direction
 */

::v-deep .u-flexAlignItemsStart {
  -webkit-box-align: start !important;
  align-items: flex-start !important;
}

::v-deep .u-flexAlignItemsEnd {
  -webkit-box-align: end !important;
  align-items: flex-end !important;
}

::v-deep .u-flexAlignItemsCenter {
  -webkit-box-align: center !important;
  align-items: center !important;
}

::v-deep .u-flexAlignItemsStretch {
  -webkit-box-align: stretch !important;
  align-items: stretch !important;
}

::v-deep .u-flexAlignItemsBaseline {
  -webkit-box-align: baseline !important;
  align-items: baseline !important;
}

/**
 * Aligns items within the flex container when there is extra
 * space in the cross-axis
 *
 * Has no effect when there is only one line of flex items.
 */

::v-deep .u-flexAlignContentStart {
  align-content: flex-start !important;
}

::v-deep .u-flexAlignContentEnd {
  align-content: flex-end !important;
}

::v-deep .u-flexAlignContentCenter {
  align-content: center !important;
}

::v-deep .u-flexAlignContentStretch {
  align-content: stretch !important;
}

::v-deep .u-flexAlignContentBetween {
  align-content: space-between !important;
}

::v-deep .u-flexAlignContentAround {
  align-content: space-around !important;
}

/* Applies to flex items
   ========================================================================== */

/**
 * Override default alignment of single item when specified by `align-items`
 */

::v-deep .u-flexAlignSelfStart {
  align-self: flex-start !important;
}

::v-deep .u-flexAlignSelfEnd {
  align-self: flex-end !important;
}

::v-deep .u-flexAlignSelfCenter {
  align-self: center !important;
}

::v-deep .u-flexAlignSelfStretch {
  align-self: stretch !important;
}

::v-deep .u-flexAlignSelfBaseline {
  align-self: baseline !important;
}

::v-deep .u-flexAlignSelfAuto {
  align-self: auto !important;
}

/**
 * Change order without editing underlying HTML
 */

::v-deep .u-flexOrderFirst {
  -webkit-box-ordinal-group: 0 !important;
  order: -1 !important;
}

::v-deep .u-flexOrderLast {
  -webkit-box-ordinal-group: 2 !important;
  order: 1 !important;
}

::v-deep .u-flexOrderNone {
  -webkit-box-ordinal-group: 1 !important;
  order: 0 !important;
}

/**
 * Specify the flex grow factor, which determines how much the flex item will
 * grow relative to the rest of the flex items in the flex container.
 *
 * Supports 1-5 proportions
 *
 * 1. Provide all values to avoid IE10 bug with shorthand flex
 *    - http://git.io/vllC7
 *
 *    Use `0%` to avoid bug in IE10/11 with unitless flex basis. Using this
 *    instead of `auto` as this matches what the default would be with `flex`
 *    shorthand - http://git.io/vllWx
 */

::v-deep .u-flexGrow1 {
  -webkit-box-flex: 1 !important;
  flex: 1 1 0% !important;

  /* 1 */
}

::v-deep .u-flexGrow2 {
  -webkit-box-flex: 2 !important;
  flex: 2 1 0% !important;
}

::v-deep .u-flexGrow3 {
  -webkit-box-flex: 3 !important;
  flex: 3 1 0% !important;
}

::v-deep .u-flexGrow4 {
  -webkit-box-flex: 4 !important;
  flex: 4 1 0% !important;
}

::v-deep .u-flexGrow5 {
  -webkit-box-flex: 5 !important;
  flex: 5 1 0% !important;
}

/**
 * Specify the flex shrink factor, which determines how much the flex item will
 * shrink relative to the rest of the flex items in the flex container.
 */

::v-deep .u-flexShrink0 {
  flex-shrink: 0 !important;
}

::v-deep .u-flexShrink1 {
  flex-shrink: 1 !important;
}

::v-deep .u-flexShrink2 {
  flex-shrink: 2 !important;
}

::v-deep .u-flexShrink3 {
  flex-shrink: 3 !important;
}

::v-deep .u-flexShrink4 {
  flex-shrink: 4 !important;
}

::v-deep .u-flexShrink5 {
  flex-shrink: 5 !important;
}

/**
 * Aligning with `auto` margins
 * http://www.w3.org/TR/css-flexbox-1/#auto-margins
 */

::v-deep .u-flexExpand {
  margin: auto !important;
}

::v-deep .u-flexExpandLeft {
  margin-left: auto !important;
}

::v-deep .u-flexExpandRight {
  margin-right: auto !important;
}

::v-deep .u-flexExpandTop {
  margin-top: auto !important;
}

::v-deep .u-flexExpandBottom {
  margin-bottom: auto !important;
}

/**
 * Basis
 */

::v-deep .u-flexBasisAuto {
  flex-basis: auto !important;
}

::v-deep .u-flexBasis0 {
  flex-basis: 0 !important;
}

/*
 * Shorthand
 *
 * Declares all values instead of keywords like 'initial' to work around IE10
 * https://www.w3.org/TR/css-flexbox-1/#flex-common
 *
 * 1. Fixes issue in IE 10 where flex-basis is ignored - https://git.io/vllMt
 *    This ensures it overrides flex-basis set in other utilities.
 */

/*
 * Sizes the item based on the width/height properties
 */

::v-deep .u-flexInitial {
  -webkit-box-flex: 0 !important;
  flex: 0 1 auto !important;
  flex-basis: auto !important;

  /* 1 */
}

/*
 * Sizes the item based on the width/height properties, but makes them fully
 * flexible, so that they absorb any free space along the main axis.
 */

::v-deep .u-flexAuto {
  -webkit-box-flex: 1 !important;
  flex: 1 1 auto !important;
  flex-basis: auto !important;

  /* 1 */
}

/*
 * Sizes the item according to the width/height properties, but makes the flex
 * item fully inflexible. Similar to initial, except that flex items are
 * not allowed to shrink, even in overflow situations.
 */

::v-deep .u-flexNone {
  -webkit-box-flex: 0 !important;
  flex: 0 0 auto !important;
  flex-basis: auto !important;

  /* 1 */
}

/**
 * @define utilities
 * Size: breakpoint 1 (small)
 */

@media (min-width: 30em) {
  /* Applies to flex container
     ======================================================================== */

  /**
   * Container
   */

  ::v-deep .u-sm-flex {
    display: -webkit-box !important;
    display: flex !important;
  }

  ::v-deep .u-sm-flexInline {
    display: -webkit-inline-box !important;
    display: inline-flex !important;
  }

  /**
   * Direction: row
   */

  ::v-deep .u-sm-flexRow {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    flex-direction: row !important;
  }

  ::v-deep .u-sm-flexRowReverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    flex-direction: row-reverse !important;
  }

  /**
   * Direction: column
   */

  ::v-deep .u-sm-flexCol {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    flex-direction: column !important;
  }

  ::v-deep .u-sm-flexColReverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    flex-direction: column-reverse !important;
  }

  /**
   * Wrap
   */

  ::v-deep .u-sm-flexWrap {
    flex-wrap: wrap !important;
  }

  ::v-deep .u-sm-flexNoWrap {
    flex-wrap: nowrap !important;
  }

  ::v-deep .u-sm-flexWrapReverse {
    flex-wrap: wrap-reverse !important;
  }

  /**
   * Align items along the main axis of the current line of the flex container
   */

  ::v-deep .u-sm-flexJustifyStart {
    -webkit-box-pack: start !important;
    justify-content: flex-start !important;
  }

  ::v-deep .u-sm-flexJustifyEnd {
    -webkit-box-pack: end !important;
    justify-content: flex-end !important;
  }

  ::v-deep .u-sm-flexJustifyCenter {
    -webkit-box-pack: center !important;
    justify-content: center !important;
  }

  ::v-deep .u-sm-flexJustifyBetween {
    -webkit-box-pack: justify !important;
    justify-content: space-between !important;
  }

  ::v-deep .u-sm-flexJustifyAround {
    justify-content: space-around !important;
  }

  /**
   * Align items in the cross axis of the current line of the flex container
   * Similar to `justify-content` but in the perpendicular direction
   */

  ::v-deep .u-sm-flexAlignItemsStart {
    -webkit-box-align: start !important;
    align-items: flex-start !important;
  }

  ::v-deep .u-sm-flexAlignItemsEnd {
    -webkit-box-align: end !important;
    align-items: flex-end !important;
  }

  ::v-deep .u-sm-flexAlignItemsCenter {
    -webkit-box-align: center !important;
    align-items: center !important;
  }

  ::v-deep .u-sm-flexAlignItemsStretch {
    -webkit-box-align: stretch !important;
    align-items: stretch !important;
  }

  ::v-deep .u-sm-flexAlignItemsBaseline {
    -webkit-box-align: baseline !important;
    align-items: baseline !important;
  }

  /**
   * Aligns items within the flex container when there is extra
   * space in the cross-axis
   *
   * Has no effect when there is only one line of flex items.
   */

  ::v-deep .u-sm-flexAlignContentStart {
    align-content: flex-start !important;
  }

  ::v-deep .u-sm-flexAlignContentEnd {
    align-content: flex-end !important;
  }

  ::v-deep .u-sm-flexAlignContentCenter {
    align-content: center !important;
  }

  ::v-deep .u-sm-flexAlignContentStretch {
    align-content: stretch !important;
  }

  ::v-deep .u-sm-flexAlignContentBetween {
    align-content: space-between !important;
  }

  ::v-deep .u-sm-flexAlignContentAround {
    align-content: space-around !important;
  }

  /* Applies to flex items
     ======================================================================== */

  /**
   * Override default alignment of single item when specified by `align-items`
   */

  ::v-deep .u-sm-flexAlignSelfStart {
    align-self: flex-start !important;
  }

  ::v-deep .u-sm-flexAlignSelfEnd {
    align-self: flex-end !important;
  }

  ::v-deep .u-sm-flexAlignSelfCenter {
    align-self: center !important;
  }

  ::v-deep .u-sm-flexAlignSelfStretch {
    align-self: stretch !important;
  }

  ::v-deep .u-sm-flexAlignSelfBaseline {
    align-self: baseline !important;
  }

  ::v-deep .u-sm-flexAlignSelfAuto {
    align-self: auto !important;
  }

  /**
   * Change order without editing underlying HTML
   */

  ::v-deep .u-sm-flexOrderFirst {
    -webkit-box-ordinal-group: 0 !important;
    order: -1 !important;
  }

  ::v-deep .u-sm-flexOrderLast {
    -webkit-box-ordinal-group: 2 !important;
    order: 1 !important;
  }

  ::v-deep .u-sm-flexOrderNone {
    -webkit-box-ordinal-group: 1 !important;
    order: 0 !important;
  }

  /**
   * Specify the flex grow factor, which determines how much the flex item will
   * grow relative to the rest of the flex items in the flex container.
   *
   * Supports 1-5 proportions
   *
   * 1. Provide all values to avoid IE10 bug with shorthand flex
   *    http://git.io/vllC7
   *
   *    Use `0%` to avoid bug in IE10/11 with unitless flex basis
   *    http://git.io/vllWx
   */

  ::v-deep .u-sm-flexGrow1 {
    -webkit-box-flex: 1 !important;
    flex: 1 1 0% !important;

    /* 1 */
  }

  ::v-deep .u-sm-flexGrow2 {
    -webkit-box-flex: 2 !important;
    flex: 2 1 0% !important;
  }

  ::v-deep .u-sm-flexGrow3 {
    -webkit-box-flex: 3 !important;
    flex: 3 1 0% !important;
  }

  ::v-deep .u-sm-flexGrow4 {
    -webkit-box-flex: 4 !important;
    flex: 4 1 0% !important;
  }

  ::v-deep .u-sm-flexGrow5 {
    -webkit-box-flex: 5 !important;
    flex: 5 1 0% !important;
  }

  /**
   * Specify the flex shrink factor, which determines how much the flex item
   * will shrink relative to the rest of the flex items in the flex container.
   */

  ::v-deep .u-sm-flexShrink0 {
    flex-shrink: 0 !important;
  }

  ::v-deep .u-sm-flexShrink1 {
    flex-shrink: 1 !important;
  }

  ::v-deep .u-sm-flexShrink2 {
    flex-shrink: 2 !important;
  }

  ::v-deep .u-sm-flexShrink3 {
    flex-shrink: 3 !important;
  }

  ::v-deep .u-sm-flexShrink4 {
    flex-shrink: 4 !important;
  }

  ::v-deep .u-sm-flexShrink5 {
    flex-shrink: 5 !important;
  }

  /**
   * Aligning with `auto` margins
   * http://www.w3.org/TR/css-flexbox-1/#auto-margins
   */

  ::v-deep .u-sm-flexExpand {
    margin: auto !important;
  }

  ::v-deep .u-sm-flexExpandLeft {
    margin-left: auto !important;
  }

  ::v-deep .u-sm-flexExpandRight {
    margin-right: auto !important;
  }

  ::v-deep .u-sm-flexExpandTop {
    margin-top: auto !important;
  }

  ::v-deep .u-sm-flexExpandBottom {
    margin-bottom: auto !important;
  }

  /**
   * Basis
   */

  ::v-deep .u-sm-flexBasisAuto {
    flex-basis: auto !important;
  }

  ::v-deep .u-sm-flexBasis0 {
    flex-basis: 0 !important;
  }

  /*
   * Shorthand
   *
   * Declares all values instead of keywords like 'initial' to work around IE10
   * https://www.w3.org/TR/css-flexbox-1/#flex-common
   *
   * 1. Fixes issue in IE 10 where flex-basis is ignored - https://git.io/vllMt
   *    This ensures it overrides flex-basis set in other utilities.
   */

  /*
   * Sizes the item based on the width/height properties
   */

  ::v-deep .u-sm-flexInitial {
    -webkit-box-flex: 0 !important;
    flex: 0 1 auto !important;
    flex-basis: auto !important;

    /* 1 */
  }

  /*
   * Sizes the item based on the width/height properties, but makes them fully
   * flexible, so that they absorb any free space along the main axis.
   */

  ::v-deep .u-sm-flexAuto {
    -webkit-box-flex: 1 !important;
    flex: 1 1 auto !important;
    flex-basis: auto !important;

    /* 1 */
  }

  /*
   * Sizes the item according to the width/height properties, but makes the flex
   * item fully inflexible. Similar to initial, except that flex items are
   * not allowed to shrink, even in overflow situations.
   */

  ::v-deep .u-sm-flexNone {
    -webkit-box-flex: 0 !important;
    flex: 0 0 auto !important;
    flex-basis: auto !important;

    /* 1 */
  }
}

/**
 * @define utilities
 * Size: breakpoint 1 (medium)
 */

@media (min-width: 47em) {
  /* Applies to flex container
     ======================================================================== */

  /**
   * Container
   */

  ::v-deep .u-md-flex {
    display: -webkit-box !important;
    display: flex !important;
  }

  ::v-deep .u-md-flexInline {
    display: -webkit-inline-box !important;
    display: inline-flex !important;
  }

  /**
   * Direction: row
   */

  ::v-deep .u-md-flexRow {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    flex-direction: row !important;
  }

  ::v-deep .u-md-flexRowReverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    flex-direction: row-reverse !important;
  }

  /**
   * Direction: column
   */

  ::v-deep .u-md-flexCol {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    flex-direction: column !important;
  }

  ::v-deep .u-md-flexColReverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    flex-direction: column-reverse !important;
  }

  /**
   * Wrap
   */

  ::v-deep .u-md-flexWrap {
    flex-wrap: wrap !important;
  }

  ::v-deep .u-md-flexNoWrap {
    flex-wrap: nowrap !important;
  }

  ::v-deep .u-md-flexWrapReverse {
    flex-wrap: wrap-reverse !important;
  }

  /**
   * Align items along the main axis of the current line of the flex container
   */

  ::v-deep .u-md-flexJustifyStart {
    -webkit-box-pack: start !important;
    justify-content: flex-start !important;
  }

  ::v-deep .u-md-flexJustifyEnd {
    -webkit-box-pack: end !important;
    justify-content: flex-end !important;
  }

  ::v-deep .u-md-flexJustifyCenter {
    -webkit-box-pack: center !important;
    justify-content: center !important;
  }

  ::v-deep .u-md-flexJustifyBetween {
    -webkit-box-pack: justify !important;
    justify-content: space-between !important;
  }

  ::v-deep .u-md-flexJustifyAround {
    justify-content: space-around !important;
  }

  /**
   * Align items in the cross axis of the current line of the flex container
   * Similar to `justify-content` but in the perpendicular direction
   */

  ::v-deep .u-md-flexAlignItemsStart {
    -webkit-box-align: start !important;
    align-items: flex-start !important;
  }

  ::v-deep .u-md-flexAlignItemsEnd {
    -webkit-box-align: end !important;
    align-items: flex-end !important;
  }

  ::v-deep .u-md-flexAlignItemsCenter {
    -webkit-box-align: center !important;
    align-items: center !important;
  }

  ::v-deep .u-md-flexAlignItemsStretch {
    -webkit-box-align: stretch !important;
    align-items: stretch !important;
  }

  ::v-deep .u-md-flexAlignItemsBaseline {
    -webkit-box-align: baseline !important;
    align-items: baseline !important;
  }

  /**
   * Aligns items within the flex container when there is extra
   * space in the cross-axis
   *
   * Has no effect when there is only one line of flex items.
   */

  ::v-deep u-md-flexAlignContentStart {
    align-content: flex-start !important;
  }

  ::v-deep .u-md-flexAlignContentEnd {
    align-content: flex-end !important;
  }

  ::v-deep .u-md-flexAlignContentCenter {
    align-content: center !important;
  }

  ::v-deep .u-md-flexAlignContentStretch {
    align-content: stretch !important;
  }

  ::v-deep .u-md-flexAlignContentBetween {
    align-content: space-between !important;
  }

  ::v-deep .u-md-flexAlignContentAround {
    align-content: space-around !important;
  }

  /* Applies to flex items
     ======================================================================== */

  /**
   * Override default alignment of single item when specified by `align-items`
   */

  ::v-deep .u-md-flexAlignSelfStart {
    align-self: flex-start !important;
  }

  ::v-deep .u-md-flexAlignSelfEnd {
    align-self: flex-end !important;
  }

  ::v-deep .u-md-flexAlignSelfCenter {
    align-self: center !important;
  }

  ::v-deep .u-md-flexAlignSelfStretch {
    align-self: stretch !important;
  }

  ::v-deep .u-md-flexAlignSelfBaseline {
    align-self: baseline !important;
  }

  ::v-deep .u-md-flexAlignSelfAuto {
    align-self: auto !important;
  }

  /**
   * Change order without editing underlying HTML
   */

  ::v-deep .u-md-flexOrderFirst {
    -webkit-box-ordinal-group: 0 !important;
    order: -1 !important;
  }

  ::v-deep .u-md-flexOrderLast {
    -webkit-box-ordinal-group: 2 !important;
    order: 1 !important;
  }

  ::v-deep .u-md-flexOrderNone {
    -webkit-box-ordinal-group: 1 !important;
    order: 0 !important;
  }

  /**
   * Specify the flex grow factor, which determines how much the flex item will
   * grow relative to the rest of the flex items in the flex container.
   *
   * Supports 1-5 proportions
   *
   * 1. Provide all values to avoid IE10 bug with shorthand flex
   *    http://git.io/vllC7
   *
   *    Use `0%` to avoid bug in IE10/11 with unitless flex basis
   *    http://git.io/vllWx
   */

  ::v-deep .u-md-flexGrow1 {
    -webkit-box-flex: 1 !important;
    flex: 1 1 0% !important;

    /* 1 */
  }

  ::v-deep .u-md-flexGrow2 {
    -webkit-box-flex: 2 !important;
    flex: 2 1 0% !important;
  }

  ::v-deep .u-md-flexGrow3 {
    -webkit-box-flex: 3 !important;
    flex: 3 1 0% !important;
  }

  ::v-deep .u-md-flexGrow4 {
    -webkit-box-flex: 4 !important;
    flex: 4 1 0% !important;
  }

  ::v-deep .u-md-flexGrow5 {
    -webkit-box-flex: 5 !important;
    flex: 5 1 0% !important;
  }

  /**
   * Specify the flex shrink factor, which determines how much the flex item
   * will shrink relative to the rest of the flex items in the flex container.
   */

  ::v-deep .u-md-flexShrink0 {
    flex-shrink: 0 !important;
  }

  ::v-deep .u-md-flexShrink1 {
    flex-shrink: 1 !important;
  }

  ::v-deep .u-md-flexShrink2 {
    flex-shrink: 2 !important;
  }

  ::v-deep .u-md-flexShrink3 {
    flex-shrink: 3 !important;
  }

  ::v-deep .u-md-flexShrink4 {
    flex-shrink: 4 !important;
  }

  ::v-deep .u-md-flexShrink5 {
    flex-shrink: 5 !important;
  }

  /**
   * Aligning with `auto` margins
   * http://www.w3.org/TR/css-flexbox-1/#auto-margins
   */

  ::v-deep .u-md-flexExpand {
    margin: auto !important;
  }

  ::v-deep .u-md-flexExpandLeft {
    margin-left: auto !important;
  }

  ::v-deep .u-md-flexExpandRight {
    margin-right: auto !important;
  }

  ::v-deep .u-md-flexExpandTop {
    margin-top: auto !important;
  }

  ::v-deep .u-md-flexExpandBottom {
    margin-bottom: auto !important;
  }

  /**
   * Basis
   */

  ::v-deep .u-md-flexBasisAuto {
    flex-basis: auto !important;
  }

  ::v-deep .u-md-flexBasis0 {
    flex-basis: 0 !important;
  }

  /*
   * Shorthand
   *
   * Declares all values instead of keywords like 'initial' to work around IE10
   * https://www.w3.org/TR/css-flexbox-1/#flex-common
   *
   * 1. Fixes issue in IE 10 where flex-basis is ignored - https://git.io/vllMt
   *    This ensures it overrides flex-basis set in other utilities.
   */

  /*
   * Sizes the item based on the width/height properties
   */

  ::v-deep .u-md-flexInitial {
    -webkit-box-flex: 0 !important;
    flex: 0 1 auto !important;
    flex-basis: auto !important;

    /* 1 */
  }

  /*
   * Sizes the item based on the width/height properties, but makes them fully
   * flexible, so that they absorb any free space along the main axis.
   */

  ::v-deep .u-md-flexAuto {
    -webkit-box-flex: 1 !important;
    flex: 1 1 auto !important;
    flex-basis: auto !important;

    /* 1 */
  }

  /*
   * Sizes the item according to the width/height properties, but makes the flex
   * item fully inflexible. Similar to initial, except that flex items are
   * not allowed to shrink, even in overflow situations.
   */

  ::v-deep .u-md-flexNone {
    -webkit-box-flex: 0 !important;
    flex: 0 0 auto !important;
    flex-basis: auto !important;

    /* 1 */
  }
}

/**
 * @define utilities
 * Size: breakpoint 1 (large)
 */

@media (min-width: 64em) {
  /* Applies to flex container
     ======================================================================== */

  /**
   * Container
   */

  ::v-deep .u-lg-flex {
    display: -webkit-box !important;
    display: flex !important;
  }

  ::v-deep .u-lg-flexInline {
    display: -webkit-inline-box !important;
    display: inline-flex !important;
  }

  /**
   * Direction: row
   */

  ::v-deep .u-lg-flexRow {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    flex-direction: row !important;
  }

  ::v-deep .u-lg-flexRowReverse {
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: reverse !important;
    flex-direction: row-reverse !important;
  }

  /**
   * Direction: column
   */

  ::v-deep .u-lg-flexCol {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: normal !important;
    flex-direction: column !important;
  }

  ::v-deep .u-lg-flexColReverse {
    -webkit-box-orient: vertical !important;
    -webkit-box-direction: reverse !important;
    flex-direction: column-reverse !important;
  }

  /**
   * Wrap
   */

  ::v-deep .u-lg-flexWrap {
    flex-wrap: wrap !important;
  }

  ::v-deep .u-lg-flexNoWrap {
    flex-wrap: nowrap !important;
  }

  ::v-deep .u-lg-flexWrapReverse {
    flex-wrap: wrap-reverse !important;
  }

  /**
   * Align items along the main axis of the current line of the flex container
   */

  ::v-deep .u-lg-flexJustifyStart {
    -webkit-box-pack: start !important;
    justify-content: flex-start !important;
  }

  ::v-deep .u-lg-flexJustifyEnd {
    -webkit-box-pack: end !important;
    justify-content: flex-end !important;
  }

  ::v-deep .u-lg-flexJustifyCenter {
    -webkit-box-pack: center !important;
    justify-content: center !important;
  }

  ::v-deep .u-lg-flexJustifyBetween {
    -webkit-box-pack: justify !important;
    justify-content: space-between !important;
  }

  ::v-deep .u-lg-flexJustifyAround {
    justify-content: space-around !important;
  }

  /**
   * Align items in the cross axis of the current line of the flex container
   * Similar to `justify-content` but in the perpendicular direction
   */

  ::v-deep .u-lg-flexAlignItemsStart {
    -webkit-box-align: start !important;
    align-items: flex-start !important;
  }

  ::v-deep .u-lg-flexAlignItemsEnd {
    -webkit-box-align: end !important;
    align-items: flex-end !important;
  }

  ::v-deep .u-lg-flexAlignItemsCenter {
    -webkit-box-align: center !important;
    align-items: center !important;
  }

  ::v-deep .u-lg-flexAlignItemsStretch {
    -webkit-box-align: stretch !important;
    align-items: stretch !important;
  }

  ::v-deep .u-lg-flexAlignItemsBaseline {
    -webkit-box-align: baseline !important;
    align-items: baseline !important;
  }

  /**
   * Aligns items within the flex container when there is extra
   * space in the cross-axis
   *
   * Has no effect when there is only one line of flex items.
   */

  ::v-deep .u-lg-flexAlignContentStart {
    align-content: flex-start !important;
  }

  ::v-deep .u-lg-flexAlignContentEnd {
    align-content: flex-end !important;
  }

  ::v-deep .u-lg-flexAlignContentCenter {
    align-content: center !important;
  }

  ::v-deep .u-lg-flexAlignContentStretch {
    align-content: stretch !important;
  }

  ::v-deep .u-lg-flexAlignContentBetween {
    align-content: space-between !important;
  }

  ::v-deep .u-lg-flexAlignContentAround {
    align-content: space-around !important;
  }

  /* Applies to flex items
     ======================================================================== */

  /**
   * Override default alignment of single item when specified by `align-items`
   */

  ::v-deep .u-lg-flexAlignSelfStart {
    align-self: flex-start !important;
  }

  ::v-deep .u-lg-flexAlignSelfEnd {
    align-self: flex-end !important;
  }

  ::v-deep .u-lg-flexAlignSelfCenter {
    align-self: center !important;
  }

  ::v-deep .u-lg-flexAlignSelfStretch {
    align-self: stretch !important;
  }

  ::v-deep .u-lg-flexAlignSelfBaseline {
    align-self: baseline !important;
  }

  ::v-deep .u-lg-flexAlignSelfAuto {
    align-self: auto !important;
  }

  /**
   * Change order without editing underlying HTML
   */

  ::v-deep .u-lg-flexOrderFirst {
    -webkit-box-ordinal-group: 0 !important;
    order: -1 !important;
  }

  ::v-deep .u-lg-flexOrderLast {
    -webkit-box-ordinal-group: 2 !important;
    order: 1 !important;
  }

  ::v-deep .u-lg-flexOrderNone {
    -webkit-box-ordinal-group: 1 !important;
    order: 0 !important;
  }

  /**
   * Specify the flex grow factor, which determines how much the flex item will
   * grow relative to the rest of the flex items in the flex container.
   *
   * Supports 1-5 proportions
   *
   * 1. Provide all values to avoid IE10 bug with shorthand flex
   *    http://git.io/vllC7
   *
   *    Use `0%` to avoid bug in IE10/11 with unitless flex basis
   *    http://git.io/vllWx
   */

  ::v-deep .u-lg-flexGrow1 {
    -webkit-box-flex: 1 !important;
    flex: 1 1 0% !important;

    /* 1 */
  }

  ::v-deep .u-lg-flexGrow2 {
    -webkit-box-flex: 2 !important;
    flex: 2 1 0% !important;
  }

  ::v-deep .u-lg-flexGrow3 {
    -webkit-box-flex: 3 !important;
    flex: 3 1 0% !important;
  }

  ::v-deep .u-lg-flexGrow4 {
    -webkit-box-flex: 4 !important;
    flex: 4 1 0% !important;
  }

  ::v-deep .u-lg-flexGrow5 {
    -webkit-box-flex: 5 !important;
    flex: 5 1 0% !important;
  }

  /**
   * Specify the flex shrink factor, which determines how much the flex item
   * will shrink relative to the rest of the flex items in the flex container.
   */

  ::v-deep .u-lg-flexShrink0 {
    flex-shrink: 0 !important;
  }

  ::v-deep .u-lg-flexShrink1 {
    flex-shrink: 1 !important;
  }

  ::v-deep .u-lg-flexShrink2 {
    flex-shrink: 2 !important;
  }

  ::v-deep .u-lg-flexShrink3 {
    flex-shrink: 3 !important;
  }

  ::v-deep .u-lg-flexShrink4 {
    flex-shrink: 4 !important;
  }

  ::v-deep .u-lg-flexShrink5 {
    flex-shrink: 5 !important;
  }

  /**
   * Aligning with `auto` margins
   * http://www.w3.org/TR/css-flexbox-1/#auto-margins
   */

  ::v-deep .u-lg-flexExpand {
    margin: auto !important;
  }

  ::v-deep .u-lg-flexExpandLeft {
    margin-left: auto !important;
  }

  ::v-deep .u-lg-flexExpandRight {
    margin-right: auto !important;
  }

  ::v-deep .u-lg-flexExpandTop {
    margin-top: auto !important;
  }

  ::v-deep .u-lg-flexExpandBottom {
    margin-bottom: auto !important;
  }

  /**
   * Basis
   */

  ::v-deep .u-lg-flexBasisAuto {
    flex-basis: auto !important;
  }

  ::v-deep .u-lg-flexBasis0 {
    flex-basis: 0 !important;
  }

  /*
   * Shorthand
   *
   * Declares all values instead of keywords like 'initial' to work around IE10
   * https://www.w3.org/TR/css-flexbox-1/#flex-common
   *
   * 1. Fixes issue in IE 10 where flex-basis is ignored - https://git.io/vllMt
   *    This ensures it overrides flex-basis set in other utilities.
   */

  /*
   * Sizes the item based on the width/height properties
   */

  ::v-deep .u-lg-flexInitial {
    -webkit-box-flex: 0 !important;
    flex: 0 1 auto !important;
    flex-basis: auto !important;

    /* 1 */
  }

  /*
   * Sizes the item based on the width/height properties, but makes them fully
   * flexible, so that they absorb any free space along the main axis.
   */

  ::v-deep .u-lg-flexAuto {
    -webkit-box-flex: 1 !important;
    flex: 1 1 auto !important;
    flex-basis: auto !important;

    /* 1 */
  }

  /*
   * Sizes the item according to the width/height properties, but makes the flex
   * item fully inflexible. Similar to initial, except that flex items are
   * not allowed to shrink, even in overflow situations.
   */

  ::v-deep .u-lg-flexNone {
    -webkit-box-flex: 0 !important;
    flex: 0 0 auto !important;
    flex-basis: auto !important;

    /* 1 */
  }
}

::v-deep .u-flexExpandEnds {
  margin-bottom: auto !important;
  margin-top: auto !important;
}

::v-deep .u-flexExpandSides {
  margin-left: auto !important;
  margin-right: auto !important;
}

@media (min-width: 30em) {
  ::v-deep .u-sm-flexExpandEnds {
    margin-bottom: auto !important;
    margin-top: auto !important;
  }

  ::v-deep .u-sm-flexExpandSides {
    margin-left: auto !important;
    margin-right: auto !important;
  }
}

@media (min-width: 47em) {
  ::v-deep .u-md-flexExpandEnds {
    margin-bottom: auto !important;
    margin-top: auto !important;
  }

  ::v-deep .u-md-flexExpandSides {
    margin-left: auto !important;
    margin-right: auto !important;
  }
}

@media (min-width: 64em) {
  ::v-deep .u-lg-flexExpandEnds {
    margin-bottom: auto !important;
    margin-top: auto !important;
  }

  ::v-deep .u-lg-flexExpandSides {
    margin-left: auto !important;
    margin-right: auto !important;
  }
}

/**
 * @define utilities
 */

::v-deep .u-linkClean {
  color: inherit !important;
  text-decoration: inherit !important;

  &:hover, &:focus, &:active {
    color: inherit !important;
    text-decoration: inherit !important;
  }
}

::v-deep .u-linkModest:not(:hover):not(:focus):not(:active) {
  color: inherit !important;
  text-decoration: inherit !important;
}

/**
 * @define utilities
 */

/**
 * Reset default list appearance.
 */

::v-deep .u-listReset {
  list-style: none;
  padding-left: 0;
}

::v-deep .u-listInline {
  list-style: none;
  padding-left: 0;

  > * {
    display: inline-block;

    &:not(:last-child) {
      margin-right: 0.579em;
    }
  }
}

/**
 * Because the inline list use case is so simple, we're going to fudge our
 * selector depth rule in favor of usability.
 *
 * Alternatively we could set flex display on the parent, but then the list
 * wouldn't respect text alignment, which seems counter-intuitive for this
 * particular case.
 */

/* stylelint-disable plugin/selector-bem-pattern */

/**
 * Gap between items. This favors left positioning, but because items are likely
 * of varying lengths the differences will be hard to perceive.
 */

/* stylelint-enable */

/**
 * @define utilities
 */

/**
 * @define utilities
 * Sizing utilities
 */

/* Proportional widths
   ========================================================================== */

/**
 * Specify the proportional width of an object.
 * Intentional redundancy build into each set of unit classes.
 * Supports: 2, 3, 4, 5, 6, 8, 10, 12 part
 *
 * 1. Use `flex-basis: auto` with a width to avoid box-sizing bug in IE10/11
 *    http://git.io/vllMD
 */

::v-deep .u-size1of12 {
  flex-basis: auto !important;
  width: 8.33333% !important;
}

::v-deep .u-size1of10 {
  flex-basis: auto !important;
  width: 10% !important;
}

::v-deep .u-size1of8 {
  flex-basis: auto !important;
  width: 12.5% !important;
}

::v-deep .u-size1of6,
  ::v-deep .u .u-size2of12 {
  flex-basis: auto !important;
  width: 16.66667% !important;
}

::v-deep .u-size1of5,
  ::v-deep .u .u-size2of10 {
  flex-basis: auto !important;
  width: 20% !important;
}

::v-deep .u-size1of4,
  ::v-deep .u .u-size2of8,
  ::v-deep .u .u-size3of12 {
  flex-basis: auto !important;
  width: 25% !important;
}

::v-deep .u-size3of10 {
  flex-basis: auto !important;
  width: 30% !important;
}

::v-deep .u-size1of3,
  ::v-deep .u .u-size2of6,
  ::v-deep .u .u-size4of12 {
  flex-basis: auto !important;
  width: 33.33333% !important;
}

::v-deep .u-size3of8 {
  flex-basis: auto !important;
  width: 37.5% !important;
}

::v-deep .u-size2of5,
  ::v-deep .u .u-size4of10 {
  flex-basis: auto !important;
  width: 40% !important;
}

::v-deep .u-size5of12 {
  flex-basis: auto !important;
  width: 41.66667% !important;
}

::v-deep .u-size1of2,
  ::v-deep .u .u-size2of4,
  ::v-deep .u .u-size3of6,
  ::v-deep .u .u-size4of8,
  ::v-deep .u .u-size5of10,
  ::v-deep .u .u-size6of12 {
  flex-basis: auto !important;
  width: 50% !important;
}

::v-deep .u-size7of12 {
  flex-basis: auto !important;
  width: 58.33333% !important;
}

::v-deep .u-size3of5,
  ::v-deep .u .u-size6of10 {
  flex-basis: auto !important;
  width: 60% !important;
}

::v-deep .u-size5of8 {
  flex-basis: auto !important;
  width: 62.5% !important;
}

::v-deep .u-size2of3,
  ::v-deep .u .u-size4of6,
  ::v-deep .u .u-size8of12 {
  flex-basis: auto !important;
  width: 66.66667% !important;
}

::v-deep .u-size7of10 {
  flex-basis: auto !important;
  width: 70% !important;
}

::v-deep .u-size3of4,
  ::v-deep .u .u-size6of8,
  ::v-deep .u .u-size9of12 {
  flex-basis: auto !important;
  width: 75% !important;
}

::v-deep .u-size4of5,
  ::v-deep .u .u-size8of10 {
  flex-basis: auto !important;
  width: 80% !important;
}

::v-deep .u-size5of6,
  ::v-deep .u .u-size10of12 {
  flex-basis: auto !important;
  width: 83.33333% !important;
}

::v-deep .u-size7of8 {
  flex-basis: auto !important;
  width: 87.5% !important;
}

::v-deep .u-size9of10 {
  flex-basis: auto !important;
  width: 90% !important;
}

::v-deep .u-size11of12 {
  flex-basis: auto !important;
  width: 91.66667% !important;
}

/* Intrinsic widths
   ========================================================================== */

/**
 * Make an element shrink wrap its content.
 */

::v-deep .u-sizeFit {
  flex-basis: auto !important;
}

/**
 * Make an element fill the remaining space.
 *
 * 1. Be explicit to work around IE10 bug with shorthand flex
 *    http://git.io/vllC7
 * 2. IE10 ignores previous `flex-basis` value. Setting again here fixes
 *    http://git.io/vllMt
 */

::v-deep .u-sizeFill {
  -webkit-box-flex: 1 !important;
  flex: 1 1 0% !important;

  /* 1 */
  flex-basis: 0% !important;

  /* 2 */
}

/**
 * An alternative method to make an element fill the remaining space.
 * Distributes space based on the initial width and height of the element
 *
 * http://www.w3.org/TR/css-flexbox/images/rel-vs-abs-flex.svg
 */

::v-deep .u-sizeFillAlt {
  -webkit-box-flex: 1 !important;
  flex: 1 1 auto !important;
  flex-basis: auto !important;
}

/**
 * Make an element the width of its parent.
 */

::v-deep .u-sizeFull {
  width: 100% !important;
}

/**
 * @define utilities
 * Size: breakpoint 1 (small)
 */

@media (min-width: 30em) {
  /* Proportional widths: breakpoint 1 (small)
     ======================================================================== */

  /**
   * Specify the proportional width of an object.
   * Intentional redundancy build into each set of unit classes.
   * Supports: 2, 3, 4, 5, 6, 8, 10, 12 part
   *
   * 1. Use `flex-basis: auto` with a width to avoid box-sizing bug in IE10/11
   *    http://git.io/vllMD
   */

  ::v-deep .u-sm-size1of12 {
    flex-basis: auto !important;
    width: 8.33333% !important;
  }

  ::v-deep .u-sm-size1of10 {
    flex-basis: auto !important;
    width: 10% !important;
  }

  ::v-deep .u-sm-size1of8 {
    flex-basis: auto !important;
    width: 12.5% !important;
  }

  ::v-deep .u-sm-size1of6,
  ::v-deep .u .u-sm-size2of12 {
    flex-basis: auto !important;
    width: 16.66667% !important;
  }

  ::v-deep .u-sm-size1of5,
  ::v-deep .u .u-sm-size2of10 {
    flex-basis: auto !important;
    width: 20% !important;
  }

  ::v-deep .u-sm-size1of4,
  ::v-deep .u .u-sm-size2of8,
  ::v-deep .u .u-sm-size3of12 {
    flex-basis: auto !important;
    width: 25% !important;
  }

  ::v-deep .u-sm-size3of10 {
    flex-basis: auto !important;
    width: 30% !important;
  }

  ::v-deep .u-sm-size1of3,
  ::v-deep .u .u-sm-size2of6,
  ::v-deep .u .u-sm-size4of12 {
    flex-basis: auto !important;
    width: 33.33333% !important;
  }

  ::v-deep .u-sm-size3of8 {
    flex-basis: auto !important;
    width: 37.5% !important;
  }

  ::v-deep .u-sm-size2of5,
  ::v-deep .u .u-sm-size4of10 {
    flex-basis: auto !important;
    width: 40% !important;
  }

  ::v-deep .u-sm-size5of12 {
    flex-basis: auto !important;
    width: 41.66667% !important;
  }

  ::v-deep .u-sm-size1of2,
  ::v-deep .u .u-sm-size2of4,
  ::v-deep .u .u-sm-size3of6,
  ::v-deep .u .u-sm-size4of8,
  ::v-deep .u .u-sm-size5of10,
  ::v-deep .u .u-sm-size6of12 {
    flex-basis: auto !important;
    width: 50% !important;
  }

  ::v-deep .u-sm-size7of12 {
    flex-basis: auto !important;
    width: 58.33333% !important;
  }

  ::v-deep .u-sm-size3of5,
  ::v-deep .u .u-sm-size6of10 {
    flex-basis: auto !important;
    width: 60% !important;
  }

  ::v-deep .u-sm-size5of8 {
    flex-basis: auto !important;
    width: 62.5% !important;
  }

  ::v-deep .u-sm-size2of3,
  ::v-deep .u .u-sm-size4of6,
  ::v-deep .u .u-sm-size8of12 {
    flex-basis: auto !important;
    width: 66.66667% !important;
  }

  ::v-deep .u-sm-size7of10 {
    flex-basis: auto !important;
    width: 70% !important;
  }

  ::v-deep .u-sm-size3of4,
  ::v-deep .u .u-sm-size6of8,
  ::v-deep .u .u-sm-size9of12 {
    flex-basis: auto !important;
    width: 75% !important;
  }

  ::v-deep .u-sm-size4of5,
  ::v-deep .u .u-sm-size8of10 {
    flex-basis: auto !important;
    width: 80% !important;
  }

  ::v-deep .u-sm-size5of6,
  ::v-deep .u .u-sm-size10of12 {
    flex-basis: auto !important;
    width: 83.33333% !important;
  }

  ::v-deep .u-sm-size7of8 {
    flex-basis: auto !important;
    width: 87.5% !important;
  }

  ::v-deep .u-sm-size9of10 {
    flex-basis: auto !important;
    width: 90% !important;
  }

  ::v-deep .u-sm-size11of12 {
    flex-basis: auto !important;
    width: 91.66667% !important;
  }

  /* Intrinsic widths
     ======================================================================== */

  /**
   * Make an element shrink wrap its content.
   */

  ::v-deep .u-sm-sizeFit {
    flex-basis: auto !important;
    width: auto !important;
  }

  /**
   * Make an element fill the remaining space.
   *
   * 1. Be explicit to work around IE10 bug with shorthand flex
   *    http://git.io/vllC7
   * 2. IE10 ignores previous `flex-basis` value. Setting again here fixes
   *    http://git.io/vllMt
   */

  ::v-deep .u-sm-sizeFill {
    -webkit-box-flex: 1 !important;
    flex: 1 1 0% !important;

    /* 1 */
    flex-basis: 0% !important;

    /* 2 */
  }

  /**
   * An alternative method to make an element fill the remaining space.
   * Distributes space based on the initial width and height of the element
   *
   * http://www.w3.org/TR/css-flexbox/images/rel-vs-abs-flex.svg
   */

  ::v-deep .u-sm-sizeFillAlt {
    -webkit-box-flex: 1 !important;
    flex: 1 1 auto !important;
    flex-basis: auto !important;
  }

  /**
   * Make an element the width of its parent.
   */

  ::v-deep .u-sm-sizeFull {
    width: 100% !important;
  }
}

/**
 * @define utilities
 * Size: breakpoint 2 (medium)
 */

@media (min-width: 47em) {
  /* Proportional widths: breakpoint 2 (medium)
     ======================================================================== */

  /**
   * Specify the proportional width of an object.
   * Intentional redundancy build into each set of unit classes.
   * Supports: 2, 3, 4, 5, 6, 8, 10, 12 part
   *
   * 1. Use `flex-basis: auto` with a width to avoid box-sizing bug in IE10/11
   *    http://git.io/vllMD
   */

  /* postcss-bem-linter: ignore */

  ::v-deep .u-md-size1of12 {
    flex-basis: auto !important;
    width: 8.33333% !important;
  }

  ::v-deep .u-md-size1of10 {
    flex-basis: auto !important;
    width: 10% !important;
  }

  ::v-deep .u-md-size1of8 {
    flex-basis: auto !important;
    width: 12.5% !important;
  }

  ::v-deep .u-md-size1of6,
  ::v-deep .u .u-md-size2of12 {
    flex-basis: auto !important;
    width: 16.66667% !important;
  }

  ::v-deep .u-md-size1of5,
  ::v-deep .u .u-md-size2of10 {
    flex-basis: auto !important;
    width: 20% !important;
  }

  ::v-deep .u-md-size1of4,
  ::v-deep .u .u-md-size2of8,
  ::v-deep .u .u-md-size3of12 {
    flex-basis: auto !important;
    width: 25% !important;
  }

  ::v-deep .u-md-size3of10 {
    flex-basis: auto !important;
    width: 30% !important;
  }

  ::v-deep .u-md-size1of3,
  ::v-deep .u .u-md-size2of6,
  ::v-deep .u .u-md-size4of12 {
    flex-basis: auto !important;
    width: 33.33333% !important;
  }

  ::v-deep .u-md-size3of8 {
    flex-basis: auto !important;
    width: 37.5% !important;
  }

  ::v-deep .u-md-size2of5,
  ::v-deep .u .u-md-size4of10 {
    flex-basis: auto !important;
    width: 40% !important;
  }

  ::v-deep .u-md-size5of12 {
    flex-basis: auto !important;
    width: 41.66667% !important;
  }

  ::v-deep .u-md-size1of2,
  ::v-deep .u .u-md-size2of4,
  ::v-deep .u .u-md-size3of6,
  ::v-deep .u .u-md-size4of8,
  ::v-deep .u .u-md-size5of10,
  ::v-deep .u .u-md-size6of12 {
    flex-basis: auto !important;
    width: 50% !important;
  }

  ::v-deep .u-md-size7of12 {
    flex-basis: auto !important;
    width: 58.33333% !important;
  }

  ::v-deep .u-md-size3of5,
  ::v-deep .u .u-md-size6of10 {
    flex-basis: auto !important;
    width: 60% !important;
  }

  ::v-deep .u-md-size5of8 {
    flex-basis: auto !important;
    width: 62.5% !important;
  }

  ::v-deep .u-md-size2of3,
  ::v-deep .u .u-md-size4of6,
  ::v-deep .u .u-md-size8of12 {
    flex-basis: auto !important;
    width: 66.66667% !important;
  }

  ::v-deep .u-md-size7of10 {
    flex-basis: auto !important;
    width: 70% !important;
  }

  ::v-deep .u-md-size3of4,
  ::v-deep .u .u-md-size6of8,
  ::v-deep .u .u-md-size9of12 {
    flex-basis: auto !important;
    width: 75% !important;
  }

  ::v-deep .u-md-size4of5,
  ::v-deep .u .u-md-size8of10 {
    flex-basis: auto !important;
    width: 80% !important;
  }

  ::v-deep .u-md-size5of6,
  ::v-deep .u .u-md-size10of12 {
    flex-basis: auto !important;
    width: 83.33333% !important;
  }

  ::v-deep .u-md-size7of8 {
    flex-basis: auto !important;
    width: 87.5% !important;
  }

  ::v-deep .u-md-size9of10 {
    flex-basis: auto !important;
    width: 90% !important;
  }

  ::v-deep .u-md-size11of12 {
    flex-basis: auto !important;
    width: 91.66667% !important;
  }

  /* Intrinsic widths
     ======================================================================== */

  /**
   * Make an element shrink wrap its content.
   */

  ::v-deep .u-md-sizeFit {
    flex-basis: auto !important;
    width: auto !important;
  }

  /**
   * Make an element fill the remaining space.
   *
   * 1. Be explicit to work around IE10 bug with shorthand flex
   *    http://git.io/vllC7
   * 2. IE10 ignores previous `flex-basis` value. Setting again here fixes
   *    http://git.io/vllMt
   */

  ::v-deep .u-md-sizeFill {
    -webkit-box-flex: 1 !important;
    flex: 1 1 0% !important;

    /* 1 */
    flex-basis: 0% !important;

    /* 2 */
  }

  /**
   * An alternative method to make an element fill the remaining space.
   * Distributes space based on the initial width and height of the element
   *
   * http://www.w3.org/TR/css-flexbox/images/rel-vs-abs-flex.svg
   */

  ::v-deep .u-md-sizeFillAlt {
    -webkit-box-flex: 1 !important;
    flex: 1 1 auto !important;
    flex-basis: auto !important;
  }

  /**
   * Make an element the width of its parent.
   */

  ::v-deep .u-md-sizeFull {
    width: 100% !important;
  }
}

/**
 * @define utilities
 * Size: breakpoint 3 (large)
 */

@media (min-width: 64em) {
  /* Proportional widths: breakpoint 3 (large)
     ======================================================================== */

  /**
   * Specify the proportional width of an object.
   * Intentional redundancy build into each set of unit classes.
   * Supports: 2, 3, 4, 5, 6, 8, 10, 12 part
   *
   * 1. Use `flex-basis: auto` with a width to avoid box-sizing bug in IE10/11
   *    http://git.io/vllMD
   */

  ::v-deep .u-lg-size1of12 {
    flex-basis: auto !important;
    width: 8.33333% !important;
  }

  ::v-deep .u-lg-size1of10 {
    flex-basis: auto !important;
    width: 10% !important;
  }

  ::v-deep .u-lg-size1of8 {
    flex-basis: auto !important;
    width: 12.5% !important;
  }

  ::v-deep .u-lg-size1of6,
  ::v-deep .u .u-lg-size2of12 {
    flex-basis: auto !important;
    width: 16.66667% !important;
  }

  ::v-deep .u-lg-size1of5,
  ::v-deep .u .u-lg-size2of10 {
    flex-basis: auto !important;
    width: 20% !important;
  }

  ::v-deep .u-lg-size1of4,
  ::v-deep .u .u-lg-size2of8,
  ::v-deep .u .u-lg-size3of12 {
    flex-basis: auto !important;
    width: 25% !important;
  }

  ::v-deep .u-lg-size3of10 {
    flex-basis: auto !important;
    width: 30% !important;
  }

  ::v-deep .u-lg-size1of3,
  ::v-deep .u .u-lg-size2of6,
  ::v-deep .u .u-lg-size4of12 {
    flex-basis: auto !important;
    width: 33.33333% !important;
  }

  ::v-deep .u-lg-size3of8 {
    flex-basis: auto !important;
    width: 37.5% !important;
  }

  ::v-deep .u-lg-size2of5,
  ::v-deep .u .u-lg-size4of10 {
    flex-basis: auto !important;
    width: 40% !important;
  }

  ::v-deep .u-lg-size5of12 {
    flex-basis: auto !important;
    width: 41.66667% !important;
  }

  ::v-deep .u-lg-size1of2,
  ::v-deep .u .u-lg-size2of4,
  ::v-deep .u .u-lg-size3of6,
  ::v-deep .u .u-lg-size4of8,
  ::v-deep .u .u-lg-size5of10,
  ::v-deep .u .u-lg-size6of12 {
    flex-basis: auto !important;
    width: 50% !important;
  }

  ::v-deep .u-lg-size7of12 {
    flex-basis: auto !important;
    width: 58.33333% !important;
  }

  ::v-deep .u-lg-size3of5,
  ::v-deep .u .u-lg-size6of10 {
    flex-basis: auto !important;
    width: 60% !important;
  }

  ::v-deep .u-lg-size5of8 {
    flex-basis: auto !important;
    width: 62.5% !important;
  }

  ::v-deep .u-lg-size2of3,
  ::v-deep .u .u-lg-size4of6,
  ::v-deep .u .u-lg-size8of12 {
    flex-basis: auto !important;
    width: 66.66667% !important;
  }

  ::v-deep .u-lg-size7of10 {
    flex-basis: auto !important;
    width: 70% !important;
  }

  ::v-deep .u-lg-size3of4,
  ::v-deep .u .u-lg-size6of8,
  ::v-deep .u .u-lg-size9of12 {
    flex-basis: auto !important;
    width: 75% !important;
  }

  ::v-deep .u-lg-size4of5,
  ::v-deep .u .u-lg-size8of10 {
    flex-basis: auto !important;
    width: 80% !important;
  }

  ::v-deep .u-lg-size5of6,
  ::v-deep .u .u-lg-size10of12 {
    flex-basis: auto !important;
    width: 83.33333% !important;
  }

  ::v-deep .u-lg-size7of8 {
    flex-basis: auto !important;
    width: 87.5% !important;
  }

  ::v-deep .u-lg-size9of10 {
    flex-basis: auto !important;
    width: 90% !important;
  }

  ::v-deep .u-lg-size11of12 {
    flex-basis: auto !important;
    width: 91.66667% !important;
  }

  /* Intrinsic widths
     ======================================================================== */

  /**
   * Make an element shrink wrap its content.
   */

  ::v-deep .u-lg-sizeFit {
    flex-basis: auto !important;
    width: auto !important;
  }

  /**
   * Make an element fill the remaining space.
   *
   * 1. Be explicit to work around IE10 bug with shorthand flex
   *    http://git.io/vllC7
   * 2. IE10 ignores previous `flex-basis` value. Setting again here fixes
   *    http://git.io/vllMt
   */

  ::v-deep .u-lg-sizeFill {
    -webkit-box-flex: 1 !important;
    flex: 1 1 0% !important;

    /* 1 */
    flex-basis: 0% !important;

    /* 2 */
  }

  /**
   * An alternative method to make an element fill the remaining space.
   * Distributes space based on the initial width and height of the element
   *
   * http://www.w3.org/TR/css-flexbox/images/rel-vs-abs-flex.svg
   */

  ::v-deep .u-lg-sizeFillAlt {
    -webkit-box-flex: 1 !important;
    flex: 1 1 auto !important;
    flex-basis: auto !important;
  }

  /**
   * Make an element the width of its parent.
   */

  ::v-deep .u-lg-sizeFull {
    width: 100% !important;
  }
}

/**
 * @define utilities
 */

/* stylelint-disable function-whitespace-after, plugin/selector-bem-pattern */

/**
 * Mixin: Make utility class that adds vertical space between adjacent items.
 *
 * @see http://alistapart.com/article/axiomatic-css-and-lobotomized-owls
 */

/**
 * Mixin: Make utility classes for adding space outside one or more edges of
 * an element.
 */

/**
 * Mixin: Make utility classes for adding space inside one or more edges of an
 * element.
 */

/**
 * Mixin: Make space between, inside and outside utilities for each step in our
 * modular scale. Optional $prefix allows for creation of responsive variations.
 */

/**
 * Actually output space utilities, default and for various breakpoints.
 */

/**
   * Negative scale steps swap `-` for `0`.
   */

::v-deep .u-spaceItems06 > * + * {
  margin-top: 5.36px !important;
  margin-top: 0.335rem !important;
}

::v-deep .u-staggerItems06 > * + * {
  margin-top: 0.335em !important;
}

::v-deep .u-space06 {
  margin: 5.36px !important;
  margin: 0.335rem !important;
}

::v-deep .u-spaceEnds06 {
  margin-bottom: 5.36px !important;
  margin-bottom: 0.335rem !important;
  margin-top: 5.36px !important;
  margin-top: 0.335rem !important;
}

::v-deep .u-spaceSides06 {
  margin-left: 5.36px !important;
  margin-left: 0.335rem !important;
  margin-right: 5.36px !important;
  margin-right: 0.335rem !important;
}

::v-deep .u-spaceTop06 {
  margin-top: 5.36px !important;
  margin-top: 0.335rem !important;
}

::v-deep .u-spaceBottom06 {
  margin-bottom: 5.36px !important;
  margin-bottom: 0.335rem !important;
}

::v-deep .u-spaceLeft06 {
  margin-left: 5.36px !important;
  margin-left: 0.335rem !important;
}

::v-deep .u-spaceRight06 {
  margin-right: 5.36px !important;
  margin-right: 0.335rem !important;
}

::v-deep .u-pull06 {
  margin: -5.36px !important;
  margin: -0.335rem !important;
}

::v-deep .u-pullEnds06 {
  margin-bottom: -5.36px !important;
  margin-bottom: -0.335rem !important;
  margin-top: -5.36px !important;
  margin-top: -0.335rem !important;
}

::v-deep .u-pullSides06 {
  margin-left: -5.36px !important;
  margin-left: -0.335rem !important;
  margin-right: -5.36px !important;
  margin-right: -0.335rem !important;
}

::v-deep .u-pullTop06 {
  margin-top: -5.36px !important;
  margin-top: -0.335rem !important;
}

::v-deep .u-pullBottom06 {
  margin-bottom: -5.36px !important;
  margin-bottom: -0.335rem !important;
}

::v-deep .u-pullLeft06 {
  margin-left: -5.36px !important;
  margin-left: -0.335rem !important;
}

::v-deep .u-pullRight06 {
  margin-right: -5.36px !important;
  margin-right: -0.335rem !important;
}

::v-deep .u-pad06 {
  padding: 5.36px !important;
  padding: 0.335rem !important;
}

::v-deep .u-padEnds06 {
  padding-bottom: 5.36px !important;
  padding-bottom: 0.335rem !important;
  padding-top: 5.36px !important;
  padding-top: 0.335rem !important;
}

::v-deep .u-padSides06 {
  padding-left: 5.36px !important;
  padding-left: 0.335rem !important;
  padding-right: 5.36px !important;
  padding-right: 0.335rem !important;
}

::v-deep .u-padTop06 {
  padding-top: 5.36px !important;
  padding-top: 0.335rem !important;
}

::v-deep .u-padBottom06 {
  padding-bottom: 5.36px !important;
  padding-bottom: 0.335rem !important;
}

::v-deep .u-padLeft06 {
  padding-left: 5.36px !important;
  padding-left: 0.335rem !important;
}

::v-deep .u-padRight06 {
  padding-right: 5.36px !important;
  padding-right: 0.335rem !important;
}

::v-deep .u-spaceItems05 > * + * {
  margin-top: 6.432px !important;
  margin-top: 0.402rem !important;
}

::v-deep .u-staggerItems05 > * + * {
  margin-top: 0.402em !important;
}

::v-deep .u-space05 {
  margin: 6.432px !important;
  margin: 0.402rem !important;
}

::v-deep .u-spaceEnds05 {
  margin-bottom: 6.432px !important;
  margin-bottom: 0.402rem !important;
  margin-top: 6.432px !important;
  margin-top: 0.402rem !important;
}

::v-deep .u-spaceSides05 {
  margin-left: 6.432px !important;
  margin-left: 0.402rem !important;
  margin-right: 6.432px !important;
  margin-right: 0.402rem !important;
}

::v-deep .u-spaceTop05 {
  margin-top: 6.432px !important;
  margin-top: 0.402rem !important;
}

::v-deep .u-spaceBottom05 {
  margin-bottom: 6.432px !important;
  margin-bottom: 0.402rem !important;
}

::v-deep .u-spaceLeft05 {
  margin-left: 6.432px !important;
  margin-left: 0.402rem !important;
}

::v-deep .u-spaceRight05 {
  margin-right: 6.432px !important;
  margin-right: 0.402rem !important;
}

::v-deep .u-pull05 {
  margin: -6.432px !important;
  margin: -0.402rem !important;
}

::v-deep .u-pullEnds05 {
  margin-bottom: -6.432px !important;
  margin-bottom: -0.402rem !important;
  margin-top: -6.432px !important;
  margin-top: -0.402rem !important;
}

::v-deep .u-pullSides05 {
  margin-left: -6.432px !important;
  margin-left: -0.402rem !important;
  margin-right: -6.432px !important;
  margin-right: -0.402rem !important;
}

::v-deep .u-pullTop05 {
  margin-top: -6.432px !important;
  margin-top: -0.402rem !important;
}

::v-deep .u-pullBottom05 {
  margin-bottom: -6.432px !important;
  margin-bottom: -0.402rem !important;
}

::v-deep .u-pullLeft05 {
  margin-left: -6.432px !important;
  margin-left: -0.402rem !important;
}

::v-deep .u-pullRight05 {
  margin-right: -6.432px !important;
  margin-right: -0.402rem !important;
}

::v-deep .u-pad05 {
  padding: 6.432px !important;
  padding: 0.402rem !important;
}

::v-deep .u-padEnds05 {
  padding-bottom: 6.432px !important;
  padding-bottom: 0.402rem !important;
  padding-top: 6.432px !important;
  padding-top: 0.402rem !important;
}

::v-deep .u-padSides05 {
  padding-left: 6.432px !important;
  padding-left: 0.402rem !important;
  padding-right: 6.432px !important;
  padding-right: 0.402rem !important;
}

::v-deep .u-padTop05 {
  padding-top: 6.432px !important;
  padding-top: 0.402rem !important;
}

::v-deep .u-padBottom05 {
  padding-bottom: 6.432px !important;
  padding-bottom: 0.402rem !important;
}

::v-deep .u-padLeft05 {
  padding-left: 6.432px !important;
  padding-left: 0.402rem !important;
}

::v-deep .u-padRight05 {
  padding-right: 6.432px !important;
  padding-right: 0.402rem !important;
}

::v-deep .u-spaceItems04 > * + * {
  margin-top: 7.712px !important;
  margin-top: 0.482rem !important;
}

::v-deep .u-staggerItems04 > * + * {
  margin-top: 0.482em !important;
}

::v-deep .u-space04 {
  margin: 7.712px !important;
  margin: 0.482rem !important;
}

::v-deep .u-spaceEnds04 {
  margin-bottom: 7.712px !important;
  margin-bottom: 0.482rem !important;
  margin-top: 7.712px !important;
  margin-top: 0.482rem !important;
}

::v-deep .u-spaceSides04 {
  margin-left: 7.712px !important;
  margin-left: 0.482rem !important;
  margin-right: 7.712px !important;
  margin-right: 0.482rem !important;
}

::v-deep .u-spaceTop04 {
  margin-top: 7.712px !important;
  margin-top: 0.482rem !important;
}

::v-deep .u-spaceBottom04 {
  margin-bottom: 7.712px !important;
  margin-bottom: 0.482rem !important;
}

::v-deep .u-spaceLeft04 {
  margin-left: 7.712px !important;
  margin-left: 0.482rem !important;
}

::v-deep .u-spaceRight04 {
  margin-right: 7.712px !important;
  margin-right: 0.482rem !important;
}

::v-deep .u-pull04 {
  margin: -7.712px !important;
  margin: -0.482rem !important;
}

::v-deep .u-pullEnds04 {
  margin-bottom: -7.712px !important;
  margin-bottom: -0.482rem !important;
  margin-top: -7.712px !important;
  margin-top: -0.482rem !important;
}

::v-deep .u-pullSides04 {
  margin-left: -7.712px !important;
  margin-left: -0.482rem !important;
  margin-right: -7.712px !important;
  margin-right: -0.482rem !important;
}

::v-deep .u-pullTop04 {
  margin-top: -7.712px !important;
  margin-top: -0.482rem !important;
}

::v-deep .u-pullBottom04 {
  margin-bottom: -7.712px !important;
  margin-bottom: -0.482rem !important;
}

::v-deep .u-pullLeft04 {
  margin-left: -7.712px !important;
  margin-left: -0.482rem !important;
}

::v-deep .u-pullRight04 {
  margin-right: -7.712px !important;
  margin-right: -0.482rem !important;
}

::v-deep .u-pad04 {
  padding: 7.712px !important;
  padding: 0.482rem !important;
}

::v-deep .u-padEnds04 {
  padding-bottom: 7.712px !important;
  padding-bottom: 0.482rem !important;
  padding-top: 7.712px !important;
  padding-top: 0.482rem !important;
}

::v-deep .u-padSides04 {
  padding-left: 7.712px !important;
  padding-left: 0.482rem !important;
  padding-right: 7.712px !important;
  padding-right: 0.482rem !important;
}

::v-deep .u-padTop04 {
  padding-top: 7.712px !important;
  padding-top: 0.482rem !important;
}

::v-deep .u-padBottom04 {
  padding-bottom: 7.712px !important;
  padding-bottom: 0.482rem !important;
}

::v-deep .u-padLeft04 {
  padding-left: 7.712px !important;
  padding-left: 0.482rem !important;
}

::v-deep .u-padRight04 {
  padding-right: 7.712px !important;
  padding-right: 0.482rem !important;
}

::v-deep .u-spaceItems03 > * + * {
  margin-top: 9.264px !important;
  margin-top: 0.579rem !important;
}

::v-deep .u-staggerItems03 > * + * {
  margin-top: 0.579em !important;
}

::v-deep .u-space03 {
  margin: 9.264px !important;
  margin: 0.579rem !important;
}

::v-deep .u-spaceEnds03 {
  margin-bottom: 9.264px !important;
  margin-bottom: 0.579rem !important;
  margin-top: 9.264px !important;
  margin-top: 0.579rem !important;
}

::v-deep .u-spaceSides03 {
  margin-left: 9.264px !important;
  margin-left: 0.579rem !important;
  margin-right: 9.264px !important;
  margin-right: 0.579rem !important;
}

::v-deep .u-spaceTop03 {
  margin-top: 9.264px !important;
  margin-top: 0.579rem !important;
}

::v-deep .u-spaceBottom03 {
  margin-bottom: 9.264px !important;
  margin-bottom: 0.579rem !important;
}

::v-deep .u-spaceLeft03 {
  margin-left: 9.264px !important;
  margin-left: 0.579rem !important;
}

::v-deep .u-spaceRight03 {
  margin-right: 9.264px !important;
  margin-right: 0.579rem !important;
}

::v-deep .u-pull03 {
  margin: -9.264px !important;
  margin: -0.579rem !important;
}

::v-deep .u-pullEnds03 {
  margin-bottom: -9.264px !important;
  margin-bottom: -0.579rem !important;
  margin-top: -9.264px !important;
  margin-top: -0.579rem !important;
}

::v-deep .u-pullSides03 {
  margin-left: -9.264px !important;
  margin-left: -0.579rem !important;
  margin-right: -9.264px !important;
  margin-right: -0.579rem !important;
}

::v-deep .u-pullTop03 {
  margin-top: -9.264px !important;
  margin-top: -0.579rem !important;
}

::v-deep .u-pullBottom03 {
  margin-bottom: -9.264px !important;
  margin-bottom: -0.579rem !important;
}

::v-deep .u-pullLeft03 {
  margin-left: -9.264px !important;
  margin-left: -0.579rem !important;
}

::v-deep .u-pullRight03 {
  margin-right: -9.264px !important;
  margin-right: -0.579rem !important;
}

::v-deep .u-pad03 {
  padding: 9.264px !important;
  padding: 0.579rem !important;
}

::v-deep .u-padEnds03 {
  padding-bottom: 9.264px !important;
  padding-bottom: 0.579rem !important;
  padding-top: 9.264px !important;
  padding-top: 0.579rem !important;
}

::v-deep .u-padSides03 {
  padding-left: 9.264px !important;
  padding-left: 0.579rem !important;
  padding-right: 9.264px !important;
  padding-right: 0.579rem !important;
}

::v-deep .u-padTop03 {
  padding-top: 9.264px !important;
  padding-top: 0.579rem !important;
}

::v-deep .u-padBottom03 {
  padding-bottom: 9.264px !important;
  padding-bottom: 0.579rem !important;
}

::v-deep .u-padLeft03 {
  padding-left: 9.264px !important;
  padding-left: 0.579rem !important;
}

::v-deep .u-padRight03 {
  padding-right: 9.264px !important;
  padding-right: 0.579rem !important;
}

::v-deep .u-spaceItems02 > * + * {
  margin-top: 11.104px !important;
  margin-top: 0.694rem !important;
}

::v-deep .u-staggerItems02 > * + * {
  margin-top: 0.694em !important;
}

::v-deep .u-space02 {
  margin: 11.104px !important;
  margin: 0.694rem !important;
}

::v-deep .u-spaceEnds02 {
  margin-bottom: 11.104px !important;
  margin-bottom: 0.694rem !important;
  margin-top: 11.104px !important;
  margin-top: 0.694rem !important;
}

::v-deep .u-spaceSides02 {
  margin-left: 11.104px !important;
  margin-left: 0.694rem !important;
  margin-right: 11.104px !important;
  margin-right: 0.694rem !important;
}

::v-deep .u-spaceTop02 {
  margin-top: 11.104px !important;
  margin-top: 0.694rem !important;
}

::v-deep .u-spaceBottom02 {
  margin-bottom: 11.104px !important;
  margin-bottom: 0.694rem !important;
}

::v-deep .u-spaceLeft02 {
  margin-left: 11.104px !important;
  margin-left: 0.694rem !important;
}

::v-deep .u-spaceRight02 {
  margin-right: 11.104px !important;
  margin-right: 0.694rem !important;
}

::v-deep .u-pull02 {
  margin: -11.104px !important;
  margin: -0.694rem !important;
}

::v-deep .u-pullEnds02 {
  margin-bottom: -11.104px !important;
  margin-bottom: -0.694rem !important;
  margin-top: -11.104px !important;
  margin-top: -0.694rem !important;
}

::v-deep .u-pullSides02 {
  margin-left: -11.104px !important;
  margin-left: -0.694rem !important;
  margin-right: -11.104px !important;
  margin-right: -0.694rem !important;
}

::v-deep .u-pullTop02 {
  margin-top: -11.104px !important;
  margin-top: -0.694rem !important;
}

::v-deep .u-pullBottom02 {
  margin-bottom: -11.104px !important;
  margin-bottom: -0.694rem !important;
}

::v-deep .u-pullLeft02 {
  margin-left: -11.104px !important;
  margin-left: -0.694rem !important;
}

::v-deep .u-pullRight02 {
  margin-right: -11.104px !important;
  margin-right: -0.694rem !important;
}

::v-deep .u-pad02 {
  padding: 11.104px !important;
  padding: 0.694rem !important;
}

::v-deep .u-padEnds02 {
  padding-bottom: 11.104px !important;
  padding-bottom: 0.694rem !important;
  padding-top: 11.104px !important;
  padding-top: 0.694rem !important;
}

::v-deep .u-padSides02 {
  padding-left: 11.104px !important;
  padding-left: 0.694rem !important;
  padding-right: 11.104px !important;
  padding-right: 0.694rem !important;
}

::v-deep .u-padTop02 {
  padding-top: 11.104px !important;
  padding-top: 0.694rem !important;
}

::v-deep .u-padBottom02 {
  padding-bottom: 11.104px !important;
  padding-bottom: 0.694rem !important;
}

::v-deep .u-padLeft02 {
  padding-left: 11.104px !important;
  padding-left: 0.694rem !important;
}

::v-deep .u-padRight02 {
  padding-right: 11.104px !important;
  padding-right: 0.694rem !important;
}

::v-deep .u-spaceItems01 > * + * {
  margin-top: 13.328px !important;
  margin-top: 0.833rem !important;
}

::v-deep .u-staggerItems01 > * + * {
  margin-top: 0.833em !important;
}

::v-deep .u-space01 {
  margin: 13.328px !important;
  margin: 0.833rem !important;
}

::v-deep .u-spaceEnds01 {
  margin-bottom: 13.328px !important;
  margin-bottom: 0.833rem !important;
  margin-top: 13.328px !important;
  margin-top: 0.833rem !important;
}

::v-deep .u-spaceSides01 {
  margin-left: 13.328px !important;
  margin-left: 0.833rem !important;
  margin-right: 13.328px !important;
  margin-right: 0.833rem !important;
}

::v-deep .u-spaceTop01 {
  margin-top: 13.328px !important;
  margin-top: 0.833rem !important;
}

::v-deep .u-spaceBottom01 {
  margin-bottom: 13.328px !important;
  margin-bottom: 0.833rem !important;
}

::v-deep .u-spaceLeft01 {
  margin-left: 13.328px !important;
  margin-left: 0.833rem !important;
}

::v-deep .u-spaceRight01 {
  margin-right: 13.328px !important;
  margin-right: 0.833rem !important;
}

::v-deep .u-pull01 {
  margin: -13.328px !important;
  margin: -0.833rem !important;
}

::v-deep .u-pullEnds01 {
  margin-bottom: -13.328px !important;
  margin-bottom: -0.833rem !important;
  margin-top: -13.328px !important;
  margin-top: -0.833rem !important;
}

::v-deep .u-pullSides01 {
  margin-left: -13.328px !important;
  margin-left: -0.833rem !important;
  margin-right: -13.328px !important;
  margin-right: -0.833rem !important;
}

::v-deep .u-pullTop01 {
  margin-top: -13.328px !important;
  margin-top: -0.833rem !important;
}

::v-deep .u-pullBottom01 {
  margin-bottom: -13.328px !important;
  margin-bottom: -0.833rem !important;
}

::v-deep .u-pullLeft01 {
  margin-left: -13.328px !important;
  margin-left: -0.833rem !important;
}

::v-deep .u-pullRight01 {
  margin-right: -13.328px !important;
  margin-right: -0.833rem !important;
}

::v-deep .u-pad01 {
  padding: 13.328px !important;
  padding: 0.833rem !important;
}

::v-deep .u-padEnds01 {
  padding-bottom: 13.328px !important;
  padding-bottom: 0.833rem !important;
  padding-top: 13.328px !important;
  padding-top: 0.833rem !important;
}

::v-deep .u-padSides01 {
  padding-left: 13.328px !important;
  padding-left: 0.833rem !important;
  padding-right: 13.328px !important;
  padding-right: 0.833rem !important;
}

::v-deep .u-padTop01 {
  padding-top: 13.328px !important;
  padding-top: 0.833rem !important;
}

::v-deep .u-padBottom01 {
  padding-bottom: 13.328px !important;
  padding-bottom: 0.833rem !important;
}

::v-deep .u-padLeft01 {
  padding-left: 13.328px !important;
  padding-left: 0.833rem !important;
}

::v-deep .u-padRight01 {
  padding-right: 13.328px !important;
  padding-right: 0.833rem !important;
}

/**
   * Default values omit the suffix and use the `0` step.
   */

::v-deep .u-spaceItems > * + * {
  margin-top: 16px !important;
  margin-top: 1rem !important;
}

::v-deep .u-staggerItems > * + * {
  margin-top: 1em !important;
}

::v-deep .u-space {
  margin: 16px !important;
  margin: 1rem !important;
}

::v-deep .u-spaceEnds {
  margin-bottom: 16px !important;
  margin-bottom: 1rem !important;
  margin-top: 16px !important;
  margin-top: 1rem !important;
}

::v-deep .u-spaceSides {
  margin-left: 16px !important;
  margin-left: 1rem !important;
  margin-right: 16px !important;
  margin-right: 1rem !important;
}

::v-deep .u-spaceTop {
  margin-top: 16px !important;
  margin-top: 1rem !important;
}

::v-deep .u-spaceBottom {
  margin-bottom: 16px !important;
  margin-bottom: 1rem !important;
}

::v-deep .u-spaceLeft {
  margin-left: 16px !important;
  margin-left: 1rem !important;
}

::v-deep .u-spaceRight {
  margin-right: 16px !important;
  margin-right: 1rem !important;
}

::v-deep .u-pull {
  margin: -16px !important;
  margin: -1rem !important;
}

::v-deep .u-pullEnds {
  margin-bottom: -16px !important;
  margin-bottom: -1rem !important;
  margin-top: -16px !important;
  margin-top: -1rem !important;
}

::v-deep .u-pullSides {
  margin-left: -16px !important;
  margin-left: -1rem !important;
  margin-right: -16px !important;
  margin-right: -1rem !important;
}

::v-deep .u-pullTop {
  margin-top: -16px !important;
  margin-top: -1rem !important;
}

::v-deep .u-pullBottom {
  margin-bottom: -16px !important;
  margin-bottom: -1rem !important;
}

::v-deep .u-pullLeft {
  margin-left: -16px !important;
  margin-left: -1rem !important;
}

::v-deep .u-pullRight {
  margin-right: -16px !important;
  margin-right: -1rem !important;
}

::v-deep .u-pad {
  padding: 16px !important;
  padding: 1rem !important;
}

::v-deep .u-padEnds {
  padding-bottom: 16px !important;
  padding-bottom: 1rem !important;
  padding-top: 16px !important;
  padding-top: 1rem !important;
}

::v-deep .u-padSides {
  padding-left: 16px !important;
  padding-left: 1rem !important;
  padding-right: 16px !important;
  padding-right: 1rem !important;
}

::v-deep .u-padTop {
  padding-top: 16px !important;
  padding-top: 1rem !important;
}

::v-deep .u-padBottom {
  padding-bottom: 16px !important;
  padding-bottom: 1rem !important;
}

::v-deep .u-padLeft {
  padding-left: 16px !important;
  padding-left: 1rem !important;
}

::v-deep .u-padRight {
  padding-right: 16px !important;
  padding-right: 1rem !important;
}

/**
   * Positive scale steps.
   */

::v-deep .u-spaceItems1 > * + * {
  margin-top: 19.2px !important;
  margin-top: 1.2rem !important;
}

::v-deep .u-staggerItems1 > * + * {
  margin-top: 1.2em !important;
}

::v-deep .u-space1 {
  margin: 19.2px !important;
  margin: 1.2rem !important;
}

::v-deep .u-spaceEnds1 {
  margin-bottom: 19.2px !important;
  margin-bottom: 1.2rem !important;
  margin-top: 19.2px !important;
  margin-top: 1.2rem !important;
}

::v-deep .u-spaceSides1 {
  margin-left: 19.2px !important;
  margin-left: 1.2rem !important;
  margin-right: 19.2px !important;
  margin-right: 1.2rem !important;
}

::v-deep .u-spaceTop1 {
  margin-top: 19.2px !important;
  margin-top: 1.2rem !important;
}

::v-deep .u-spaceBottom1 {
  margin-bottom: 19.2px !important;
  margin-bottom: 1.2rem !important;
}

::v-deep .u-spaceLeft1 {
  margin-left: 19.2px !important;
  margin-left: 1.2rem !important;
}

::v-deep .u-spaceRight1 {
  margin-right: 19.2px !important;
  margin-right: 1.2rem !important;
}

::v-deep .u-pull1 {
  margin: -19.2px !important;
  margin: -1.2rem !important;
}

::v-deep .u-pullEnds1 {
  margin-bottom: -19.2px !important;
  margin-bottom: -1.2rem !important;
  margin-top: -19.2px !important;
  margin-top: -1.2rem !important;
}

::v-deep .u-pullSides1 {
  margin-left: -19.2px !important;
  margin-left: -1.2rem !important;
  margin-right: -19.2px !important;
  margin-right: -1.2rem !important;
}

::v-deep .u-pullTop1 {
  margin-top: -19.2px !important;
  margin-top: -1.2rem !important;
}

::v-deep .u-pullBottom1 {
  margin-bottom: -19.2px !important;
  margin-bottom: -1.2rem !important;
}

::v-deep .u-pullLeft1 {
  margin-left: -19.2px !important;
  margin-left: -1.2rem !important;
}

::v-deep .u-pullRight1 {
  margin-right: -19.2px !important;
  margin-right: -1.2rem !important;
}

::v-deep .u-pad1 {
  padding: 19.2px !important;
  padding: 1.2rem !important;
}

::v-deep .u-padEnds1 {
  padding-bottom: 19.2px !important;
  padding-bottom: 1.2rem !important;
  padding-top: 19.2px !important;
  padding-top: 1.2rem !important;
}

::v-deep .u-padSides1 {
  padding-left: 19.2px !important;
  padding-left: 1.2rem !important;
  padding-right: 19.2px !important;
  padding-right: 1.2rem !important;
}

::v-deep .u-padTop1 {
  padding-top: 19.2px !important;
  padding-top: 1.2rem !important;
}

::v-deep .u-padBottom1 {
  padding-bottom: 19.2px !important;
  padding-bottom: 1.2rem !important;
}

::v-deep .u-padLeft1 {
  padding-left: 19.2px !important;
  padding-left: 1.2rem !important;
}

::v-deep .u-padRight1 {
  padding-right: 19.2px !important;
  padding-right: 1.2rem !important;
}

::v-deep .u-spaceItems2 > * + * {
  margin-top: 23.04px !important;
  margin-top: 1.44rem !important;
}

::v-deep .u-staggerItems2 > * + * {
  margin-top: 1.44em !important;
}

::v-deep .u-space2 {
  margin: 23.04px !important;
  margin: 1.44rem !important;
}

::v-deep .u-spaceEnds2 {
  margin-bottom: 23.04px !important;
  margin-bottom: 1.44rem !important;
  margin-top: 23.04px !important;
  margin-top: 1.44rem !important;
}

::v-deep .u-spaceSides2 {
  margin-left: 23.04px !important;
  margin-left: 1.44rem !important;
  margin-right: 23.04px !important;
  margin-right: 1.44rem !important;
}

::v-deep .u-spaceTop2 {
  margin-top: 23.04px !important;
  margin-top: 1.44rem !important;
}

::v-deep .u-spaceBottom2 {
  margin-bottom: 23.04px !important;
  margin-bottom: 1.44rem !important;
}

::v-deep .u-spaceLeft2 {
  margin-left: 23.04px !important;
  margin-left: 1.44rem !important;
}

::v-deep .u-spaceRight2 {
  margin-right: 23.04px !important;
  margin-right: 1.44rem !important;
}

::v-deep .u-pull2 {
  margin: -23.04px !important;
  margin: -1.44rem !important;
}

::v-deep .u-pullEnds2 {
  margin-bottom: -23.04px !important;
  margin-bottom: -1.44rem !important;
  margin-top: -23.04px !important;
  margin-top: -1.44rem !important;
}

::v-deep .u-pullSides2 {
  margin-left: -23.04px !important;
  margin-left: -1.44rem !important;
  margin-right: -23.04px !important;
  margin-right: -1.44rem !important;
}

::v-deep .u-pullTop2 {
  margin-top: -23.04px !important;
  margin-top: -1.44rem !important;
}

::v-deep .u-pullBottom2 {
  margin-bottom: -23.04px !important;
  margin-bottom: -1.44rem !important;
}

::v-deep .u-pullLeft2 {
  margin-left: -23.04px !important;
  margin-left: -1.44rem !important;
}

::v-deep .u-pullRight2 {
  margin-right: -23.04px !important;
  margin-right: -1.44rem !important;
}

::v-deep .u-pad2 {
  padding: 23.04px !important;
  padding: 1.44rem !important;
}

::v-deep .u-padEnds2 {
  padding-bottom: 23.04px !important;
  padding-bottom: 1.44rem !important;
  padding-top: 23.04px !important;
  padding-top: 1.44rem !important;
}

::v-deep .u-padSides2 {
  padding-left: 23.04px !important;
  padding-left: 1.44rem !important;
  padding-right: 23.04px !important;
  padding-right: 1.44rem !important;
}

::v-deep .u-padTop2 {
  padding-top: 23.04px !important;
  padding-top: 1.44rem !important;
}

::v-deep .u-padBottom2 {
  padding-bottom: 23.04px !important;
  padding-bottom: 1.44rem !important;
}

::v-deep .u-padLeft2 {
  padding-left: 23.04px !important;
  padding-left: 1.44rem !important;
}

::v-deep .u-padRight2 {
  padding-right: 23.04px !important;
  padding-right: 1.44rem !important;
}

::v-deep .u-spaceItems3 > * + * {
  margin-top: 27.648px !important;
  margin-top: 1.728rem !important;
}

::v-deep .u-staggerItems3 > * + * {
  margin-top: 1.728em !important;
}

::v-deep .u-space3 {
  margin: 27.648px !important;
  margin: 1.728rem !important;
}

::v-deep .u-spaceEnds3 {
  margin-bottom: 27.648px !important;
  margin-bottom: 1.728rem !important;
  margin-top: 27.648px !important;
  margin-top: 1.728rem !important;
}

::v-deep .u-spaceSides3 {
  margin-left: 27.648px !important;
  margin-left: 1.728rem !important;
  margin-right: 27.648px !important;
  margin-right: 1.728rem !important;
}

::v-deep .u-spaceTop3 {
  margin-top: 27.648px !important;
  margin-top: 1.728rem !important;
}

::v-deep .u-spaceBottom3 {
  margin-bottom: 27.648px !important;
  margin-bottom: 1.728rem !important;
}

::v-deep .u-spaceLeft3 {
  margin-left: 27.648px !important;
  margin-left: 1.728rem !important;
}

::v-deep .u-spaceRight3 {
  margin-right: 27.648px !important;
  margin-right: 1.728rem !important;
}

::v-deep .u-pull3 {
  margin: -27.648px !important;
  margin: -1.728rem !important;
}

::v-deep .u-pullEnds3 {
  margin-bottom: -27.648px !important;
  margin-bottom: -1.728rem !important;
  margin-top: -27.648px !important;
  margin-top: -1.728rem !important;
}

::v-deep .u-pullSides3 {
  margin-left: -27.648px !important;
  margin-left: -1.728rem !important;
  margin-right: -27.648px !important;
  margin-right: -1.728rem !important;
}

::v-deep .u-pullTop3 {
  margin-top: -27.648px !important;
  margin-top: -1.728rem !important;
}

::v-deep .u-pullBottom3 {
  margin-bottom: -27.648px !important;
  margin-bottom: -1.728rem !important;
}

::v-deep .u-pullLeft3 {
  margin-left: -27.648px !important;
  margin-left: -1.728rem !important;
}

::v-deep .u-pullRight3 {
  margin-right: -27.648px !important;
  margin-right: -1.728rem !important;
}

::v-deep .u-pad3 {
  padding: 27.648px !important;
  padding: 1.728rem !important;
}

::v-deep .u-padEnds3 {
  padding-bottom: 27.648px !important;
  padding-bottom: 1.728rem !important;
  padding-top: 27.648px !important;
  padding-top: 1.728rem !important;
}

::v-deep .u-padSides3 {
  padding-left: 27.648px !important;
  padding-left: 1.728rem !important;
  padding-right: 27.648px !important;
  padding-right: 1.728rem !important;
}

::v-deep .u-padTop3 {
  padding-top: 27.648px !important;
  padding-top: 1.728rem !important;
}

::v-deep .u-padBottom3 {
  padding-bottom: 27.648px !important;
  padding-bottom: 1.728rem !important;
}

::v-deep .u-padLeft3 {
  padding-left: 27.648px !important;
  padding-left: 1.728rem !important;
}

::v-deep .u-padRight3 {
  padding-right: 27.648px !important;
  padding-right: 1.728rem !important;
}

::v-deep .u-spaceItems4 > * + * {
  margin-top: 33.184px !important;
  margin-top: 2.074rem !important;
}

::v-deep .u-staggerItems4 > * + * {
  margin-top: 2.074em !important;
}

::v-deep .u-space4 {
  margin: 33.184px !important;
  margin: 2.074rem !important;
}

::v-deep .u-spaceEnds4 {
  margin-bottom: 33.184px !important;
  margin-bottom: 2.074rem !important;
  margin-top: 33.184px !important;
  margin-top: 2.074rem !important;
}

::v-deep .u-spaceSides4 {
  margin-left: 33.184px !important;
  margin-left: 2.074rem !important;
  margin-right: 33.184px !important;
  margin-right: 2.074rem !important;
}

::v-deep .u-spaceTop4 {
  margin-top: 33.184px !important;
  margin-top: 2.074rem !important;
}

::v-deep .u-spaceBottom4 {
  margin-bottom: 33.184px !important;
  margin-bottom: 2.074rem !important;
}

::v-deep .u-spaceLeft4 {
  margin-left: 33.184px !important;
  margin-left: 2.074rem !important;
}

::v-deep .u-spaceRight4 {
  margin-right: 33.184px !important;
  margin-right: 2.074rem !important;
}

::v-deep .u-pull4 {
  margin: -33.184px !important;
  margin: -2.074rem !important;
}

::v-deep .u-pullEnds4 {
  margin-bottom: -33.184px !important;
  margin-bottom: -2.074rem !important;
  margin-top: -33.184px !important;
  margin-top: -2.074rem !important;
}

::v-deep .u-pullSides4 {
  margin-left: -33.184px !important;
  margin-left: -2.074rem !important;
  margin-right: -33.184px !important;
  margin-right: -2.074rem !important;
}

::v-deep .u-pullTop4 {
  margin-top: -33.184px !important;
  margin-top: -2.074rem !important;
}

::v-deep .u-pullBottom4 {
  margin-bottom: -33.184px !important;
  margin-bottom: -2.074rem !important;
}

::v-deep .u-pullLeft4 {
  margin-left: -33.184px !important;
  margin-left: -2.074rem !important;
}

::v-deep .u-pullRight4 {
  margin-right: -33.184px !important;
  margin-right: -2.074rem !important;
}

::v-deep .u-pad4 {
  padding: 33.184px !important;
  padding: 2.074rem !important;
}

::v-deep .u-padEnds4 {
  padding-bottom: 33.184px !important;
  padding-bottom: 2.074rem !important;
  padding-top: 33.184px !important;
  padding-top: 2.074rem !important;
}

::v-deep .u-padSides4 {
  padding-left: 33.184px !important;
  padding-left: 2.074rem !important;
  padding-right: 33.184px !important;
  padding-right: 2.074rem !important;
}

::v-deep .u-padTop4 {
  padding-top: 33.184px !important;
  padding-top: 2.074rem !important;
}

::v-deep .u-padBottom4 {
  padding-bottom: 33.184px !important;
  padding-bottom: 2.074rem !important;
}

::v-deep .u-padLeft4 {
  padding-left: 33.184px !important;
  padding-left: 2.074rem !important;
}

::v-deep .u-padRight4 {
  padding-right: 33.184px !important;
  padding-right: 2.074rem !important;
}

::v-deep .u-spaceItems5 > * + * {
  margin-top: 39.808px !important;
  margin-top: 2.488rem !important;
}

::v-deep .u-staggerItems5 > * + * {
  margin-top: 2.488em !important;
}

::v-deep .u-space5 {
  margin: 39.808px !important;
  margin: 2.488rem !important;
}

::v-deep .u-spaceEnds5 {
  margin-bottom: 39.808px !important;
  margin-bottom: 2.488rem !important;
  margin-top: 39.808px !important;
  margin-top: 2.488rem !important;
}

::v-deep .u-spaceSides5 {
  margin-left: 39.808px !important;
  margin-left: 2.488rem !important;
  margin-right: 39.808px !important;
  margin-right: 2.488rem !important;
}

::v-deep .u-spaceTop5 {
  margin-top: 39.808px !important;
  margin-top: 2.488rem !important;
}

::v-deep .u-spaceBottom5 {
  margin-bottom: 39.808px !important;
  margin-bottom: 2.488rem !important;
}

::v-deep .u-spaceLeft5 {
  margin-left: 39.808px !important;
  margin-left: 2.488rem !important;
}

::v-deep .u-spaceRight5 {
  margin-right: 39.808px !important;
  margin-right: 2.488rem !important;
}

::v-deep .u-pull5 {
  margin: -39.808px !important;
  margin: -2.488rem !important;
}

::v-deep .u-pullEnds5 {
  margin-bottom: -39.808px !important;
  margin-bottom: -2.488rem !important;
  margin-top: -39.808px !important;
  margin-top: -2.488rem !important;
}

::v-deep .u-pullSides5 {
  margin-left: -39.808px !important;
  margin-left: -2.488rem !important;
  margin-right: -39.808px !important;
  margin-right: -2.488rem !important;
}

::v-deep .u-pullTop5 {
  margin-top: -39.808px !important;
  margin-top: -2.488rem !important;
}

::v-deep .u-pullBottom5 {
  margin-bottom: -39.808px !important;
  margin-bottom: -2.488rem !important;
}

::v-deep .u-pullLeft5 {
  margin-left: -39.808px !important;
  margin-left: -2.488rem !important;
}

::v-deep .u-pullRight5 {
  margin-right: -39.808px !important;
  margin-right: -2.488rem !important;
}

::v-deep .u-pad5 {
  padding: 39.808px !important;
  padding: 2.488rem !important;
}

::v-deep .u-padEnds5 {
  padding-bottom: 39.808px !important;
  padding-bottom: 2.488rem !important;
  padding-top: 39.808px !important;
  padding-top: 2.488rem !important;
}

::v-deep .u-padSides5 {
  padding-left: 39.808px !important;
  padding-left: 2.488rem !important;
  padding-right: 39.808px !important;
  padding-right: 2.488rem !important;
}

::v-deep .u-padTop5 {
  padding-top: 39.808px !important;
  padding-top: 2.488rem !important;
}

::v-deep .u-padBottom5 {
  padding-bottom: 39.808px !important;
  padding-bottom: 2.488rem !important;
}

::v-deep .u-padLeft5 {
  padding-left: 39.808px !important;
  padding-left: 2.488rem !important;
}

::v-deep .u-padRight5 {
  padding-right: 39.808px !important;
  padding-right: 2.488rem !important;
}

::v-deep .u-spaceItems6 > * + * {
  margin-top: 47.776px !important;
  margin-top: 2.986rem !important;
}

::v-deep .u-staggerItems6 > * + * {
  margin-top: 2.986em !important;
}

::v-deep .u-space6 {
  margin: 47.776px !important;
  margin: 2.986rem !important;
}

::v-deep .u-spaceEnds6 {
  margin-bottom: 47.776px !important;
  margin-bottom: 2.986rem !important;
  margin-top: 47.776px !important;
  margin-top: 2.986rem !important;
}

::v-deep .u-spaceSides6 {
  margin-left: 47.776px !important;
  margin-left: 2.986rem !important;
  margin-right: 47.776px !important;
  margin-right: 2.986rem !important;
}

::v-deep .u-spaceTop6 {
  margin-top: 47.776px !important;
  margin-top: 2.986rem !important;
}

::v-deep .u-spaceBottom6 {
  margin-bottom: 47.776px !important;
  margin-bottom: 2.986rem !important;
}

::v-deep .u-spaceLeft6 {
  margin-left: 47.776px !important;
  margin-left: 2.986rem !important;
}

::v-deep .u-spaceRight6 {
  margin-right: 47.776px !important;
  margin-right: 2.986rem !important;
}

::v-deep .u-pull6 {
  margin: -47.776px !important;
  margin: -2.986rem !important;
}

::v-deep .u-pullEnds6 {
  margin-bottom: -47.776px !important;
  margin-bottom: -2.986rem !important;
  margin-top: -47.776px !important;
  margin-top: -2.986rem !important;
}

::v-deep .u-pullSides6 {
  margin-left: -47.776px !important;
  margin-left: -2.986rem !important;
  margin-right: -47.776px !important;
  margin-right: -2.986rem !important;
}

::v-deep .u-pullTop6 {
  margin-top: -47.776px !important;
  margin-top: -2.986rem !important;
}

::v-deep .u-pullBottom6 {
  margin-bottom: -47.776px !important;
  margin-bottom: -2.986rem !important;
}

::v-deep .u-pullLeft6 {
  margin-left: -47.776px !important;
  margin-left: -2.986rem !important;
}

::v-deep .u-pullRight6 {
  margin-right: -47.776px !important;
  margin-right: -2.986rem !important;
}

::v-deep .u-pad6 {
  padding: 47.776px !important;
  padding: 2.986rem !important;
}

::v-deep .u-padEnds6 {
  padding-bottom: 47.776px !important;
  padding-bottom: 2.986rem !important;
  padding-top: 47.776px !important;
  padding-top: 2.986rem !important;
}

::v-deep .u-padSides6 {
  padding-left: 47.776px !important;
  padding-left: 2.986rem !important;
  padding-right: 47.776px !important;
  padding-right: 2.986rem !important;
}

::v-deep .u-padTop6 {
  padding-top: 47.776px !important;
  padding-top: 2.986rem !important;
}

::v-deep .u-padBottom6 {
  padding-bottom: 47.776px !important;
  padding-bottom: 2.986rem !important;
}

::v-deep .u-padLeft6 {
  padding-left: 47.776px !important;
  padding-left: 2.986rem !important;
}

::v-deep .u-padRight6 {
  padding-right: 47.776px !important;
  padding-right: 2.986rem !important;
}

/**
   * Reset utilities. These come last to give them slight precedence over the
   * other utilities to make it easier to clear whitespace across breakpoints.
   */

::v-deep .u-spaceNone {
  margin: 0 !important;
}

::v-deep .u-spaceEndsNone {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}

::v-deep .u-spaceSidesNone {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

::v-deep .u-spaceTopNone {
  margin-top: 0 !important;
}

::v-deep .u-spaceBottomNone {
  margin-bottom: 0 !important;
}

::v-deep .u-spaceLeftNone {
  margin-left: 0 !important;
}

::v-deep .u-spaceRightNone {
  margin-right: 0 !important;
}

::v-deep .u-padNone {
  padding: 0 !important;
}

::v-deep .u-padEndsNone {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}

::v-deep .u-padSidesNone {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

::v-deep .u-padTopNone {
  padding-top: 0 !important;
}

::v-deep .u-padBottomNone {
  padding-bottom: 0 !important;
}

::v-deep .u-padLeftNone {
  padding-left: 0 !important;
}

::v-deep .u-padRightNone {
  padding-right: 0 !important;
}

@media (min-width: 30em) {
  /**
   * Negative scale steps swap `-` for `0`.
   */

  ::v-deep .u-sm-spaceItems06 > * + * {
    margin-top: 0.335rem !important;
  }

  ::v-deep .u-sm-staggerItems06 > * + * {
    margin-top: 0.335em !important;
  }

  ::v-deep .u-sm-space06 {
    margin: 0.335rem !important;
  }

  ::v-deep .u-sm-spaceEnds06 {
    margin-bottom: 0.335rem !important;
    margin-top: 0.335rem !important;
  }

  ::v-deep .u-sm-spaceSides06 {
    margin-left: 0.335rem !important;
    margin-right: 0.335rem !important;
  }

  ::v-deep .u-sm-spaceTop06 {
    margin-top: 0.335rem !important;
  }

  ::v-deep .u-sm-spaceBottom06 {
    margin-bottom: 0.335rem !important;
  }

  ::v-deep .u-sm-spaceLeft06 {
    margin-left: 0.335rem !important;
  }

  ::v-deep .u-sm-spaceRight06 {
    margin-right: 0.335rem !important;
  }

  ::v-deep .u-sm-pull06 {
    margin: -0.335rem !important;
  }

  ::v-deep .u-sm-pullEnds06 {
    margin-bottom: -0.335rem !important;
    margin-top: -0.335rem !important;
  }

  ::v-deep .u-sm-pullSides06 {
    margin-left: -0.335rem !important;
    margin-right: -0.335rem !important;
  }

  ::v-deep .u-sm-pullTop06 {
    margin-top: -0.335rem !important;
  }

  ::v-deep .u-sm-pullBottom06 {
    margin-bottom: -0.335rem !important;
  }

  ::v-deep .u-sm-pullLeft06 {
    margin-left: -0.335rem !important;
  }

  ::v-deep .u-sm-pullRight06 {
    margin-right: -0.335rem !important;
  }

  ::v-deep .u-sm-pad06 {
    padding: 0.335rem !important;
  }

  ::v-deep .u-sm-padEnds06 {
    padding-bottom: 0.335rem !important;
    padding-top: 0.335rem !important;
  }

  ::v-deep .u-sm-padSides06 {
    padding-left: 0.335rem !important;
    padding-right: 0.335rem !important;
  }

  ::v-deep .u-sm-padTop06 {
    padding-top: 0.335rem !important;
  }

  ::v-deep .u-sm-padBottom06 {
    padding-bottom: 0.335rem !important;
  }

  ::v-deep .u-sm-padLeft06 {
    padding-left: 0.335rem !important;
  }

  ::v-deep .u-sm-padRight06 {
    padding-right: 0.335rem !important;
  }

  ::v-deep .u-sm-spaceItems05 > * + * {
    margin-top: 0.402rem !important;
  }

  ::v-deep .u-sm-staggerItems05 > * + * {
    margin-top: 0.402em !important;
  }

  ::v-deep .u-sm-space05 {
    margin: 0.402rem !important;
  }

  ::v-deep .u-sm-spaceEnds05 {
    margin-bottom: 0.402rem !important;
    margin-top: 0.402rem !important;
  }

  ::v-deep .u-sm-spaceSides05 {
    margin-left: 0.402rem !important;
    margin-right: 0.402rem !important;
  }

  ::v-deep .u-sm-spaceTop05 {
    margin-top: 0.402rem !important;
  }

  ::v-deep .u-sm-spaceBottom05 {
    margin-bottom: 0.402rem !important;
  }

  ::v-deep .u-sm-spaceLeft05 {
    margin-left: 0.402rem !important;
  }

  ::v-deep .u-sm-spaceRight05 {
    margin-right: 0.402rem !important;
  }

  ::v-deep .u-sm-pull05 {
    margin: -0.402rem !important;
  }

  ::v-deep .u-sm-pullEnds05 {
    margin-bottom: -0.402rem !important;
    margin-top: -0.402rem !important;
  }

  ::v-deep .u-sm-pullSides05 {
    margin-left: -0.402rem !important;
    margin-right: -0.402rem !important;
  }

  ::v-deep .u-sm-pullTop05 {
    margin-top: -0.402rem !important;
  }

  ::v-deep .u-sm-pullBottom05 {
    margin-bottom: -0.402rem !important;
  }

  ::v-deep .u-sm-pullLeft05 {
    margin-left: -0.402rem !important;
  }

  ::v-deep .u-sm-pullRight05 {
    margin-right: -0.402rem !important;
  }

  ::v-deep .u-sm-pad05 {
    padding: 0.402rem !important;
  }

  ::v-deep .u-sm-padEnds05 {
    padding-bottom: 0.402rem !important;
    padding-top: 0.402rem !important;
  }

  ::v-deep .u-sm-padSides05 {
    padding-left: 0.402rem !important;
    padding-right: 0.402rem !important;
  }

  ::v-deep .u-sm-padTop05 {
    padding-top: 0.402rem !important;
  }

  ::v-deep .u-sm-padBottom05 {
    padding-bottom: 0.402rem !important;
  }

  ::v-deep .u-sm-padLeft05 {
    padding-left: 0.402rem !important;
  }

  ::v-deep .u-sm-padRight05 {
    padding-right: 0.402rem !important;
  }

  ::v-deep .u-sm-spaceItems04 > * + * {
    margin-top: 0.482rem !important;
  }

  ::v-deep .u-sm-staggerItems04 > * + * {
    margin-top: 0.482em !important;
  }

  ::v-deep .u-sm-space04 {
    margin: 0.482rem !important;
  }

  ::v-deep .u-sm-spaceEnds04 {
    margin-bottom: 0.482rem !important;
    margin-top: 0.482rem !important;
  }

  ::v-deep .u-sm-spaceSides04 {
    margin-left: 0.482rem !important;
    margin-right: 0.482rem !important;
  }

  ::v-deep .u-sm-spaceTop04 {
    margin-top: 0.482rem !important;
  }

  ::v-deep .u-sm-spaceBottom04 {
    margin-bottom: 0.482rem !important;
  }

  ::v-deep .u-sm-spaceLeft04 {
    margin-left: 0.482rem !important;
  }

  ::v-deep .u-sm-spaceRight04 {
    margin-right: 0.482rem !important;
  }

  ::v-deep .u-sm-pull04 {
    margin: -0.482rem !important;
  }

  ::v-deep .u-sm-pullEnds04 {
    margin-bottom: -0.482rem !important;
    margin-top: -0.482rem !important;
  }

  ::v-deep .u-sm-pullSides04 {
    margin-left: -0.482rem !important;
    margin-right: -0.482rem !important;
  }

  ::v-deep .u-sm-pullTop04 {
    margin-top: -0.482rem !important;
  }

  ::v-deep .u-sm-pullBottom04 {
    margin-bottom: -0.482rem !important;
  }

  ::v-deep .u-sm-pullLeft04 {
    margin-left: -0.482rem !important;
  }

  ::v-deep .u-sm-pullRight04 {
    margin-right: -0.482rem !important;
  }

  ::v-deep .u-sm-pad04 {
    padding: 0.482rem !important;
  }

  ::v-deep .u-sm-padEnds04 {
    padding-bottom: 0.482rem !important;
    padding-top: 0.482rem !important;
  }

  ::v-deep .u-sm-padSides04 {
    padding-left: 0.482rem !important;
    padding-right: 0.482rem !important;
  }

  ::v-deep .u-sm-padTop04 {
    padding-top: 0.482rem !important;
  }

  ::v-deep .u-sm-padBottom04 {
    padding-bottom: 0.482rem !important;
  }

  ::v-deep .u-sm-padLeft04 {
    padding-left: 0.482rem !important;
  }

  ::v-deep .u-sm-padRight04 {
    padding-right: 0.482rem !important;
  }

  ::v-deep .u-sm-spaceItems03 > * + * {
    margin-top: 0.579rem !important;
  }

  ::v-deep .u-sm-staggerItems03 > * + * {
    margin-top: 0.579em !important;
  }

  ::v-deep .u-sm-space03 {
    margin: 0.579rem !important;
  }

  ::v-deep .u-sm-spaceEnds03 {
    margin-bottom: 0.579rem !important;
    margin-top: 0.579rem !important;
  }

  ::v-deep .u-sm-spaceSides03 {
    margin-left: 0.579rem !important;
    margin-right: 0.579rem !important;
  }

  ::v-deep .u-sm-spaceTop03 {
    margin-top: 0.579rem !important;
  }

  ::v-deep .u-sm-spaceBottom03 {
    margin-bottom: 0.579rem !important;
  }

  ::v-deep .u-sm-spaceLeft03 {
    margin-left: 0.579rem !important;
  }

  ::v-deep .u-sm-spaceRight03 {
    margin-right: 0.579rem !important;
  }

  ::v-deep .u-sm-pull03 {
    margin: -0.579rem !important;
  }

  ::v-deep .u-sm-pullEnds03 {
    margin-bottom: -0.579rem !important;
    margin-top: -0.579rem !important;
  }

  ::v-deep .u-sm-pullSides03 {
    margin-left: -0.579rem !important;
    margin-right: -0.579rem !important;
  }

  ::v-deep .u-sm-pullTop03 {
    margin-top: -0.579rem !important;
  }

  ::v-deep .u-sm-pullBottom03 {
    margin-bottom: -0.579rem !important;
  }

  ::v-deep .u-sm-pullLeft03 {
    margin-left: -0.579rem !important;
  }

  ::v-deep .u-sm-pullRight03 {
    margin-right: -0.579rem !important;
  }

  ::v-deep .u-sm-pad03 {
    padding: 0.579rem !important;
  }

  ::v-deep .u-sm-padEnds03 {
    padding-bottom: 0.579rem !important;
    padding-top: 0.579rem !important;
  }

  ::v-deep .u-sm-padSides03 {
    padding-left: 0.579rem !important;
    padding-right: 0.579rem !important;
  }

  ::v-deep .u-sm-padTop03 {
    padding-top: 0.579rem !important;
  }

  ::v-deep .u-sm-padBottom03 {
    padding-bottom: 0.579rem !important;
  }

  ::v-deep .u-sm-padLeft03 {
    padding-left: 0.579rem !important;
  }

  ::v-deep .u-sm-padRight03 {
    padding-right: 0.579rem !important;
  }

  ::v-deep .u-sm-spaceItems02 > * + * {
    margin-top: 0.694rem !important;
  }

  ::v-deep .u-sm-staggerItems02 > * + * {
    margin-top: 0.694em !important;
  }

  ::v-deep .u-sm-space02 {
    margin: 0.694rem !important;
  }

  ::v-deep .u-sm-spaceEnds02 {
    margin-bottom: 0.694rem !important;
    margin-top: 0.694rem !important;
  }

  ::v-deep .u-sm-spaceSides02 {
    margin-left: 0.694rem !important;
    margin-right: 0.694rem !important;
  }

  ::v-deep .u-sm-spaceTop02 {
    margin-top: 0.694rem !important;
  }

  ::v-deep .u-sm-spaceBottom02 {
    margin-bottom: 0.694rem !important;
  }

  ::v-deep .u-sm-spaceLeft02 {
    margin-left: 0.694rem !important;
  }

  ::v-deep .u-sm-spaceRight02 {
    margin-right: 0.694rem !important;
  }

  ::v-deep .u-sm-pull02 {
    margin: -0.694rem !important;
  }

  ::v-deep .u-sm-pullEnds02 {
    margin-bottom: -0.694rem !important;
    margin-top: -0.694rem !important;
  }

  ::v-deep .u-sm-pullSides02 {
    margin-left: -0.694rem !important;
    margin-right: -0.694rem !important;
  }

  ::v-deep .u-sm-pullTop02 {
    margin-top: -0.694rem !important;
  }

  ::v-deep .u-sm-pullBottom02 {
    margin-bottom: -0.694rem !important;
  }

  ::v-deep .u-sm-pullLeft02 {
    margin-left: -0.694rem !important;
  }

  ::v-deep .u-sm-pullRight02 {
    margin-right: -0.694rem !important;
  }

  ::v-deep .u-sm-pad02 {
    padding: 0.694rem !important;
  }

  ::v-deep .u-sm-padEnds02 {
    padding-bottom: 0.694rem !important;
    padding-top: 0.694rem !important;
  }

  ::v-deep .u-sm-padSides02 {
    padding-left: 0.694rem !important;
    padding-right: 0.694rem !important;
  }

  ::v-deep .u-sm-padTop02 {
    padding-top: 0.694rem !important;
  }

  ::v-deep .u-sm-padBottom02 {
    padding-bottom: 0.694rem !important;
  }

  ::v-deep .u-sm-padLeft02 {
    padding-left: 0.694rem !important;
  }

  ::v-deep .u-sm-padRight02 {
    padding-right: 0.694rem !important;
  }

  ::v-deep .u-sm-spaceItems01 > * + * {
    margin-top: 0.833rem !important;
  }

  ::v-deep .u-sm-staggerItems01 > * + * {
    margin-top: 0.833em !important;
  }

  ::v-deep .u-sm-space01 {
    margin: 0.833rem !important;
  }

  ::v-deep .u-sm-spaceEnds01 {
    margin-bottom: 0.833rem !important;
    margin-top: 0.833rem !important;
  }

  ::v-deep .u-sm-spaceSides01 {
    margin-left: 0.833rem !important;
    margin-right: 0.833rem !important;
  }

  ::v-deep .u-sm-spaceTop01 {
    margin-top: 0.833rem !important;
  }

  ::v-deep .u-sm-spaceBottom01 {
    margin-bottom: 0.833rem !important;
  }

  ::v-deep .u-sm-spaceLeft01 {
    margin-left: 0.833rem !important;
  }

  ::v-deep .u-sm-spaceRight01 {
    margin-right: 0.833rem !important;
  }

  ::v-deep .u-sm-pull01 {
    margin: -0.833rem !important;
  }

  ::v-deep .u-sm-pullEnds01 {
    margin-bottom: -0.833rem !important;
    margin-top: -0.833rem !important;
  }

  ::v-deep .u-sm-pullSides01 {
    margin-left: -0.833rem !important;
    margin-right: -0.833rem !important;
  }

  ::v-deep .u-sm-pullTop01 {
    margin-top: -0.833rem !important;
  }

  ::v-deep .u-sm-pullBottom01 {
    margin-bottom: -0.833rem !important;
  }

  ::v-deep .u-sm-pullLeft01 {
    margin-left: -0.833rem !important;
  }

  ::v-deep .u-sm-pullRight01 {
    margin-right: -0.833rem !important;
  }

  ::v-deep .u-sm-pad01 {
    padding: 0.833rem !important;
  }

  ::v-deep .u-sm-padEnds01 {
    padding-bottom: 0.833rem !important;
    padding-top: 0.833rem !important;
  }

  ::v-deep .u-sm-padSides01 {
    padding-left: 0.833rem !important;
    padding-right: 0.833rem !important;
  }

  ::v-deep .u-sm-padTop01 {
    padding-top: 0.833rem !important;
  }

  ::v-deep .u-sm-padBottom01 {
    padding-bottom: 0.833rem !important;
  }

  ::v-deep .u-sm-padLeft01 {
    padding-left: 0.833rem !important;
  }

  ::v-deep .u-sm-padRight01 {
    padding-right: 0.833rem !important;
  }

  /**
   * Default values omit the suffix and use the `0` step.
   */

  ::v-deep .u-sm-spaceItems > * + * {
    margin-top: 1rem !important;
  }

  ::v-deep .u-sm-staggerItems > * + * {
    margin-top: 1em !important;
  }

  ::v-deep .u-sm-space {
    margin: 1rem !important;
  }

  ::v-deep .u-sm-spaceEnds {
    margin-bottom: 1rem !important;
    margin-top: 1rem !important;
  }

  ::v-deep .u-sm-spaceSides {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  ::v-deep .u-sm-spaceTop {
    margin-top: 1rem !important;
  }

  ::v-deep .u-sm-spaceBottom {
    margin-bottom: 1rem !important;
  }

  ::v-deep .u-sm-spaceLeft {
    margin-left: 1rem !important;
  }

  ::v-deep .u-sm-spaceRight {
    margin-right: 1rem !important;
  }

  ::v-deep .u-sm-pull {
    margin: -1rem !important;
  }

  ::v-deep .u-sm-pullEnds {
    margin-bottom: -1rem !important;
    margin-top: -1rem !important;
  }

  ::v-deep .u-sm-pullSides {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }

  ::v-deep .u-sm-pullTop {
    margin-top: -1rem !important;
  }

  ::v-deep .u-sm-pullBottom {
    margin-bottom: -1rem !important;
  }

  ::v-deep .u-sm-pullLeft {
    margin-left: -1rem !important;
  }

  ::v-deep .u-sm-pullRight {
    margin-right: -1rem !important;
  }

  ::v-deep .u-sm-pad {
    padding: 1rem !important;
  }

  ::v-deep .u-sm-padEnds {
    padding-bottom: 1rem !important;
    padding-top: 1rem !important;
  }

  ::v-deep .u-sm-padSides {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  ::v-deep .u-sm-padTop {
    padding-top: 1rem !important;
  }

  ::v-deep .u-sm-padBottom {
    padding-bottom: 1rem !important;
  }

  ::v-deep .u-sm-padLeft {
    padding-left: 1rem !important;
  }

  ::v-deep .u-sm-padRight {
    padding-right: 1rem !important;
  }

  /**
   * Positive scale steps.
   */

  ::v-deep .u-sm-spaceItems1 > * + * {
    margin-top: 1.2rem !important;
  }

  ::v-deep .u-sm-staggerItems1 > * + * {
    margin-top: 1.2em !important;
  }

  ::v-deep .u-sm-space1 {
    margin: 1.2rem !important;
  }

  ::v-deep .u-sm-spaceEnds1 {
    margin-bottom: 1.2rem !important;
    margin-top: 1.2rem !important;
  }

  ::v-deep .u-sm-spaceSides1 {
    margin-left: 1.2rem !important;
    margin-right: 1.2rem !important;
  }

  ::v-deep .u-sm-spaceTop1 {
    margin-top: 1.2rem !important;
  }

  ::v-deep .u-sm-spaceBottom1 {
    margin-bottom: 1.2rem !important;
  }

  ::v-deep .u-sm-spaceLeft1 {
    margin-left: 1.2rem !important;
  }

  ::v-deep .u-sm-spaceRight1 {
    margin-right: 1.2rem !important;
  }

  ::v-deep .u-sm-pull1 {
    margin: -1.2rem !important;
  }

  ::v-deep .u-sm-pullEnds1 {
    margin-bottom: -1.2rem !important;
    margin-top: -1.2rem !important;
  }

  ::v-deep .u-sm-pullSides1 {
    margin-left: -1.2rem !important;
    margin-right: -1.2rem !important;
  }

  ::v-deep .u-sm-pullTop1 {
    margin-top: -1.2rem !important;
  }

  ::v-deep .u-sm-pullBottom1 {
    margin-bottom: -1.2rem !important;
  }

  ::v-deep .u-sm-pullLeft1 {
    margin-left: -1.2rem !important;
  }

  ::v-deep .u-sm-pullRight1 {
    margin-right: -1.2rem !important;
  }

  ::v-deep .u-sm-pad1 {
    padding: 1.2rem !important;
  }

  ::v-deep .u-sm-padEnds1 {
    padding-bottom: 1.2rem !important;
    padding-top: 1.2rem !important;
  }

  ::v-deep .u-sm-padSides1 {
    padding-left: 1.2rem !important;
    padding-right: 1.2rem !important;
  }

  ::v-deep .u-sm-padTop1 {
    padding-top: 1.2rem !important;
  }

  ::v-deep .u-sm-padBottom1 {
    padding-bottom: 1.2rem !important;
  }

  ::v-deep .u-sm-padLeft1 {
    padding-left: 1.2rem !important;
  }

  ::v-deep .u-sm-padRight1 {
    padding-right: 1.2rem !important;
  }

  ::v-deep .u-sm-spaceItems2 > * + * {
    margin-top: 1.44rem !important;
  }

  ::v-deep .u-sm-staggerItems2 > * + * {
    margin-top: 1.44em !important;
  }

  ::v-deep .u-sm-space2 {
    margin: 1.44rem !important;
  }

  ::v-deep .u-sm-spaceEnds2 {
    margin-bottom: 1.44rem !important;
    margin-top: 1.44rem !important;
  }

  ::v-deep .u-sm-spaceSides2 {
    margin-left: 1.44rem !important;
    margin-right: 1.44rem !important;
  }

  ::v-deep .u-sm-spaceTop2 {
    margin-top: 1.44rem !important;
  }

  ::v-deep .u-sm-spaceBottom2 {
    margin-bottom: 1.44rem !important;
  }

  ::v-deep .u-sm-spaceLeft2 {
    margin-left: 1.44rem !important;
  }

  ::v-deep .u-sm-spaceRight2 {
    margin-right: 1.44rem !important;
  }

  ::v-deep .u-sm-pull2 {
    margin: -1.44rem !important;
  }

  ::v-deep .u-sm-pullEnds2 {
    margin-bottom: -1.44rem !important;
    margin-top: -1.44rem !important;
  }

  ::v-deep .u-sm-pullSides2 {
    margin-left: -1.44rem !important;
    margin-right: -1.44rem !important;
  }

  ::v-deep .u-sm-pullTop2 {
    margin-top: -1.44rem !important;
  }

  ::v-deep .u-sm-pullBottom2 {
    margin-bottom: -1.44rem !important;
  }

  ::v-deep .u-sm-pullLeft2 {
    margin-left: -1.44rem !important;
  }

  ::v-deep .u-sm-pullRight2 {
    margin-right: -1.44rem !important;
  }

  ::v-deep .u-sm-pad2 {
    padding: 1.44rem !important;
  }

  ::v-deep .u-sm-padEnds2 {
    padding-bottom: 1.44rem !important;
    padding-top: 1.44rem !important;
  }

  ::v-deep .u-sm-padSides2 {
    padding-left: 1.44rem !important;
    padding-right: 1.44rem !important;
  }

  ::v-deep .u-sm-padTop2 {
    padding-top: 1.44rem !important;
  }

  ::v-deep .u-sm-padBottom2 {
    padding-bottom: 1.44rem !important;
  }

  ::v-deep .u-sm-padLeft2 {
    padding-left: 1.44rem !important;
  }

  ::v-deep .u-sm-padRight2 {
    padding-right: 1.44rem !important;
  }

  ::v-deep .u-sm-spaceItems3 > * + * {
    margin-top: 1.728rem !important;
  }

  ::v-deep .u-sm-staggerItems3 > * + * {
    margin-top: 1.728em !important;
  }

  ::v-deep .u-sm-space3 {
    margin: 1.728rem !important;
  }

  ::v-deep .u-sm-spaceEnds3 {
    margin-bottom: 1.728rem !important;
    margin-top: 1.728rem !important;
  }

  ::v-deep .u-sm-spaceSides3 {
    margin-left: 1.728rem !important;
    margin-right: 1.728rem !important;
  }

  ::v-deep .u-sm-spaceTop3 {
    margin-top: 1.728rem !important;
  }

  ::v-deep .u-sm-spaceBottom3 {
    margin-bottom: 1.728rem !important;
  }

  ::v-deep .u-sm-spaceLeft3 {
    margin-left: 1.728rem !important;
  }

  ::v-deep .u-sm-spaceRight3 {
    margin-right: 1.728rem !important;
  }

  ::v-deep .u-sm-pull3 {
    margin: -1.728rem !important;
  }

  ::v-deep .u-sm-pullEnds3 {
    margin-bottom: -1.728rem !important;
    margin-top: -1.728rem !important;
  }

  ::v-deep .u-sm-pullSides3 {
    margin-left: -1.728rem !important;
    margin-right: -1.728rem !important;
  }

  ::v-deep .u-sm-pullTop3 {
    margin-top: -1.728rem !important;
  }

  ::v-deep .u-sm-pullBottom3 {
    margin-bottom: -1.728rem !important;
  }

  ::v-deep .u-sm-pullLeft3 {
    margin-left: -1.728rem !important;
  }

  ::v-deep .u-sm-pullRight3 {
    margin-right: -1.728rem !important;
  }

  ::v-deep .u-sm-pad3 {
    padding: 1.728rem !important;
  }

  ::v-deep .u-sm-padEnds3 {
    padding-bottom: 1.728rem !important;
    padding-top: 1.728rem !important;
  }

  ::v-deep .u-sm-padSides3 {
    padding-left: 1.728rem !important;
    padding-right: 1.728rem !important;
  }

  ::v-deep .u-sm-padTop3 {
    padding-top: 1.728rem !important;
  }

  ::v-deep .u-sm-padBottom3 {
    padding-bottom: 1.728rem !important;
  }

  ::v-deep .u-sm-padLeft3 {
    padding-left: 1.728rem !important;
  }

  ::v-deep .u-sm-padRight3 {
    padding-right: 1.728rem !important;
  }

  ::v-deep .u-sm-spaceItems4 > * + * {
    margin-top: 2.074rem !important;
  }

  ::v-deep .u-sm-staggerItems4 > * + * {
    margin-top: 2.074em !important;
  }

  ::v-deep .u-sm-space4 {
    margin: 2.074rem !important;
  }

  ::v-deep .u-sm-spaceEnds4 {
    margin-bottom: 2.074rem !important;
    margin-top: 2.074rem !important;
  }

  ::v-deep .u-sm-spaceSides4 {
    margin-left: 2.074rem !important;
    margin-right: 2.074rem !important;
  }

  ::v-deep .u-sm-spaceTop4 {
    margin-top: 2.074rem !important;
  }

  ::v-deep .u-sm-spaceBottom4 {
    margin-bottom: 2.074rem !important;
  }

  ::v-deep .u-sm-spaceLeft4 {
    margin-left: 2.074rem !important;
  }

  ::v-deep .u-sm-spaceRight4 {
    margin-right: 2.074rem !important;
  }

  ::v-deep .u-sm-pull4 {
    margin: -2.074rem !important;
  }

  ::v-deep .u-sm-pullEnds4 {
    margin-bottom: -2.074rem !important;
    margin-top: -2.074rem !important;
  }

  ::v-deep .u-sm-pullSides4 {
    margin-left: -2.074rem !important;
    margin-right: -2.074rem !important;
  }

  ::v-deep .u-sm-pullTop4 {
    margin-top: -2.074rem !important;
  }

  ::v-deep .u-sm-pullBottom4 {
    margin-bottom: -2.074rem !important;
  }

  ::v-deep .u-sm-pullLeft4 {
    margin-left: -2.074rem !important;
  }

  ::v-deep .u-sm-pullRight4 {
    margin-right: -2.074rem !important;
  }

  ::v-deep .u-sm-pad4 {
    padding: 2.074rem !important;
  }

  ::v-deep .u-sm-padEnds4 {
    padding-bottom: 2.074rem !important;
    padding-top: 2.074rem !important;
  }

  ::v-deep .u-sm-padSides4 {
    padding-left: 2.074rem !important;
    padding-right: 2.074rem !important;
  }

  ::v-deep .u-sm-padTop4 {
    padding-top: 2.074rem !important;
  }

  ::v-deep .u-sm-padBottom4 {
    padding-bottom: 2.074rem !important;
  }

  ::v-deep .u-sm-padLeft4 {
    padding-left: 2.074rem !important;
  }

  ::v-deep .u-sm-padRight4 {
    padding-right: 2.074rem !important;
  }

  ::v-deep .u-sm-spaceItems5 > * + * {
    margin-top: 2.488rem !important;
  }

  ::v-deep .u-sm-staggerItems5 > * + * {
    margin-top: 2.488em !important;
  }

  ::v-deep .u-sm-space5 {
    margin: 2.488rem !important;
  }

  ::v-deep .u-sm-spaceEnds5 {
    margin-bottom: 2.488rem !important;
    margin-top: 2.488rem !important;
  }

  ::v-deep .u-sm-spaceSides5 {
    margin-left: 2.488rem !important;
    margin-right: 2.488rem !important;
  }

  ::v-deep .u-sm-spaceTop5 {
    margin-top: 2.488rem !important;
  }

  ::v-deep .u-sm-spaceBottom5 {
    margin-bottom: 2.488rem !important;
  }

  ::v-deep .u-sm-spaceLeft5 {
    margin-left: 2.488rem !important;
  }

  ::v-deep .u-sm-spaceRight5 {
    margin-right: 2.488rem !important;
  }

  ::v-deep .u-sm-pull5 {
    margin: -2.488rem !important;
  }

  ::v-deep .u-sm-pullEnds5 {
    margin-bottom: -2.488rem !important;
    margin-top: -2.488rem !important;
  }

  ::v-deep .u-sm-pullSides5 {
    margin-left: -2.488rem !important;
    margin-right: -2.488rem !important;
  }

  ::v-deep .u-sm-pullTop5 {
    margin-top: -2.488rem !important;
  }

  ::v-deep .u-sm-pullBottom5 {
    margin-bottom: -2.488rem !important;
  }

  ::v-deep .u-sm-pullLeft5 {
    margin-left: -2.488rem !important;
  }

  ::v-deep .u-sm-pullRight5 {
    margin-right: -2.488rem !important;
  }

  ::v-deep .u-sm-pad5 {
    padding: 2.488rem !important;
  }

  ::v-deep .u-sm-padEnds5 {
    padding-bottom: 2.488rem !important;
    padding-top: 2.488rem !important;
  }

  ::v-deep .u-sm-padSides5 {
    padding-left: 2.488rem !important;
    padding-right: 2.488rem !important;
  }

  ::v-deep .u-sm-padTop5 {
    padding-top: 2.488rem !important;
  }

  ::v-deep .u-sm-padBottom5 {
    padding-bottom: 2.488rem !important;
  }

  ::v-deep .u-sm-padLeft5 {
    padding-left: 2.488rem !important;
  }

  ::v-deep .u-sm-padRight5 {
    padding-right: 2.488rem !important;
  }

  ::v-deep .u-sm-spaceItems6 > * + * {
    margin-top: 2.986rem !important;
  }

  ::v-deep .u-sm-staggerItems6 > * + * {
    margin-top: 2.986em !important;
  }

  ::v-deep .u-sm-space6 {
    margin: 2.986rem !important;
  }

  ::v-deep .u-sm-spaceEnds6 {
    margin-bottom: 2.986rem !important;
    margin-top: 2.986rem !important;
  }

  ::v-deep .u-sm-spaceSides6 {
    margin-left: 2.986rem !important;
    margin-right: 2.986rem !important;
  }

  ::v-deep .u-sm-spaceTop6 {
    margin-top: 2.986rem !important;
  }

  ::v-deep .u-sm-spaceBottom6 {
    margin-bottom: 2.986rem !important;
  }

  ::v-deep .u-sm-spaceLeft6 {
    margin-left: 2.986rem !important;
  }

  ::v-deep .u-sm-spaceRight6 {
    margin-right: 2.986rem !important;
  }

  ::v-deep .u-sm-pull6 {
    margin: -2.986rem !important;
  }

  ::v-deep .u-sm-pullEnds6 {
    margin-bottom: -2.986rem !important;
    margin-top: -2.986rem !important;
  }

  ::v-deep .u-sm-pullSides6 {
    margin-left: -2.986rem !important;
    margin-right: -2.986rem !important;
  }

  ::v-deep .u-sm-pullTop6 {
    margin-top: -2.986rem !important;
  }

  ::v-deep .u-sm-pullBottom6 {
    margin-bottom: -2.986rem !important;
  }

  ::v-deep .u-sm-pullLeft6 {
    margin-left: -2.986rem !important;
  }

  ::v-deep .u-sm-pullRight6 {
    margin-right: -2.986rem !important;
  }

  ::v-deep .u-sm-pad6 {
    padding: 2.986rem !important;
  }

  ::v-deep .u-sm-padEnds6 {
    padding-bottom: 2.986rem !important;
    padding-top: 2.986rem !important;
  }

  ::v-deep .u-sm-padSides6 {
    padding-left: 2.986rem !important;
    padding-right: 2.986rem !important;
  }

  ::v-deep .u-sm-padTop6 {
    padding-top: 2.986rem !important;
  }

  ::v-deep .u-sm-padBottom6 {
    padding-bottom: 2.986rem !important;
  }

  ::v-deep .u-sm-padLeft6 {
    padding-left: 2.986rem !important;
  }

  ::v-deep .u-sm-padRight6 {
    padding-right: 2.986rem !important;
  }

  /**
   * Reset utilities. These come last to give them slight precedence over the
   * other utilities to make it easier to clear whitespace across breakpoints.
   */

  ::v-deep .u-sm-spaceNone {
    margin: 0 !important;
  }

  ::v-deep .u-sm-spaceEndsNone {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
  }

  ::v-deep .u-sm-spaceSidesNone {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  ::v-deep .u-sm-spaceTopNone {
    margin-top: 0 !important;
  }

  ::v-deep .u-sm-spaceBottomNone {
    margin-bottom: 0 !important;
  }

  ::v-deep .u-sm-spaceLeftNone {
    margin-left: 0 !important;
  }

  ::v-deep .u-sm-spaceRightNone {
    margin-right: 0 !important;
  }

  ::v-deep .u-sm-padNone {
    padding: 0 !important;
  }

  ::v-deep .u-sm-padEndsNone {
    padding-bottom: 0 !important;
    padding-top: 0 !important;
  }

  ::v-deep .u-sm-padSidesNone {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  ::v-deep .u-sm-padTopNone {
    padding-top: 0 !important;
  }

  ::v-deep .u-sm-padBottomNone {
    padding-bottom: 0 !important;
  }

  ::v-deep .u-sm-padLeftNone {
    padding-left: 0 !important;
  }

  ::v-deep .u-sm-padRightNone {
    padding-right: 0 !important;
  }
}

@media (min-width: 47em) {
  /**
   * Negative scale steps swap `-` for `0`.
   */

  ::v-deep .u-md-spaceItems06 > * + * {
    margin-top: 0.335rem !important;
  }

  ::v-deep .u-md-staggerItems06 > * + * {
    margin-top: 0.335em !important;
  }

  ::v-deep .u-md-space06 {
    margin: 0.335rem !important;
  }

  ::v-deep .u-md-spaceEnds06 {
    margin-bottom: 0.335rem !important;
    margin-top: 0.335rem !important;
  }

  ::v-deep .u-md-spaceSides06 {
    margin-left: 0.335rem !important;
    margin-right: 0.335rem !important;
  }

  ::v-deep .u-md-spaceTop06 {
    margin-top: 0.335rem !important;
  }

  ::v-deep .u-md-spaceBottom06 {
    margin-bottom: 0.335rem !important;
  }

  ::v-deep .u-md-spaceLeft06 {
    margin-left: 0.335rem !important;
  }

  ::v-deep .u-md-spaceRight06 {
    margin-right: 0.335rem !important;
  }

  ::v-deep .u-md-pull06 {
    margin: -0.335rem !important;
  }

  ::v-deep .u-md-pullEnds06 {
    margin-bottom: -0.335rem !important;
    margin-top: -0.335rem !important;
  }

  ::v-deep .u-md-pullSides06 {
    margin-left: -0.335rem !important;
    margin-right: -0.335rem !important;
  }

  ::v-deep .u-md-pullTop06 {
    margin-top: -0.335rem !important;
  }

  ::v-deep .u-md-pullBottom06 {
    margin-bottom: -0.335rem !important;
  }

  ::v-deep .u-md-pullLeft06 {
    margin-left: -0.335rem !important;
  }

  ::v-deep .u-md-pullRight06 {
    margin-right: -0.335rem !important;
  }

  ::v-deep .u-md-pad06 {
    padding: 0.335rem !important;
  }

  ::v-deep .u-md-padEnds06 {
    padding-bottom: 0.335rem !important;
    padding-top: 0.335rem !important;
  }

  ::v-deep .u-md-padSides06 {
    padding-left: 0.335rem !important;
    padding-right: 0.335rem !important;
  }

  ::v-deep .u-md-padTop06 {
    padding-top: 0.335rem !important;
  }

  ::v-deep .u-md-padBottom06 {
    padding-bottom: 0.335rem !important;
  }

  ::v-deep .u-md-padLeft06 {
    padding-left: 0.335rem !important;
  }

  ::v-deep .u-md-padRight06 {
    padding-right: 0.335rem !important;
  }

  ::v-deep .u-md-spaceItems05 > * + * {
    margin-top: 0.402rem !important;
  }

  ::v-deep .u-md-staggerItems05 > * + * {
    margin-top: 0.402em !important;
  }

  ::v-deep .u-md-space05 {
    margin: 0.402rem !important;
  }

  ::v-deep .u-md-spaceEnds05 {
    margin-bottom: 0.402rem !important;
    margin-top: 0.402rem !important;
  }

  ::v-deep .u-md-spaceSides05 {
    margin-left: 0.402rem !important;
    margin-right: 0.402rem !important;
  }

  ::v-deep .u-md-spaceTop05 {
    margin-top: 0.402rem !important;
  }

  ::v-deep .u-md-spaceBottom05 {
    margin-bottom: 0.402rem !important;
  }

  ::v-deep .u-md-spaceLeft05 {
    margin-left: 0.402rem !important;
  }

  ::v-deep .u-md-spaceRight05 {
    margin-right: 0.402rem !important;
  }

  ::v-deep .u-md-pull05 {
    margin: -0.402rem !important;
  }

  ::v-deep .u-md-pullEnds05 {
    margin-bottom: -0.402rem !important;
    margin-top: -0.402rem !important;
  }

  ::v-deep .u-md-pullSides05 {
    margin-left: -0.402rem !important;
    margin-right: -0.402rem !important;
  }

  ::v-deep .u-md-pullTop05 {
    margin-top: -0.402rem !important;
  }

  ::v-deep .u-md-pullBottom05 {
    margin-bottom: -0.402rem !important;
  }

  ::v-deep .u-md-pullLeft05 {
    margin-left: -0.402rem !important;
  }

  ::v-deep .u-md-pullRight05 {
    margin-right: -0.402rem !important;
  }

  ::v-deep .u-md-pad05 {
    padding: 0.402rem !important;
  }

  ::v-deep .u-md-padEnds05 {
    padding-bottom: 0.402rem !important;
    padding-top: 0.402rem !important;
  }

  ::v-deep .u-md-padSides05 {
    padding-left: 0.402rem !important;
    padding-right: 0.402rem !important;
  }

  ::v-deep .u-md-padTop05 {
    padding-top: 0.402rem !important;
  }

  ::v-deep .u-md-padBottom05 {
    padding-bottom: 0.402rem !important;
  }

  ::v-deep .u-md-padLeft05 {
    padding-left: 0.402rem !important;
  }

  ::v-deep .u-md-padRight05 {
    padding-right: 0.402rem !important;
  }

  ::v-deep .u-md-spaceItems04 > * + * {
    margin-top: 0.482rem !important;
  }

  ::v-deep .u-md-staggerItems04 > * + * {
    margin-top: 0.482em !important;
  }

  ::v-deep .u-md-space04 {
    margin: 0.482rem !important;
  }

  ::v-deep .u-md-spaceEnds04 {
    margin-bottom: 0.482rem !important;
    margin-top: 0.482rem !important;
  }

  ::v-deep .u-md-spaceSides04 {
    margin-left: 0.482rem !important;
    margin-right: 0.482rem !important;
  }

  ::v-deep .u-md-spaceTop04 {
    margin-top: 0.482rem !important;
  }

  ::v-deep .u-md-spaceBottom04 {
    margin-bottom: 0.482rem !important;
  }

  ::v-deep .u-md-spaceLeft04 {
    margin-left: 0.482rem !important;
  }

  ::v-deep .u-md-spaceRight04 {
    margin-right: 0.482rem !important;
  }

  ::v-deep .u-md-pull04 {
    margin: -0.482rem !important;
  }

  ::v-deep .u-md-pullEnds04 {
    margin-bottom: -0.482rem !important;
    margin-top: -0.482rem !important;
  }

  ::v-deep .u-md-pullSides04 {
    margin-left: -0.482rem !important;
    margin-right: -0.482rem !important;
  }

  ::v-deep .u-md-pullTop04 {
    margin-top: -0.482rem !important;
  }

  ::v-deep .u-md-pullBottom04 {
    margin-bottom: -0.482rem !important;
  }

  ::v-deep .u-md-pullLeft04 {
    margin-left: -0.482rem !important;
  }

  ::v-deep .u-md-pullRight04 {
    margin-right: -0.482rem !important;
  }

  ::v-deep .u-md-pad04 {
    padding: 0.482rem !important;
  }

  ::v-deep .u-md-padEnds04 {
    padding-bottom: 0.482rem !important;
    padding-top: 0.482rem !important;
  }

  ::v-deep .u-md-padSides04 {
    padding-left: 0.482rem !important;
    padding-right: 0.482rem !important;
  }

  ::v-deep .u-md-padTop04 {
    padding-top: 0.482rem !important;
  }

  ::v-deep .u-md-padBottom04 {
    padding-bottom: 0.482rem !important;
  }

  ::v-deep .u-md-padLeft04 {
    padding-left: 0.482rem !important;
  }

  ::v-deep .u-md-padRight04 {
    padding-right: 0.482rem !important;
  }

  ::v-deep .u-md-spaceItems03 > * + * {
    margin-top: 0.579rem !important;
  }

  ::v-deep .u-md-staggerItems03 > * + * {
    margin-top: 0.579em !important;
  }

  ::v-deep .u-md-space03 {
    margin: 0.579rem !important;
  }

  ::v-deep .u-md-spaceEnds03 {
    margin-bottom: 0.579rem !important;
    margin-top: 0.579rem !important;
  }

  ::v-deep .u-md-spaceSides03 {
    margin-left: 0.579rem !important;
    margin-right: 0.579rem !important;
  }

  ::v-deep .u-md-spaceTop03 {
    margin-top: 0.579rem !important;
  }

  ::v-deep .u-md-spaceBottom03 {
    margin-bottom: 0.579rem !important;
  }

  ::v-deep .u-md-spaceLeft03 {
    margin-left: 0.579rem !important;
  }

  ::v-deep .u-md-spaceRight03 {
    margin-right: 0.579rem !important;
  }

  ::v-deep .u-md-pull03 {
    margin: -0.579rem !important;
  }

  ::v-deep .u-md-pullEnds03 {
    margin-bottom: -0.579rem !important;
    margin-top: -0.579rem !important;
  }

  ::v-deep .u-md-pullSides03 {
    margin-left: -0.579rem !important;
    margin-right: -0.579rem !important;
  }

  ::v-deep .u-md-pullTop03 {
    margin-top: -0.579rem !important;
  }

  ::v-deep .u-md-pullBottom03 {
    margin-bottom: -0.579rem !important;
  }

  ::v-deep .u-md-pullLeft03 {
    margin-left: -0.579rem !important;
  }

  ::v-deep .u-md-pullRight03 {
    margin-right: -0.579rem !important;
  }

  ::v-deep .u-md-pad03 {
    padding: 0.579rem !important;
  }

  ::v-deep .u-md-padEnds03 {
    padding-bottom: 0.579rem !important;
    padding-top: 0.579rem !important;
  }

  ::v-deep .u-md-padSides03 {
    padding-left: 0.579rem !important;
    padding-right: 0.579rem !important;
  }

  ::v-deep .u-md-padTop03 {
    padding-top: 0.579rem !important;
  }

  ::v-deep .u-md-padBottom03 {
    padding-bottom: 0.579rem !important;
  }

  ::v-deep .u-md-padLeft03 {
    padding-left: 0.579rem !important;
  }

  ::v-deep .u-md-padRight03 {
    padding-right: 0.579rem !important;
  }

  ::v-deep .u-md-spaceItems02 > * + * {
    margin-top: 0.694rem !important;
  }

  ::v-deep .u-md-staggerItems02 > * + * {
    margin-top: 0.694em !important;
  }

  ::v-deep .u-md-space02 {
    margin: 0.694rem !important;
  }

  ::v-deep .u-md-spaceEnds02 {
    margin-bottom: 0.694rem !important;
    margin-top: 0.694rem !important;
  }

  ::v-deep .u-md-spaceSides02 {
    margin-left: 0.694rem !important;
    margin-right: 0.694rem !important;
  }

  ::v-deep .u-md-spaceTop02 {
    margin-top: 0.694rem !important;
  }

  ::v-deep .u-md-spaceBottom02 {
    margin-bottom: 0.694rem !important;
  }

  ::v-deep .u-md-spaceLeft02 {
    margin-left: 0.694rem !important;
  }

  ::v-deep .u-md-spaceRight02 {
    margin-right: 0.694rem !important;
  }

  ::v-deep .u-md-pull02 {
    margin: -0.694rem !important;
  }

  ::v-deep .u-md-pullEnds02 {
    margin-bottom: -0.694rem !important;
    margin-top: -0.694rem !important;
  }

  ::v-deep .u-md-pullSides02 {
    margin-left: -0.694rem !important;
    margin-right: -0.694rem !important;
  }

  ::v-deep .u-md-pullTop02 {
    margin-top: -0.694rem !important;
  }

  ::v-deep .u-md-pullBottom02 {
    margin-bottom: -0.694rem !important;
  }

  ::v-deep .u-md-pullLeft02 {
    margin-left: -0.694rem !important;
  }

  ::v-deep .u-md-pullRight02 {
    margin-right: -0.694rem !important;
  }

  ::v-deep .u-md-pad02 {
    padding: 0.694rem !important;
  }

  ::v-deep .u-md-padEnds02 {
    padding-bottom: 0.694rem !important;
    padding-top: 0.694rem !important;
  }

  ::v-deep .u-md-padSides02 {
    padding-left: 0.694rem !important;
    padding-right: 0.694rem !important;
  }

  ::v-deep .u-md-padTop02 {
    padding-top: 0.694rem !important;
  }

  ::v-deep .u-md-padBottom02 {
    padding-bottom: 0.694rem !important;
  }

  ::v-deep .u-md-padLeft02 {
    padding-left: 0.694rem !important;
  }

  ::v-deep .u-md-padRight02 {
    padding-right: 0.694rem !important;
  }

  ::v-deep .u-md-spaceItems01 > * + * {
    margin-top: 0.833rem !important;
  }

  ::v-deep .u-md-staggerItems01 > * + * {
    margin-top: 0.833em !important;
  }

  ::v-deep .u-md-space01 {
    margin: 0.833rem !important;
  }

  ::v-deep .u-md-spaceEnds01 {
    margin-bottom: 0.833rem !important;
    margin-top: 0.833rem !important;
  }

  ::v-deep .u-md-spaceSides01 {
    margin-left: 0.833rem !important;
    margin-right: 0.833rem !important;
  }

  ::v-deep .u-md-spaceTop01 {
    margin-top: 0.833rem !important;
  }

  ::v-deep .u-md-spaceBottom01 {
    margin-bottom: 0.833rem !important;
  }

  ::v-deep .u-md-spaceLeft01 {
    margin-left: 0.833rem !important;
  }

  ::v-deep .u-md-spaceRight01 {
    margin-right: 0.833rem !important;
  }

  ::v-deep .u-md-pull01 {
    margin: -0.833rem !important;
  }

  ::v-deep .u-md-pullEnds01 {
    margin-bottom: -0.833rem !important;
    margin-top: -0.833rem !important;
  }

  ::v-deep .u-md-pullSides01 {
    margin-left: -0.833rem !important;
    margin-right: -0.833rem !important;
  }

  ::v-deep .u-md-pullTop01 {
    margin-top: -0.833rem !important;
  }

  ::v-deep .u-md-pullBottom01 {
    margin-bottom: -0.833rem !important;
  }

  ::v-deep .u-md-pullLeft01 {
    margin-left: -0.833rem !important;
  }

  ::v-deep .u-md-pullRight01 {
    margin-right: -0.833rem !important;
  }

  ::v-deep .u-md-pad01 {
    padding: 0.833rem !important;
  }

  ::v-deep .u-md-padEnds01 {
    padding-bottom: 0.833rem !important;
    padding-top: 0.833rem !important;
  }

  ::v-deep .u-md-padSides01 {
    padding-left: 0.833rem !important;
    padding-right: 0.833rem !important;
  }

  ::v-deep .u-md-padTop01 {
    padding-top: 0.833rem !important;
  }

  ::v-deep .u-md-padBottom01 {
    padding-bottom: 0.833rem !important;
  }

  ::v-deep .u-md-padLeft01 {
    padding-left: 0.833rem !important;
  }

  ::v-deep .u-md-padRight01 {
    padding-right: 0.833rem !important;
  }

  /**
   * Default values omit the suffix and use the `0` step.
   */

  ::v-deep .u-md-spaceItems > * + * {
    margin-top: 1rem !important;
  }

  ::v-deep .u-md-staggerItems > * + * {
    margin-top: 1em !important;
  }

  ::v-deep .u-md-space {
    margin: 1rem !important;
  }

  ::v-deep .u-md-spaceEnds {
    margin-bottom: 1rem !important;
    margin-top: 1rem !important;
  }

  ::v-deep .u-md-spaceSides {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  ::v-deep .u-md-spaceTop {
    margin-top: 1rem !important;
  }

  ::v-deep .u-md-spaceBottom {
    margin-bottom: 1rem !important;
  }

  ::v-deep .u-md-spaceLeft {
    margin-left: 1rem !important;
  }

  ::v-deep .u-md-spaceRight {
    margin-right: 1rem !important;
  }

  ::v-deep .u-md-pull {
    margin: -1rem !important;
  }

  ::v-deep .u-md-pullEnds {
    margin-bottom: -1rem !important;
    margin-top: -1rem !important;
  }

  ::v-deep .u-md-pullSides {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }

  ::v-deep .u-md-pullTop {
    margin-top: -1rem !important;
  }

  ::v-deep .u-md-pullBottom {
    margin-bottom: -1rem !important;
  }

  ::v-deep .u-md-pullLeft {
    margin-left: -1rem !important;
  }

  ::v-deep .u-md-pullRight {
    margin-right: -1rem !important;
  }

  ::v-deep .u-md-pad {
    padding: 1rem !important;
  }

  ::v-deep .u-md-padEnds {
    padding-bottom: 1rem !important;
    padding-top: 1rem !important;
  }

  ::v-deep .u-md-padSides {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  ::v-deep .u-md-padTop {
    padding-top: 1rem !important;
  }

  ::v-deep .u-md-padBottom {
    padding-bottom: 1rem !important;
  }

  ::v-deep .u-md-padLeft {
    padding-left: 1rem !important;
  }

  ::v-deep .u-md-padRight {
    padding-right: 1rem !important;
  }

  /**
   * Positive scale steps.
   */

  ::v-deep .u-md-spaceItems1 > * + * {
    margin-top: 1.2rem !important;
  }

  ::v-deep .u-md-staggerItems1 > * + * {
    margin-top: 1.2em !important;
  }

  ::v-deep .u-md-space1 {
    margin: 1.2rem !important;
  }

  ::v-deep .u-md-spaceEnds1 {
    margin-bottom: 1.2rem !important;
    margin-top: 1.2rem !important;
  }

  ::v-deep .u-md-spaceSides1 {
    margin-left: 1.2rem !important;
    margin-right: 1.2rem !important;
  }

  ::v-deep .u-md-spaceTop1 {
    margin-top: 1.2rem !important;
  }

  ::v-deep .u-md-spaceBottom1 {
    margin-bottom: 1.2rem !important;
  }

  ::v-deep .u-md-spaceLeft1 {
    margin-left: 1.2rem !important;
  }

  ::v-deep .u-md-spaceRight1 {
    margin-right: 1.2rem !important;
  }

  ::v-deep .u-md-pull1 {
    margin: -1.2rem !important;
  }

  ::v-deep .u-md-pullEnds1 {
    margin-bottom: -1.2rem !important;
    margin-top: -1.2rem !important;
  }

  ::v-deep .u-md-pullSides1 {
    margin-left: -1.2rem !important;
    margin-right: -1.2rem !important;
  }

  ::v-deep .u-md-pullTop1 {
    margin-top: -1.2rem !important;
  }

  ::v-deep .u-md-pullBottom1 {
    margin-bottom: -1.2rem !important;
  }

  ::v-deep .u-md-pullLeft1 {
    margin-left: -1.2rem !important;
  }

  ::v-deep .u-md-pullRight1 {
    margin-right: -1.2rem !important;
  }

  ::v-deep .u-md-pad1 {
    padding: 1.2rem !important;
  }

  ::v-deep .u-md-padEnds1 {
    padding-bottom: 1.2rem !important;
    padding-top: 1.2rem !important;
  }

  ::v-deep .u-md-padSides1 {
    padding-left: 1.2rem !important;
    padding-right: 1.2rem !important;
  }

  ::v-deep .u-md-padTop1 {
    padding-top: 1.2rem !important;
  }

  ::v-deep .u-md-padBottom1 {
    padding-bottom: 1.2rem !important;
  }

  ::v-deep .u-md-padLeft1 {
    padding-left: 1.2rem !important;
  }

  ::v-deep .u-md-padRight1 {
    padding-right: 1.2rem !important;
  }

  ::v-deep .u-md-spaceItems2 > * + * {
    margin-top: 1.44rem !important;
  }

  ::v-deep .u-md-staggerItems2 > * + * {
    margin-top: 1.44em !important;
  }

  ::v-deep .u-md-space2 {
    margin: 1.44rem !important;
  }

  ::v-deep .u-md-spaceEnds2 {
    margin-bottom: 1.44rem !important;
    margin-top: 1.44rem !important;
  }

  ::v-deep .u-md-spaceSides2 {
    margin-left: 1.44rem !important;
    margin-right: 1.44rem !important;
  }

  ::v-deep .u-md-spaceTop2 {
    margin-top: 1.44rem !important;
  }

  ::v-deep .u-md-spaceBottom2 {
    margin-bottom: 1.44rem !important;
  }

  ::v-deep .u-md-spaceLeft2 {
    margin-left: 1.44rem !important;
  }

  ::v-deep .u-md-spaceRight2 {
    margin-right: 1.44rem !important;
  }

  ::v-deep .u-md-pull2 {
    margin: -1.44rem !important;
  }

  ::v-deep .u-md-pullEnds2 {
    margin-bottom: -1.44rem !important;
    margin-top: -1.44rem !important;
  }

  ::v-deep .u-md-pullSides2 {
    margin-left: -1.44rem !important;
    margin-right: -1.44rem !important;
  }

  ::v-deep .u-md-pullTop2 {
    margin-top: -1.44rem !important;
  }

  ::v-deep .u-md-pullBottom2 {
    margin-bottom: -1.44rem !important;
  }

  ::v-deep .u-md-pullLeft2 {
    margin-left: -1.44rem !important;
  }

  ::v-deep .u-md-pullRight2 {
    margin-right: -1.44rem !important;
  }

  ::v-deep .u-md-pad2 {
    padding: 1.44rem !important;
  }

  ::v-deep .u-md-padEnds2 {
    padding-bottom: 1.44rem !important;
    padding-top: 1.44rem !important;
  }

  ::v-deep .u-md-padSides2 {
    padding-left: 1.44rem !important;
    padding-right: 1.44rem !important;
  }

  ::v-deep .u-md-padTop2 {
    padding-top: 1.44rem !important;
  }

  ::v-deep .u-md-padBottom2 {
    padding-bottom: 1.44rem !important;
  }

  ::v-deep .u-md-padLeft2 {
    padding-left: 1.44rem !important;
  }

  ::v-deep .u-md-padRight2 {
    padding-right: 1.44rem !important;
  }

  ::v-deep .u-md-spaceItems3 > * + * {
    margin-top: 1.728rem !important;
  }

  ::v-deep .u-md-staggerItems3 > * + * {
    margin-top: 1.728em !important;
  }

  ::v-deep .u-md-space3 {
    margin: 1.728rem !important;
  }

  ::v-deep .u-md-spaceEnds3 {
    margin-bottom: 1.728rem !important;
    margin-top: 1.728rem !important;
  }

  ::v-deep .u-md-spaceSides3 {
    margin-left: 1.728rem !important;
    margin-right: 1.728rem !important;
  }

  ::v-deep .u-md-spaceTop3 {
    margin-top: 1.728rem !important;
  }

  ::v-deep .u-md-spaceBottom3 {
    margin-bottom: 1.728rem !important;
  }

  ::v-deep .u-md-spaceLeft3 {
    margin-left: 1.728rem !important;
  }

  ::v-deep .u-md-spaceRight3 {
    margin-right: 1.728rem !important;
  }

  ::v-deep .u-md-pull3 {
    margin: -1.728rem !important;
  }

  ::v-deep .u-md-pullEnds3 {
    margin-bottom: -1.728rem !important;
    margin-top: -1.728rem !important;
  }

  ::v-deep .u-md-pullSides3 {
    margin-left: -1.728rem !important;
    margin-right: -1.728rem !important;
  }

  ::v-deep .u-md-pullTop3 {
    margin-top: -1.728rem !important;
  }

  ::v-deep .u-md-pullBottom3 {
    margin-bottom: -1.728rem !important;
  }

  ::v-deep .u-md-pullLeft3 {
    margin-left: -1.728rem !important;
  }

  ::v-deep .u-md-pullRight3 {
    margin-right: -1.728rem !important;
  }

  ::v-deep .u-md-pad3 {
    padding: 1.728rem !important;
  }

  ::v-deep .u-md-padEnds3 {
    padding-bottom: 1.728rem !important;
    padding-top: 1.728rem !important;
  }

  ::v-deep .u-md-padSides3 {
    padding-left: 1.728rem !important;
    padding-right: 1.728rem !important;
  }

  ::v-deep .u-md-padTop3 {
    padding-top: 1.728rem !important;
  }

  ::v-deep .u-md-padBottom3 {
    padding-bottom: 1.728rem !important;
  }

  ::v-deep .u-md-padLeft3 {
    padding-left: 1.728rem !important;
  }

  ::v-deep .u-md-padRight3 {
    padding-right: 1.728rem !important;
  }

  ::v-deep .u-md-spaceItems4 > * + * {
    margin-top: 2.074rem !important;
  }

  ::v-deep .u-md-staggerItems4 > * + * {
    margin-top: 2.074em !important;
  }

  ::v-deep .u-md-space4 {
    margin: 2.074rem !important;
  }

  ::v-deep .u-md-spaceEnds4 {
    margin-bottom: 2.074rem !important;
    margin-top: 2.074rem !important;
  }

  ::v-deep .u-md-spaceSides4 {
    margin-left: 2.074rem !important;
    margin-right: 2.074rem !important;
  }

  ::v-deep .u-md-spaceTop4 {
    margin-top: 2.074rem !important;
  }

  ::v-deep .u-md-spaceBottom4 {
    margin-bottom: 2.074rem !important;
  }

  ::v-deep .u-md-spaceLeft4 {
    margin-left: 2.074rem !important;
  }

  ::v-deep .u-md-spaceRight4 {
    margin-right: 2.074rem !important;
  }

  ::v-deep .u-md-pull4 {
    margin: -2.074rem !important;
  }

  ::v-deep .u-md-pullEnds4 {
    margin-bottom: -2.074rem !important;
    margin-top: -2.074rem !important;
  }

  ::v-deep .u-md-pullSides4 {
    margin-left: -2.074rem !important;
    margin-right: -2.074rem !important;
  }

  ::v-deep .u-md-pullTop4 {
    margin-top: -2.074rem !important;
  }

  ::v-deep .u-md-pullBottom4 {
    margin-bottom: -2.074rem !important;
  }

  ::v-deep .u-md-pullLeft4 {
    margin-left: -2.074rem !important;
  }

  ::v-deep .u-md-pullRight4 {
    margin-right: -2.074rem !important;
  }

  ::v-deep .u-md-pad4 {
    padding: 2.074rem !important;
  }

  ::v-deep .u-md-padEnds4 {
    padding-bottom: 2.074rem !important;
    padding-top: 2.074rem !important;
  }

  ::v-deep .u-md-padSides4 {
    padding-left: 2.074rem !important;
    padding-right: 2.074rem !important;
  }

  ::v-deep .u-md-padTop4 {
    padding-top: 2.074rem !important;
  }

  ::v-deep .u-md-padBottom4 {
    padding-bottom: 2.074rem !important;
  }

  ::v-deep .u-md-padLeft4 {
    padding-left: 2.074rem !important;
  }

  ::v-deep .u-md-padRight4 {
    padding-right: 2.074rem !important;
  }

  ::v-deep .u-md-spaceItems5 > * + * {
    margin-top: 2.488rem !important;
  }

  ::v-deep .u-md-staggerItems5 > * + * {
    margin-top: 2.488em !important;
  }

  ::v-deep .u-md-space5 {
    margin: 2.488rem !important;
  }

  ::v-deep .u-md-spaceEnds5 {
    margin-bottom: 2.488rem !important;
    margin-top: 2.488rem !important;
  }

  ::v-deep .u-md-spaceSides5 {
    margin-left: 2.488rem !important;
    margin-right: 2.488rem !important;
  }

  ::v-deep .u-md-spaceTop5 {
    margin-top: 2.488rem !important;
  }

  ::v-deep .u-md-spaceBottom5 {
    margin-bottom: 2.488rem !important;
  }

  ::v-deep .u-md-spaceLeft5 {
    margin-left: 2.488rem !important;
  }

  ::v-deep .u-md-spaceRight5 {
    margin-right: 2.488rem !important;
  }

  ::v-deep .u-md-pull5 {
    margin: -2.488rem !important;
  }

  ::v-deep .u-md-pullEnds5 {
    margin-bottom: -2.488rem !important;
    margin-top: -2.488rem !important;
  }

  ::v-deep .u-md-pullSides5 {
    margin-left: -2.488rem !important;
    margin-right: -2.488rem !important;
  }

  ::v-deep .u-md-pullTop5 {
    margin-top: -2.488rem !important;
  }

  ::v-deep .u-md-pullBottom5 {
    margin-bottom: -2.488rem !important;
  }

  ::v-deep .u-md-pullLeft5 {
    margin-left: -2.488rem !important;
  }

  ::v-deep .u-md-pullRight5 {
    margin-right: -2.488rem !important;
  }

  ::v-deep .u-md-pad5 {
    padding: 2.488rem !important;
  }

  ::v-deep .u-md-padEnds5 {
    padding-bottom: 2.488rem !important;
    padding-top: 2.488rem !important;
  }

  ::v-deep .u-md-padSides5 {
    padding-left: 2.488rem !important;
    padding-right: 2.488rem !important;
  }

  ::v-deep .u-md-padTop5 {
    padding-top: 2.488rem !important;
  }

  ::v-deep .u-md-padBottom5 {
    padding-bottom: 2.488rem !important;
  }

  ::v-deep .u-md-padLeft5 {
    padding-left: 2.488rem !important;
  }

  ::v-deep .u-md-padRight5 {
    padding-right: 2.488rem !important;
  }

  ::v-deep .u-md-spaceItems6 > * + * {
    margin-top: 2.986rem !important;
  }

  ::v-deep .u-md-staggerItems6 > * + * {
    margin-top: 2.986em !important;
  }

  ::v-deep .u-md-space6 {
    margin: 2.986rem !important;
  }

  ::v-deep .u-md-spaceEnds6 {
    margin-bottom: 2.986rem !important;
    margin-top: 2.986rem !important;
  }

  ::v-deep .u-md-spaceSides6 {
    margin-left: 2.986rem !important;
    margin-right: 2.986rem !important;
  }

  ::v-deep .u-md-spaceTop6 {
    margin-top: 2.986rem !important;
  }

  ::v-deep .u-md-spaceBottom6 {
    margin-bottom: 2.986rem !important;
  }

  ::v-deep .u-md-spaceLeft6 {
    margin-left: 2.986rem !important;
  }

  ::v-deep .u-md-spaceRight6 {
    margin-right: 2.986rem !important;
  }

  ::v-deep .u-md-pull6 {
    margin: -2.986rem !important;
  }

  ::v-deep .u-md-pullEnds6 {
    margin-bottom: -2.986rem !important;
    margin-top: -2.986rem !important;
  }

  ::v-deep .u-md-pullSides6 {
    margin-left: -2.986rem !important;
    margin-right: -2.986rem !important;
  }

  ::v-deep .u-md-pullTop6 {
    margin-top: -2.986rem !important;
  }

  ::v-deep .u-md-pullBottom6 {
    margin-bottom: -2.986rem !important;
  }

  ::v-deep .u-md-pullLeft6 {
    margin-left: -2.986rem !important;
  }

  ::v-deep .u-md-pullRight6 {
    margin-right: -2.986rem !important;
  }

  ::v-deep .u-md-pad6 {
    padding: 2.986rem !important;
  }

  ::v-deep .u-md-padEnds6 {
    padding-bottom: 2.986rem !important;
    padding-top: 2.986rem !important;
  }

  ::v-deep .u-md-padSides6 {
    padding-left: 2.986rem !important;
    padding-right: 2.986rem !important;
  }

  ::v-deep .u-md-padTop6 {
    padding-top: 2.986rem !important;
  }

  ::v-deep .u-md-padBottom6 {
    padding-bottom: 2.986rem !important;
  }

  ::v-deep .u-md-padLeft6 {
    padding-left: 2.986rem !important;
  }

  ::v-deep .u-md-padRight6 {
    padding-right: 2.986rem !important;
  }

  /**
   * Reset utilities. These come last to give them slight precedence over the
   * other utilities to make it easier to clear whitespace across breakpoints.
   */

  ::v-deep .u-md-spaceNone {
    margin: 0 !important;
  }

  ::v-deep .u-md-spaceEndsNone {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
  }

  ::v-deep .u-md-spaceSidesNone {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  ::v-deep .u-md-spaceTopNone {
    margin-top: 0 !important;
  }

  ::v-deep .u-md-spaceBottomNone {
    margin-bottom: 0 !important;
  }

  ::v-deep .u-md-spaceLeftNone {
    margin-left: 0 !important;
  }

  ::v-deep .u-md-spaceRightNone {
    margin-right: 0 !important;
  }

  ::v-deep .u-md-padNone {
    padding: 0 !important;
  }

  ::v-deep .u-md-padEndsNone {
    padding-bottom: 0 !important;
    padding-top: 0 !important;
  }

  ::v-deep .u-md-padSidesNone {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  ::v-deep .u-md-padTopNone {
    padding-top: 0 !important;
  }

  ::v-deep .u-md-padBottomNone {
    padding-bottom: 0 !important;
  }

  ::v-deep .u-md-padLeftNone {
    padding-left: 0 !important;
  }

  ::v-deep .u-md-padRightNone {
    padding-right: 0 !important;
  }
}

@media (min-width: 64em) {
  /**
   * Negative scale steps swap `-` for `0`.
   */

  ::v-deep .u-lg-spaceItems06 > * + * {
    margin-top: 0.335rem !important;
  }

  ::v-deep .u-lg-staggerItems06 > * + * {
    margin-top: 0.335em !important;
  }

  ::v-deep .u-lg-space06 {
    margin: 0.335rem !important;
  }

  ::v-deep .u-lg-spaceEnds06 {
    margin-bottom: 0.335rem !important;
    margin-top: 0.335rem !important;
  }

  ::v-deep .u-lg-spaceSides06 {
    margin-left: 0.335rem !important;
    margin-right: 0.335rem !important;
  }

  ::v-deep .u-lg-spaceTop06 {
    margin-top: 0.335rem !important;
  }

  ::v-deep .u-lg-spaceBottom06 {
    margin-bottom: 0.335rem !important;
  }

  ::v-deep .u-lg-spaceLeft06 {
    margin-left: 0.335rem !important;
  }

  ::v-deep .u-lg-spaceRight06 {
    margin-right: 0.335rem !important;
  }

  ::v-deep .u-lg-pull06 {
    margin: -0.335rem !important;
  }

  ::v-deep .u-lg-pullEnds06 {
    margin-bottom: -0.335rem !important;
    margin-top: -0.335rem !important;
  }

  ::v-deep .u-lg-pullSides06 {
    margin-left: -0.335rem !important;
    margin-right: -0.335rem !important;
  }

  ::v-deep .u-lg-pullTop06 {
    margin-top: -0.335rem !important;
  }

  ::v-deep .u-lg-pullBottom06 {
    margin-bottom: -0.335rem !important;
  }

  ::v-deep .u-lg-pullLeft06 {
    margin-left: -0.335rem !important;
  }

  ::v-deep .u-lg-pullRight06 {
    margin-right: -0.335rem !important;
  }

  ::v-deep .u-lg-pad06 {
    padding: 0.335rem !important;
  }

  ::v-deep .u-lg-padEnds06 {
    padding-bottom: 0.335rem !important;
    padding-top: 0.335rem !important;
  }

  ::v-deep .u-lg-padSides06 {
    padding-left: 0.335rem !important;
    padding-right: 0.335rem !important;
  }

  ::v-deep .u-lg-padTop06 {
    padding-top: 0.335rem !important;
  }

  ::v-deep .u-lg-padBottom06 {
    padding-bottom: 0.335rem !important;
  }

  ::v-deep .u-lg-padLeft06 {
    padding-left: 0.335rem !important;
  }

  ::v-deep .u-lg-padRight06 {
    padding-right: 0.335rem !important;
  }

  ::v-deep .u-lg-spaceItems05 > * + * {
    margin-top: 0.402rem !important;
  }

  ::v-deep .u-lg-staggerItems05 > * + * {
    margin-top: 0.402em !important;
  }

  ::v-deep .u-lg-space05 {
    margin: 0.402rem !important;
  }

  ::v-deep .u-lg-spaceEnds05 {
    margin-bottom: 0.402rem !important;
    margin-top: 0.402rem !important;
  }

  ::v-deep .u-lg-spaceSides05 {
    margin-left: 0.402rem !important;
    margin-right: 0.402rem !important;
  }

  ::v-deep .u-lg-spaceTop05 {
    margin-top: 0.402rem !important;
  }

  ::v-deep .u-lg-spaceBottom05 {
    margin-bottom: 0.402rem !important;
  }

  ::v-deep .u-lg-spaceLeft05 {
    margin-left: 0.402rem !important;
  }

  ::v-deep .u-lg-spaceRight05 {
    margin-right: 0.402rem !important;
  }

  ::v-deep .u-lg-pull05 {
    margin: -0.402rem !important;
  }

  ::v-deep .u-lg-pullEnds05 {
    margin-bottom: -0.402rem !important;
    margin-top: -0.402rem !important;
  }

  ::v-deep .u-lg-pullSides05 {
    margin-left: -0.402rem !important;
    margin-right: -0.402rem !important;
  }

  ::v-deep .u-lg-pullTop05 {
    margin-top: -0.402rem !important;
  }

  ::v-deep .u-lg-pullBottom05 {
    margin-bottom: -0.402rem !important;
  }

  ::v-deep .u-lg-pullLeft05 {
    margin-left: -0.402rem !important;
  }

  ::v-deep .u-lg-pullRight05 {
    margin-right: -0.402rem !important;
  }

  ::v-deep .u-lg-pad05 {
    padding: 0.402rem !important;
  }

  ::v-deep .u-lg-padEnds05 {
    padding-bottom: 0.402rem !important;
    padding-top: 0.402rem !important;
  }

  ::v-deep .u-lg-padSides05 {
    padding-left: 0.402rem !important;
    padding-right: 0.402rem !important;
  }

  ::v-deep .u-lg-padTop05 {
    padding-top: 0.402rem !important;
  }

  ::v-deep .u-lg-padBottom05 {
    padding-bottom: 0.402rem !important;
  }

  ::v-deep .u-lg-padLeft05 {
    padding-left: 0.402rem !important;
  }

  ::v-deep .u-lg-padRight05 {
    padding-right: 0.402rem !important;
  }

  ::v-deep .u-lg-spaceItems04 > * + * {
    margin-top: 0.482rem !important;
  }

  ::v-deep .u-lg-staggerItems04 > * + * {
    margin-top: 0.482em !important;
  }

  ::v-deep .u-lg-space04 {
    margin: 0.482rem !important;
  }

  ::v-deep .u-lg-spaceEnds04 {
    margin-bottom: 0.482rem !important;
    margin-top: 0.482rem !important;
  }

  ::v-deep .u-lg-spaceSides04 {
    margin-left: 0.482rem !important;
    margin-right: 0.482rem !important;
  }

  ::v-deep .u-lg-spaceTop04 {
    margin-top: 0.482rem !important;
  }

  ::v-deep .u-lg-spaceBottom04 {
    margin-bottom: 0.482rem !important;
  }

  ::v-deep .u-lg-spaceLeft04 {
    margin-left: 0.482rem !important;
  }

  ::v-deep .u-lg-spaceRight04 {
    margin-right: 0.482rem !important;
  }

  ::v-deep .u-lg-pull04 {
    margin: -0.482rem !important;
  }

  ::v-deep .u-lg-pullEnds04 {
    margin-bottom: -0.482rem !important;
    margin-top: -0.482rem !important;
  }

  ::v-deep .u-lg-pullSides04 {
    margin-left: -0.482rem !important;
    margin-right: -0.482rem !important;
  }

  ::v-deep .u-lg-pullTop04 {
    margin-top: -0.482rem !important;
  }

  ::v-deep .u-lg-pullBottom04 {
    margin-bottom: -0.482rem !important;
  }

  ::v-deep .u-lg-pullLeft04 {
    margin-left: -0.482rem !important;
  }

  ::v-deep .u-lg-pullRight04 {
    margin-right: -0.482rem !important;
  }

  ::v-deep .u-lg-pad04 {
    padding: 0.482rem !important;
  }

  ::v-deep .u-lg-padEnds04 {
    padding-bottom: 0.482rem !important;
    padding-top: 0.482rem !important;
  }

  ::v-deep .u-lg-padSides04 {
    padding-left: 0.482rem !important;
    padding-right: 0.482rem !important;
  }

  ::v-deep .u-lg-padTop04 {
    padding-top: 0.482rem !important;
  }

  ::v-deep .u-lg-padBottom04 {
    padding-bottom: 0.482rem !important;
  }

  ::v-deep .u-lg-padLeft04 {
    padding-left: 0.482rem !important;
  }

  ::v-deep .u-lg-padRight04 {
    padding-right: 0.482rem !important;
  }

  ::v-deep .u-lg-spaceItems03 > * + * {
    margin-top: 0.579rem !important;
  }

  ::v-deep .u-lg-staggerItems03 > * + * {
    margin-top: 0.579em !important;
  }

  ::v-deep .u-lg-space03 {
    margin: 0.579rem !important;
  }

  ::v-deep .u-lg-spaceEnds03 {
    margin-bottom: 0.579rem !important;
    margin-top: 0.579rem !important;
  }

  ::v-deep .u-lg-spaceSides03 {
    margin-left: 0.579rem !important;
    margin-right: 0.579rem !important;
  }

  ::v-deep .u-lg-spaceTop03 {
    margin-top: 0.579rem !important;
  }

  ::v-deep .u-lg-spaceBottom03 {
    margin-bottom: 0.579rem !important;
  }

  ::v-deep .u-lg-spaceLeft03 {
    margin-left: 0.579rem !important;
  }

  ::v-deep .u-lg-spaceRight03 {
    margin-right: 0.579rem !important;
  }

  ::v-deep .u-lg-pull03 {
    margin: -0.579rem !important;
  }

  ::v-deep .u-lg-pullEnds03 {
    margin-bottom: -0.579rem !important;
    margin-top: -0.579rem !important;
  }

  ::v-deep .u-lg-pullSides03 {
    margin-left: -0.579rem !important;
    margin-right: -0.579rem !important;
  }

  ::v-deep .u-lg-pullTop03 {
    margin-top: -0.579rem !important;
  }

  ::v-deep .u-lg-pullBottom03 {
    margin-bottom: -0.579rem !important;
  }

  ::v-deep .u-lg-pullLeft03 {
    margin-left: -0.579rem !important;
  }

  ::v-deep .u-lg-pullRight03 {
    margin-right: -0.579rem !important;
  }

  ::v-deep .u-lg-pad03 {
    padding: 0.579rem !important;
  }

  ::v-deep .u-lg-padEnds03 {
    padding-bottom: 0.579rem !important;
    padding-top: 0.579rem !important;
  }

  ::v-deep .u-lg-padSides03 {
    padding-left: 0.579rem !important;
    padding-right: 0.579rem !important;
  }

  ::v-deep .u-lg-padTop03 {
    padding-top: 0.579rem !important;
  }

  ::v-deep .u-lg-padBottom03 {
    padding-bottom: 0.579rem !important;
  }

  ::v-deep .u-lg-padLeft03 {
    padding-left: 0.579rem !important;
  }

  ::v-deep .u-lg-padRight03 {
    padding-right: 0.579rem !important;
  }

  ::v-deep .u-lg-spaceItems02 > * + * {
    margin-top: 0.694rem !important;
  }

  ::v-deep .u-lg-staggerItems02 > * + * {
    margin-top: 0.694em !important;
  }

  ::v-deep .u-lg-space02 {
    margin: 0.694rem !important;
  }

  ::v-deep .u-lg-spaceEnds02 {
    margin-bottom: 0.694rem !important;
    margin-top: 0.694rem !important;
  }

  ::v-deep .u-lg-spaceSides02 {
    margin-left: 0.694rem !important;
    margin-right: 0.694rem !important;
  }

  ::v-deep .u-lg-spaceTop02 {
    margin-top: 0.694rem !important;
  }

  ::v-deep .u-lg-spaceBottom02 {
    margin-bottom: 0.694rem !important;
  }

  ::v-deep .u-lg-spaceLeft02 {
    margin-left: 0.694rem !important;
  }

  ::v-deep .u-lg-spaceRight02 {
    margin-right: 0.694rem !important;
  }

  ::v-deep .u-lg-pull02 {
    margin: -0.694rem !important;
  }

  ::v-deep .u-lg-pullEnds02 {
    margin-bottom: -0.694rem !important;
    margin-top: -0.694rem !important;
  }

  ::v-deep .u-lg-pullSides02 {
    margin-left: -0.694rem !important;
    margin-right: -0.694rem !important;
  }

  ::v-deep .u-lg-pullTop02 {
    margin-top: -0.694rem !important;
  }

  ::v-deep .u-lg-pullBottom02 {
    margin-bottom: -0.694rem !important;
  }

  ::v-deep .u-lg-pullLeft02 {
    margin-left: -0.694rem !important;
  }

  ::v-deep .u-lg-pullRight02 {
    margin-right: -0.694rem !important;
  }

  ::v-deep .u-lg-pad02 {
    padding: 0.694rem !important;
  }

  ::v-deep .u-lg-padEnds02 {
    padding-bottom: 0.694rem !important;
    padding-top: 0.694rem !important;
  }

  ::v-deep .u-lg-padSides02 {
    padding-left: 0.694rem !important;
    padding-right: 0.694rem !important;
  }

  ::v-deep .u-lg-padTop02 {
    padding-top: 0.694rem !important;
  }

  ::v-deep .u-lg-padBottom02 {
    padding-bottom: 0.694rem !important;
  }

  ::v-deep .u-lg-padLeft02 {
    padding-left: 0.694rem !important;
  }

  ::v-deep .u-lg-padRight02 {
    padding-right: 0.694rem !important;
  }

  ::v-deep .u-lg-spaceItems01 > * + * {
    margin-top: 0.833rem !important;
  }

  ::v-deep .u-lg-staggerItems01 > * + * {
    margin-top: 0.833em !important;
  }

  ::v-deep .u-lg-space01 {
    margin: 0.833rem !important;
  }

  ::v-deep .u-lg-spaceEnds01 {
    margin-bottom: 0.833rem !important;
    margin-top: 0.833rem !important;
  }

  ::v-deep .u-lg-spaceSides01 {
    margin-left: 0.833rem !important;
    margin-right: 0.833rem !important;
  }

  ::v-deep .u-lg-spaceTop01 {
    margin-top: 0.833rem !important;
  }

  ::v-deep .u-lg-spaceBottom01 {
    margin-bottom: 0.833rem !important;
  }

  ::v-deep .u-lg-spaceLeft01 {
    margin-left: 0.833rem !important;
  }

  ::v-deep .u-lg-spaceRight01 {
    margin-right: 0.833rem !important;
  }

  ::v-deep .u-lg-pull01 {
    margin: -0.833rem !important;
  }

  ::v-deep .u-lg-pullEnds01 {
    margin-bottom: -0.833rem !important;
    margin-top: -0.833rem !important;
  }

  ::v-deep .u-lg-pullSides01 {
    margin-left: -0.833rem !important;
    margin-right: -0.833rem !important;
  }

  ::v-deep .u-lg-pullTop01 {
    margin-top: -0.833rem !important;
  }

  ::v-deep .u-lg-pullBottom01 {
    margin-bottom: -0.833rem !important;
  }

  ::v-deep .u-lg-pullLeft01 {
    margin-left: -0.833rem !important;
  }

  ::v-deep .u-lg-pullRight01 {
    margin-right: -0.833rem !important;
  }

  ::v-deep .u-lg-pad01 {
    padding: 0.833rem !important;
  }

  ::v-deep .u-lg-padEnds01 {
    padding-bottom: 0.833rem !important;
    padding-top: 0.833rem !important;
  }

  ::v-deep .u-lg-padSides01 {
    padding-left: 0.833rem !important;
    padding-right: 0.833rem !important;
  }

  ::v-deep .u-lg-padTop01 {
    padding-top: 0.833rem !important;
  }

  ::v-deep .u-lg-padBottom01 {
    padding-bottom: 0.833rem !important;
  }

  ::v-deep .u-lg-padLeft01 {
    padding-left: 0.833rem !important;
  }

  ::v-deep .u-lg-padRight01 {
    padding-right: 0.833rem !important;
  }

  /**
   * Default values omit the suffix and use the `0` step.
   */

  ::v-deep .u-lg-spaceItems > * + * {
    margin-top: 1rem !important;
  }

  ::v-deep .u-lg-staggerItems > * + * {
    margin-top: 1em !important;
  }

  ::v-deep .u-lg-space {
    margin: 1rem !important;
  }

  ::v-deep .u-lg-spaceEnds {
    margin-bottom: 1rem !important;
    margin-top: 1rem !important;
  }

  ::v-deep .u-lg-spaceSides {
    margin-left: 1rem !important;
    margin-right: 1rem !important;
  }

  ::v-deep .u-lg-spaceTop {
    margin-top: 1rem !important;
  }

  ::v-deep .u-lg-spaceBottom {
    margin-bottom: 1rem !important;
  }

  ::v-deep .u-lg-spaceLeft {
    margin-left: 1rem !important;
  }

  ::v-deep .u-lg-spaceRight {
    margin-right: 1rem !important;
  }

  ::v-deep .u-lg-pull {
    margin: -1rem !important;
  }

  ::v-deep .u-lg-pullEnds {
    margin-bottom: -1rem !important;
    margin-top: -1rem !important;
  }

  ::v-deep .u-lg-pullSides {
    margin-left: -1rem !important;
    margin-right: -1rem !important;
  }

  ::v-deep .u-lg-pullTop {
    margin-top: -1rem !important;
  }

  ::v-deep .u-lg-pullBottom {
    margin-bottom: -1rem !important;
  }

  ::v-deep .u-lg-pullLeft {
    margin-left: -1rem !important;
  }

  ::v-deep .u-lg-pullRight {
    margin-right: -1rem !important;
  }

  ::v-deep .u-lg-pad {
    padding: 1rem !important;
  }

  ::v-deep .u-lg-padEnds {
    padding-bottom: 1rem !important;
    padding-top: 1rem !important;
  }

  ::v-deep .u-lg-padSides {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  ::v-deep .u-lg-padTop {
    padding-top: 1rem !important;
  }

  ::v-deep .u-lg-padBottom {
    padding-bottom: 1rem !important;
  }

  ::v-deep .u-lg-padLeft {
    padding-left: 1rem !important;
  }

  ::v-deep .u-lg-padRight {
    padding-right: 1rem !important;
  }

  /**
   * Positive scale steps.
   */

  ::v-deep .u-lg-spaceItems1 > * + * {
    margin-top: 1.2rem !important;
  }

  ::v-deep .u-lg-staggerItems1 > * + * {
    margin-top: 1.2em !important;
  }

  ::v-deep .u-lg-space1 {
    margin: 1.2rem !important;
  }

  ::v-deep .u-lg-spaceEnds1 {
    margin-bottom: 1.2rem !important;
    margin-top: 1.2rem !important;
  }

  ::v-deep .u-lg-spaceSides1 {
    margin-left: 1.2rem !important;
    margin-right: 1.2rem !important;
  }

  ::v-deep .u-lg-spaceTop1 {
    margin-top: 1.2rem !important;
  }

  ::v-deep .u-lg-spaceBottom1 {
    margin-bottom: 1.2rem !important;
  }

  ::v-deep .u-lg-spaceLeft1 {
    margin-left: 1.2rem !important;
  }

  ::v-deep .u-lg-spaceRight1 {
    margin-right: 1.2rem !important;
  }

  ::v-deep .u-lg-pull1 {
    margin: -1.2rem !important;
  }

  ::v-deep .u-lg-pullEnds1 {
    margin-bottom: -1.2rem !important;
    margin-top: -1.2rem !important;
  }

  ::v-deep .u-lg-pullSides1 {
    margin-left: -1.2rem !important;
    margin-right: -1.2rem !important;
  }

  ::v-deep .u-lg-pullTop1 {
    margin-top: -1.2rem !important;
  }

  ::v-deep .u-lg-pullBottom1 {
    margin-bottom: -1.2rem !important;
  }

  ::v-deep .u-lg-pullLeft1 {
    margin-left: -1.2rem !important;
  }

  ::v-deep .u-lg-pullRight1 {
    margin-right: -1.2rem !important;
  }

  ::v-deep .u-lg-pad1 {
    padding: 1.2rem !important;
  }

  ::v-deep .u-lg-padEnds1 {
    padding-bottom: 1.2rem !important;
    padding-top: 1.2rem !important;
  }

  ::v-deep .u-lg-padSides1 {
    padding-left: 1.2rem !important;
    padding-right: 1.2rem !important;
  }

  ::v-deep .u-lg-padTop1 {
    padding-top: 1.2rem !important;
  }

  ::v-deep .u-lg-padBottom1 {
    padding-bottom: 1.2rem !important;
  }

  ::v-deep .u-lg-padLeft1 {
    padding-left: 1.2rem !important;
  }

  ::v-deep .u-lg-padRight1 {
    padding-right: 1.2rem !important;
  }

  ::v-deep .u-lg-spaceItems2 > * + * {
    margin-top: 1.44rem !important;
  }

  ::v-deep .u-lg-staggerItems2 > * + * {
    margin-top: 1.44em !important;
  }

  ::v-deep .u-lg-space2 {
    margin: 1.44rem !important;
  }

  ::v-deep .u-lg-spaceEnds2 {
    margin-bottom: 1.44rem !important;
    margin-top: 1.44rem !important;
  }

  ::v-deep .u-lg-spaceSides2 {
    margin-left: 1.44rem !important;
    margin-right: 1.44rem !important;
  }

  ::v-deep .u-lg-spaceTop2 {
    margin-top: 1.44rem !important;
  }

  ::v-deep .u-lg-spaceBottom2 {
    margin-bottom: 1.44rem !important;
  }

  ::v-deep .u-lg-spaceLeft2 {
    margin-left: 1.44rem !important;
  }

  ::v-deep .u-lg-spaceRight2 {
    margin-right: 1.44rem !important;
  }

  ::v-deep .u-lg-pull2 {
    margin: -1.44rem !important;
  }

  ::v-deep .u-lg-pullEnds2 {
    margin-bottom: -1.44rem !important;
    margin-top: -1.44rem !important;
  }

  ::v-deep .u-lg-pullSides2 {
    margin-left: -1.44rem !important;
    margin-right: -1.44rem !important;
  }

  ::v-deep .u-lg-pullTop2 {
    margin-top: -1.44rem !important;
  }

  ::v-deep .u-lg-pullBottom2 {
    margin-bottom: -1.44rem !important;
  }

  ::v-deep .u-lg-pullLeft2 {
    margin-left: -1.44rem !important;
  }

  ::v-deep .u-lg-pullRight2 {
    margin-right: -1.44rem !important;
  }

  ::v-deep .u-lg-pad2 {
    padding: 1.44rem !important;
  }

  ::v-deep .u-lg-padEnds2 {
    padding-bottom: 1.44rem !important;
    padding-top: 1.44rem !important;
  }

  ::v-deep .u-lg-padSides2 {
    padding-left: 1.44rem !important;
    padding-right: 1.44rem !important;
  }

  ::v-deep .u-lg-padTop2 {
    padding-top: 1.44rem !important;
  }

  ::v-deep .u-lg-padBottom2 {
    padding-bottom: 1.44rem !important;
  }

  ::v-deep .u-lg-padLeft2 {
    padding-left: 1.44rem !important;
  }

  ::v-deep .u-lg-padRight2 {
    padding-right: 1.44rem !important;
  }

  ::v-deep .u-lg-spaceItems3 > * + * {
    margin-top: 1.728rem !important;
  }

  ::v-deep .u-lg-staggerItems3 > * + * {
    margin-top: 1.728em !important;
  }

  ::v-deep .u-lg-space3 {
    margin: 1.728rem !important;
  }

  ::v-deep .u-lg-spaceEnds3 {
    margin-bottom: 1.728rem !important;
    margin-top: 1.728rem !important;
  }

  ::v-deep .u-lg-spaceSides3 {
    margin-left: 1.728rem !important;
    margin-right: 1.728rem !important;
  }

  ::v-deep .u-lg-spaceTop3 {
    margin-top: 1.728rem !important;
  }

  ::v-deep .u-lg-spaceBottom3 {
    margin-bottom: 1.728rem !important;
  }

  ::v-deep .u-lg-spaceLeft3 {
    margin-left: 1.728rem !important;
  }

  ::v-deep .u-lg-spaceRight3 {
    margin-right: 1.728rem !important;
  }

  ::v-deep .u-lg-pull3 {
    margin: -1.728rem !important;
  }

  ::v-deep .u-lg-pullEnds3 {
    margin-bottom: -1.728rem !important;
    margin-top: -1.728rem !important;
  }

  ::v-deep .u-lg-pullSides3 {
    margin-left: -1.728rem !important;
    margin-right: -1.728rem !important;
  }

  ::v-deep .u-lg-pullTop3 {
    margin-top: -1.728rem !important;
  }

  ::v-deep .u-lg-pullBottom3 {
    margin-bottom: -1.728rem !important;
  }

  ::v-deep .u-lg-pullLeft3 {
    margin-left: -1.728rem !important;
  }

  ::v-deep .u-lg-pullRight3 {
    margin-right: -1.728rem !important;
  }

  ::v-deep .u-lg-pad3 {
    padding: 1.728rem !important;
  }

  ::v-deep .u-lg-padEnds3 {
    padding-bottom: 1.728rem !important;
    padding-top: 1.728rem !important;
  }

  ::v-deep .u-lg-padSides3 {
    padding-left: 1.728rem !important;
    padding-right: 1.728rem !important;
  }

  ::v-deep .u-lg-padTop3 {
    padding-top: 1.728rem !important;
  }

  ::v-deep .u-lg-padBottom3 {
    padding-bottom: 1.728rem !important;
  }

  ::v-deep .u-lg-padLeft3 {
    padding-left: 1.728rem !important;
  }

  ::v-deep .u-lg-padRight3 {
    padding-right: 1.728rem !important;
  }

  ::v-deep .u-lg-spaceItems4 > * + * {
    margin-top: 2.074rem !important;
  }

  ::v-deep .u-lg-staggerItems4 > * + * {
    margin-top: 2.074em !important;
  }

  ::v-deep .u-lg-space4 {
    margin: 2.074rem !important;
  }

  ::v-deep .u-lg-spaceEnds4 {
    margin-bottom: 2.074rem !important;
    margin-top: 2.074rem !important;
  }

  ::v-deep .u-lg-spaceSides4 {
    margin-left: 2.074rem !important;
    margin-right: 2.074rem !important;
  }

  ::v-deep .u-lg-spaceTop4 {
    margin-top: 2.074rem !important;
  }

  ::v-deep .u-lg-spaceBottom4 {
    margin-bottom: 2.074rem !important;
  }

  ::v-deep .u-lg-spaceLeft4 {
    margin-left: 2.074rem !important;
  }

  ::v-deep .u-lg-spaceRight4 {
    margin-right: 2.074rem !important;
  }

  ::v-deep .u-lg-pull4 {
    margin: -2.074rem !important;
  }

  ::v-deep .u-lg-pullEnds4 {
    margin-bottom: -2.074rem !important;
    margin-top: -2.074rem !important;
  }

  ::v-deep .u-lg-pullSides4 {
    margin-left: -2.074rem !important;
    margin-right: -2.074rem !important;
  }

  ::v-deep .u-lg-pullTop4 {
    margin-top: -2.074rem !important;
  }

  ::v-deep .u-lg-pullBottom4 {
    margin-bottom: -2.074rem !important;
  }

  ::v-deep .u-lg-pullLeft4 {
    margin-left: -2.074rem !important;
  }

  ::v-deep .u-lg-pullRight4 {
    margin-right: -2.074rem !important;
  }

  ::v-deep .u-lg-pad4 {
    padding: 2.074rem !important;
  }

  ::v-deep .u-lg-padEnds4 {
    padding-bottom: 2.074rem !important;
    padding-top: 2.074rem !important;
  }

  ::v-deep .u-lg-padSides4 {
    padding-left: 2.074rem !important;
    padding-right: 2.074rem !important;
  }

  ::v-deep .u-lg-padTop4 {
    padding-top: 2.074rem !important;
  }

  ::v-deep .u-lg-padBottom4 {
    padding-bottom: 2.074rem !important;
  }

  ::v-deep .u-lg-padLeft4 {
    padding-left: 2.074rem !important;
  }

  ::v-deep .u-lg-padRight4 {
    padding-right: 2.074rem !important;
  }

  ::v-deep .u-lg-spaceItems5 > * + * {
    margin-top: 2.488rem !important;
  }

  ::v-deep .u-lg-staggerItems5 > * + * {
    margin-top: 2.488em !important;
  }

  ::v-deep .u-lg-space5 {
    margin: 2.488rem !important;
  }

  ::v-deep .u-lg-spaceEnds5 {
    margin-bottom: 2.488rem !important;
    margin-top: 2.488rem !important;
  }

  ::v-deep .u-lg-spaceSides5 {
    margin-left: 2.488rem !important;
    margin-right: 2.488rem !important;
  }

  ::v-deep .u-lg-spaceTop5 {
    margin-top: 2.488rem !important;
  }

  ::v-deep .u-lg-spaceBottom5 {
    margin-bottom: 2.488rem !important;
  }

  ::v-deep .u-lg-spaceLeft5 {
    margin-left: 2.488rem !important;
  }

  ::v-deep .u-lg-spaceRight5 {
    margin-right: 2.488rem !important;
  }

  ::v-deep .u-lg-pull5 {
    margin: -2.488rem !important;
  }

  ::v-deep .u-lg-pullEnds5 {
    margin-bottom: -2.488rem !important;
    margin-top: -2.488rem !important;
  }

  ::v-deep .u-lg-pullSides5 {
    margin-left: -2.488rem !important;
    margin-right: -2.488rem !important;
  }

  ::v-deep .u-lg-pullTop5 {
    margin-top: -2.488rem !important;
  }

  ::v-deep .u-lg-pullBottom5 {
    margin-bottom: -2.488rem !important;
  }

  ::v-deep .u-lg-pullLeft5 {
    margin-left: -2.488rem !important;
  }

  ::v-deep .u-lg-pullRight5 {
    margin-right: -2.488rem !important;
  }

  ::v-deep .u-lg-pad5 {
    padding: 2.488rem !important;
  }

  ::v-deep .u-lg-padEnds5 {
    padding-bottom: 2.488rem !important;
    padding-top: 2.488rem !important;
  }

  ::v-deep .u-lg-padSides5 {
    padding-left: 2.488rem !important;
    padding-right: 2.488rem !important;
  }

  ::v-deep .u-lg-padTop5 {
    padding-top: 2.488rem !important;
  }

  ::v-deep .u-lg-padBottom5 {
    padding-bottom: 2.488rem !important;
  }

  ::v-deep .u-lg-padLeft5 {
    padding-left: 2.488rem !important;
  }

  ::v-deep .u-lg-padRight5 {
    padding-right: 2.488rem !important;
  }

  ::v-deep .u-lg-spaceItems6 > * + * {
    margin-top: 2.986rem !important;
  }

  ::v-deep .u-lg-staggerItems6 > * + * {
    margin-top: 2.986em !important;
  }

  ::v-deep .u-lg-space6 {
    margin: 2.986rem !important;
  }

  ::v-deep .u-lg-spaceEnds6 {
    margin-bottom: 2.986rem !important;
    margin-top: 2.986rem !important;
  }

  ::v-deep .u-lg-spaceSides6 {
    margin-left: 2.986rem !important;
    margin-right: 2.986rem !important;
  }

  ::v-deep .u-lg-spaceTop6 {
    margin-top: 2.986rem !important;
  }

  ::v-deep .u-lg-spaceBottom6 {
    margin-bottom: 2.986rem !important;
  }

  ::v-deep .u-lg-spaceLeft6 {
    margin-left: 2.986rem !important;
  }

  ::v-deep .u-lg-spaceRight6 {
    margin-right: 2.986rem !important;
  }

  ::v-deep .u-lg-pull6 {
    margin: -2.986rem !important;
  }

  ::v-deep .u-lg-pullEnds6 {
    margin-bottom: -2.986rem !important;
    margin-top: -2.986rem !important;
  }

  ::v-deep .u-lg-pullSides6 {
    margin-left: -2.986rem !important;
    margin-right: -2.986rem !important;
  }

  ::v-deep .u-lg-pullTop6 {
    margin-top: -2.986rem !important;
  }

  ::v-deep .u-lg-pullBottom6 {
    margin-bottom: -2.986rem !important;
  }

  ::v-deep .u-lg-pullLeft6 {
    margin-left: -2.986rem !important;
  }

  ::v-deep .u-lg-pullRight6 {
    margin-right: -2.986rem !important;
  }

  ::v-deep .u-lg-pad6 {
    padding: 2.986rem !important;
  }

  ::v-deep .u-lg-padEnds6 {
    padding-bottom: 2.986rem !important;
    padding-top: 2.986rem !important;
  }

  ::v-deep .u-lg-padSides6 {
    padding-left: 2.986rem !important;
    padding-right: 2.986rem !important;
  }

  ::v-deep .u-lg-padTop6 {
    padding-top: 2.986rem !important;
  }

  ::v-deep .u-lg-padBottom6 {
    padding-bottom: 2.986rem !important;
  }

  ::v-deep .u-lg-padLeft6 {
    padding-left: 2.986rem !important;
  }

  ::v-deep .u-lg-padRight6 {
    padding-right: 2.986rem !important;
  }

  /**
   * Reset utilities. These come last to give them slight precedence over the
   * other utilities to make it easier to clear whitespace across breakpoints.
   */

  ::v-deep .u-lg-spaceNone {
    margin: 0 !important;
  }

  ::v-deep .u-lg-spaceEndsNone {
    margin-bottom: 0 !important;
    margin-top: 0 !important;
  }

  ::v-deep .u-lg-spaceSidesNone {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  ::v-deep .u-lg-spaceTopNone {
    margin-top: 0 !important;
  }

  ::v-deep .u-lg-spaceBottomNone {
    margin-bottom: 0 !important;
  }

  ::v-deep .u-lg-spaceLeftNone {
    margin-left: 0 !important;
  }

  ::v-deep .u-lg-spaceRightNone {
    margin-right: 0 !important;
  }

  ::v-deep .u-lg-padNone {
    padding: 0 !important;
  }

  ::v-deep .u-lg-padEndsNone {
    padding-bottom: 0 !important;
    padding-top: 0 !important;
  }

  ::v-deep .u-lg-padSidesNone {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  ::v-deep .u-lg-padTopNone {
    padding-top: 0 !important;
  }

  ::v-deep .u-lg-padBottomNone {
    padding-bottom: 0 !important;
  }

  ::v-deep .u-lg-padLeftNone {
    padding-left: 0 !important;
  }

  ::v-deep .u-lg-padRightNone {
    padding-right: 0 !important;
  }
}

/* stylelint-enable */

/**
 * @define utilities
 */

/**
 * Word breaking
 *
 * Break strings when their length exceeds the width of their container.
 */

::v-deep .u-textBreak {
  word-wrap: break-word !important;
}

/**
 * Horizontal text alignment
 */

::v-deep .u-textCenter {
  text-align: center !important;
}

::v-deep .u-textLeft {
  text-align: left !important;
}

::v-deep .u-textRight {
  text-align: right !important;
}

/**
 * Inherit the ancestor's text color.
 */

::v-deep .u-textInheritColor {
  color: inherit !important;
}

/**
 * Enables font kerning in all browsers.
 * http://blog.typekit.com/2014/02/05/kerning-on-the-web/
 *
 * 1. Chrome (not Windows), Firefox, IE 10+
 * 2. Safari 7 and future browsers
 * 3. Chrome (not Windows), Firefox, Safari 6+, iOS, Android
 */

::v-deep .u-textKern {
  -webkit-font-feature-settings: "kern" 1, "kern";
  font-feature-settings: "kern" 1, "kern";

  /* 1 */
  -webkit-font-kerning: normal;
  font-kerning: normal;

  /* 2 */
  text-rendering: optimizeLegibility;

  /* 3 */
}

/**
 * Prevent whitespace wrapping
 */

::v-deep .u-textNoWrap {
  white-space: nowrap !important;
}

/**
 * Text truncation
 *
 * Prevent text from wrapping onto multiple lines, and truncate with an
 * ellipsis.
 *
 * 1. Ensure that the node has a maximum width after which truncation can
 *    occur.
 * 2. Fix for IE 8/9 if `word-wrap: break-word` is in effect on ancestor
 *    nodes.
 */

::v-deep .u-textTruncate {
  max-width: 100%;

  /* 1 */
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  word-wrap: normal !important;

  /* 2 */
}

/**
 * Size and line-height
 */

/* stylelint-disable plugin/selector-bem-pattern */

::v-deep .u-textSize01 {
  font-size: 13.328px !important;
  font-size: 0.833rem !important;
}

::v-deep .u-textSize {
  font-size: 16px !important;
  font-size: 1rem !important;
}

::v-deep .u-lineHeight {
  line-height: 1 !important;
}

::v-deep .u-textSize1 {
  font-size: 19.2px !important;
  font-size: 1.2rem !important;
}

::v-deep .u-textSize2 {
  font-size: 23.04px !important;
  font-size: 1.44rem !important;
}

::v-deep .u-textSize3 {
  font-size: 27.648px !important;
  font-size: 1.728rem !important;
}

::v-deep .u-textSize4 {
  font-size: 33.184px !important;
  font-size: 2.074rem !important;
}

::v-deep .u-textSize5 {
  font-size: 39.808px !important;
  font-size: 2.488rem !important;
}

::v-deep .u-textSize6 {
  font-size: 47.776px !important;
  font-size: 2.986rem !important;
}

::v-deep .u-textShrink6 {
  font-size: 0.335em !important;
}

::v-deep .u-textShrink5 {
  font-size: 0.402em !important;
}

::v-deep .u-textShrink4 {
  font-size: 0.482em !important;
}

::v-deep .u-textShrink3 {
  font-size: 0.579em !important;
}

::v-deep .u-textShrink2 {
  font-size: 0.694em !important;
}

::v-deep .u-textShrink1 {
  font-size: 0.833em !important;
}

::v-deep .u-textShrink,
  ::v-deep .u .u-textGrow {
  font-size: 1em !important;
}

::v-deep .u-textGrow1 {
  font-size: 1.2em !important;
}

::v-deep .u-textGrow2 {
  font-size: 1.44em !important;
}

::v-deep .u-textGrow3 {
  font-size: 1.728em !important;
}

::v-deep .u-textGrow4 {
  font-size: 2.074em !important;
}

::v-deep .u-textGrow5 {
  font-size: 2.488em !important;
}

::v-deep .u-textGrow6 {
  font-size: 2.986em !important;
}

::v-deep .u-lineHeight1 {
  line-height: 1.2 !important;
}

::v-deep .u-lineHeight2 {
  line-height: 1.44 !important;
}

@media (min-width: 30em) {
  ::v-deep .u-sm-textSize01 {
    font-size: 0.833rem !important;
  }

  ::v-deep .u-sm-textSize {
    font-size: 1rem !important;
  }

  ::v-deep .u-sm-lineHeight {
    line-height: 1 !important;
  }

  ::v-deep .u-sm-textSize1 {
    font-size: 1.2rem !important;
  }

  ::v-deep .u-sm-textSize2 {
    font-size: 1.44rem !important;
  }

  ::v-deep .u-sm-textSize3 {
    font-size: 1.728rem !important;
  }

  ::v-deep .u-sm-textSize4 {
    font-size: 2.074rem !important;
  }

  ::v-deep .u-sm-textSize5 {
    font-size: 2.488rem !important;
  }

  ::v-deep .u-sm-textSize6 {
    font-size: 2.986rem !important;
  }

  ::v-deep .u-sm-textShrink6 {
    font-size: 0.335em !important;
  }

  ::v-deep .u-sm-textShrink5 {
    font-size: 0.402em !important;
  }

  ::v-deep .u-sm-textShrink4 {
    font-size: 0.482em !important;
  }

  ::v-deep .u-sm-textShrink3 {
    font-size: 0.579em !important;
  }

  ::v-deep .u-sm-textShrink2 {
    font-size: 0.694em !important;
  }

  ::v-deep .u-sm-textShrink1 {
    font-size: 0.833em !important;
  }

  ::v-deep .u-sm-textShrink,
  ::v-deep .u .u-sm-textGrow {
    font-size: 1em !important;
  }

  ::v-deep .u-sm-textGrow1 {
    font-size: 1.2em !important;
  }

  ::v-deep .u-sm-textGrow2 {
    font-size: 1.44em !important;
  }

  ::v-deep .u-sm-textGrow3 {
    font-size: 1.728em !important;
  }

  ::v-deep .u-sm-textGrow4 {
    font-size: 2.074em !important;
  }

  ::v-deep .u-sm-textGrow5 {
    font-size: 2.488em !important;
  }

  ::v-deep .u-sm-textGrow6 {
    font-size: 2.986em !important;
  }

  ::v-deep .u-sm-lineHeight1 {
    line-height: 1.2 !important;
  }

  ::v-deep .u-sm-lineHeight2 {
    line-height: 1.44 !important;
  }
}

@media (min-width: 47em) {
  ::v-deep .u-md-textSize01 {
    font-size: 0.833rem !important;
  }

  ::v-deep .u-md-textSize {
    font-size: 1rem !important;
  }

  ::v-deep .u-md-lineHeight {
    line-height: 1 !important;
  }

  ::v-deep .u-md-textSize1 {
    font-size: 1.2rem !important;
  }

  ::v-deep .u-md-textSize2 {
    font-size: 1.44rem !important;
  }

  ::v-deep .u-md-textSize3 {
    font-size: 1.728rem !important;
  }

  ::v-deep .u-md-textSize4 {
    font-size: 2.074rem !important;
  }

  ::v-deep .u-md-textSize5 {
    font-size: 2.488rem !important;
  }

  ::v-deep .u-md-textSize6 {
    font-size: 2.986rem !important;
  }

  ::v-deep .u-md-textShrink6 {
    font-size: 0.335em !important;
  }

  ::v-deep .u-md-textShrink5 {
    font-size: 0.402em !important;
  }

  ::v-deep .u-md-textShrink4 {
    font-size: 0.482em !important;
  }

  ::v-deep .u-md-textShrink3 {
    font-size: 0.579em !important;
  }

  ::v-deep .u-md-textShrink2 {
    font-size: 0.694em !important;
  }

  ::v-deep .u-md-textShrink1 {
    font-size: 0.833em !important;
  }

  ::v-deep .u-md-textShrink,
  ::v-deep .u .u-md-textGrow {
    font-size: 1em !important;
  }

  ::v-deep .u-md-textGrow1 {
    font-size: 1.2em !important;
  }

  ::v-deep .u-md-textGrow2 {
    font-size: 1.44em !important;
  }

  ::v-deep .u-md-textGrow3 {
    font-size: 1.728em !important;
  }

  ::v-deep .u-md-textGrow4 {
    font-size: 2.074em !important;
  }

  ::v-deep .u-md-textGrow5 {
    font-size: 2.488em !important;
  }

  ::v-deep .u-md-textGrow6 {
    font-size: 2.986em !important;
  }

  ::v-deep .u-md-lineHeight1 {
    line-height: 1.2 !important;
  }

  ::v-deep .u-md-lineHeight2 {
    line-height: 1.44 !important;
  }
}

@media (min-width: 64em) {
  ::v-deep .u-lg-textSize01 {
    font-size: 0.833rem !important;
  }

  ::v-deep .u-lg-textSize {
    font-size: 1rem !important;
  }

  ::v-deep .u-lg-lineHeight {
    line-height: 1 !important;
  }

  ::v-deep .u-lg-textSize1 {
    font-size: 1.2rem !important;
  }

  ::v-deep .u-lg-textSize2 {
    font-size: 1.44rem !important;
  }

  ::v-deep .u-lg-textSize3 {
    font-size: 1.728rem !important;
  }

  ::v-deep .u-lg-textSize4 {
    font-size: 2.074rem !important;
  }

  ::v-deep .u-lg-textSize5 {
    font-size: 2.488rem !important;
  }

  ::v-deep .u-lg-textSize6 {
    font-size: 2.986rem !important;
  }

  ::v-deep .u-lg-textShrink6 {
    font-size: 0.335em !important;
  }

  ::v-deep .u-lg-textShrink5 {
    font-size: 0.402em !important;
  }

  ::v-deep .u-lg-textShrink4 {
    font-size: 0.482em !important;
  }

  ::v-deep .u-lg-textShrink3 {
    font-size: 0.579em !important;
  }

  ::v-deep .u-lg-textShrink2 {
    font-size: 0.694em !important;
  }

  ::v-deep .u-lg-textShrink1 {
    font-size: 0.833em !important;
  }

  ::v-deep .u-lg-textShrink,
  ::v-deep .u .u-lg-textGrow {
    font-size: 1em !important;
  }

  ::v-deep .u-lg-textGrow1 {
    font-size: 1.2em !important;
  }

  ::v-deep .u-lg-textGrow2 {
    font-size: 1.44em !important;
  }

  ::v-deep .u-lg-textGrow3 {
    font-size: 1.728em !important;
  }

  ::v-deep .u-lg-textGrow4 {
    font-size: 2.074em !important;
  }

  ::v-deep .u-lg-textGrow5 {
    font-size: 2.488em !important;
  }

  ::v-deep .u-lg-textGrow6 {
    font-size: 2.986em !important;
  }

  ::v-deep .u-lg-lineHeight1 {
    line-height: 1.2 !important;
  }

  ::v-deep .u-lg-lineHeight2 {
    line-height: 1.44 !important;
  }
}

/* stylelint-enable */

/**
 * Color
 */

::v-deep .u-textBlack {
  color: #2c2a29 !important;
}

::v-deep .u-textGray {
  color: #63666a !important;
}

::v-deep .u-textLeonisa {
  color: #003865 !important;
}

::v-deep .u-textDarkPink {
  color: #af605b !important;
}

::v-deep .u-textWine {
  color: #641e35 !important;
}

::v-deep .u-textRed {
  color: #d73043 !important;
}

::v-deep .u-textGreen {
  color: #8ec549 !important;
}

::v-deep .u-textSeaGreen {
  color: #009ca6 !important;
}

/**
 * Note: The following text color utilities do not meet contrast guidelines,
 * they should only be used for presentational elements (such as iconography
 * or visual indicators) or against dark backgrounds with sufficient contrast.
 */

::v-deep .u-textWhite {
  color: #fff !important;
}

::v-deep .u-textSalmon {
  color: #db908c !important;
}

/**
 * Alignment
 */

@media (min-width: 30em) {
  ::v-deep .u-sm-textCenter {
    text-align: center !important;
  }

  ::v-deep .u-sm-textLeft {
    text-align: left !important;
  }

  ::v-deep .u-sm-textRight {
    text-align: right !important;
  }
}

@media (min-width: 47em) {
  ::v-deep .u-md-textCenter {
    text-align: center !important;
  }

  ::v-deep .u-md-textLeft {
    text-align: left !important;
  }

  ::v-deep .u-md-textRight {
    text-align: right !important;
  }
}

@media (min-width: 64em) {
  ::v-deep .u-lg-textCenter {
    text-align: center !important;
  }

  ::v-deep .u-lg-textLeft {
    text-align: left !important;
  }

  ::v-deep .u-lg-textRight {
    text-align: right !important;
  }
}

/**
 * Weight
 */

::v-deep .u-textNormal {
  font-weight: 400 !important;
}

::v-deep .u-textSemibold {
  font-weight: 500 !important;
}

::v-deep .u-textBold {
  font-weight: 700 !important;
}

/**
 * Case
 */

::v-deep .u-textCapitalize {
  text-transform: capitalize !important;
}

::v-deep .u-textUpper {
  text-transform: uppercase !important;
}

/*
 * Font
 */

::v-deep .u-textSerif {
  font-stretch: normal;
  font-style: normal;
  font-weight: 100;
  font-family: serif;
}

::v-deep .fonts-loaded .u-textSerif {
  font-family: Canela Web;
}

/*
 * Spacing
 */

::v-deep .u-textSpacingLoose {
  letter-spacing: 0.15em !important;
}
</style>
